import axios from 'axios';
import Config from '../config'
import LZString from "lz-string";

const Apiurl = Config.apiUrl
const QTurl = Config.qtUrl
const DPVurl = Config.dpvUrl
const decorURL = Config.decorURL
const deliveryUrl = Config.deliveryUrl
const Metaurl = Config.metaUrl

let experienceCentersCache = null;
let cacheTimestamp = null;
const cacheLifetime = 60 * 60 * 1000; // Cache lifetime in milliseconds (1 hour)
const TrackingURL = "https://ftt.decorpot.com/api/packaging";
const snagURL =  "https://ops.decorpot.com/api/snag";
// const snagURL =  "http://localhost:5004/api/snag";


const HttpService = {


      getSnagReport() {
    return axios.get(`${snagURL}/findMySnags`);
    },

  getProjectLogs(params) {
        return axios.get(`${snagURL}/getProjectLogs`, { params });
    },
    findCityWiseSnag(data) {
        const params = new URLSearchParams();

        if (data.cityName) {
        params.append('cityName', data.cityName);
        }

        if (data.agingBucket) {
        params.append('agingBucket', data.agingBucket);
        }

        const queryString = params.toString();
        const url = queryString 
        ? `${snagURL}/findCityWiseSnag?${queryString}` 
        : `${snagURL}/findCityWiseSnag`;

        return axios.get(url);
    },
    login: function (data) {
        return axios.post(`${Apiurl}user/login`, data);
    },
    getMetaLeads: function ({ page = 1, limit = 50, hours, startDate, endDate, platform, status, all } = {}) {
        const params = new URLSearchParams();
        params.set('page', String(page));
        params.set('limit', String(limit));
        if (all) params.set('all', 'true');
        if (hours != null && hours !== '') params.set('hours', String(hours));
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if (platform) params.set('platform', platform);
        if (status) params.set('status', status);
        return axios.get(`${Metaurl}meta/leads?${params.toString()}`);
    },
    getMetaLeadPhone: function (leadgenId) {
        return axios.get(`${Metaurl}meta/leads/${leadgenId}/phone`);
    },
    recoverMetaMissedLeads: function ({ hours = 24, limitPerForm = 500, retryLimit = 100 } = {}) {
        return axios.post(`${Metaurl}meta/recover-missed`, { hours, limitPerForm, retryLimit });
    },
    downloadProjectWiseReports : function(payload) {
        return axios.post(`${TrackingURL}/getPannelDetails`, payload);
    },
    getFaqCategories : function () {
        return axios.get(`${QTurl}call_center/getFaqCategories`);
    },
    getProjectWiseSticker: function (data) {
        return axios.post(`${QTurl}project/getAllStickerDetails`, data);
    },
    generateSticker: function (data) {
        return axios.post(`${QTurl}project/generateSticker`, data);
    },
    faqDetails : function (data) {
        return axios.put(`${QTurl}call_center/faqDetails`,data);
    },
    updateCallCenterLead : function (data) {
        return axios.put(`${QTurl}call_center/update_call_center_lead`,data);
    },
    sendCallCenterLeadToManager : function (data) {
        return axios.put(`${QTurl}call_center/send_call_center_lead_to_manager`,data);
    },
    getFollowUpSelfData : function () {
        return axios.get(`${QTurl}call_center/get_follow_up_self_data`);
    },
    getFollowUpSelfForTeamData : function () {
        return axios.get(`${QTurl}call_center/get_follow_up_self_for_team_data`);
    },
    getCallCenterDashboardData : function () {
        return axios.get(`${QTurl}call_center/get_call_center_dashboard_data`);
    },
    getCallCenterUsersForAM : function () {
        return axios.get(`${QTurl}call_center/get_call_center_users_for_AM`);
    },
    getCallCenterJunkLeads : function () {
        return axios.get(`${QTurl}call_center/get_call_center_junk_leads`);
    },
    getFilteredCallCenterDashboardData : function (data) {
        return axios.put(`${QTurl}call_center/get_filtered_call_center_dashboard_data`, data);
    },
    ReAssignCallCenterUser : function (data) {
        return axios.put(`${QTurl}call_center/re_assign_call_center_user`,data);
    },
    approve_call_center_junk_lead : function (data) {
        return axios.put(`${QTurl}call_center/approve_call_center_junk_lead`,data);
    },
    get_pending_approval_for_cc_am : function () {
        return axios.get(`${QTurl}call_center/get_pending_approval_for_cc_am`);
    },
    verifyLead : function (data) {
        return axios.put(`${QTurl}call_center/verify_lead`,data);
    },
    verify_call_center_ticket: function(data){
        return axios.put(`${QTurl}call_center/verify_call_center_ticket`, data)
    },
    agentStatus : function () {
        return axios.get(`${QTurl}call_center/agent_status`);
    },
    createFaq : function (data) {
        return axios.post(`${QTurl}call_center/createFaq`,data);
    },
    createCategories : function (data) {
        return axios.post(`${QTurl}call_center/createFaqCategories`, data);
    },
    makeCall : function (data) {
        return axios.post(`${QTurl}call_center/make_call`, data)
    },
    getCallDetails : function(data){
        return axios.get(`${QTurl}call_center/get_call_details?customer_number=${data.client_phone_number}`);
    },
    
    submitVendorForm : function (data){
        return axios.post(`${QTurl}chmTicketForWhatsApp/new`, data);  
    },
    submitJobRelatedForm : function (data){
        return axios.post(`${QTurl}chmTicketForWhatsApp/jobRelatedTicket`, data);  
    },
    submitIssueForm : function (data){
        return axios.post(`${QTurl}chmTicketForWhatsApp/serviceRelatedTicket`, data);  
    },
    getUserForWhatsAppMessage : function (){
        return axios.get(`${QTurl}chmTicketForWhatsApp/usersForMessage`);  
    },
    getDataBasedClickOverallSummaryForDynamicDetails: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickOverallSummaryForDynamicDetails`, data)
    },
    dynamicGroupingUserWise : function (data){
        return axios.post(`${QTurl}dynamicGroupingUserWise/addGroup`, data);  
    },
    dynamicGroupDetails : function (){
        return axios.get(`${QTurl}dynamicGroupingUserWise/getGroupDetails`);  
    },
    dynamicDeleteGroup: function (groupId, mainId) {
        return axios.put(`${QTurl}dynamicGroupingUserWise/deleteGroup`, { groupId, mainId });
    }, 
    overallSummaryDashBoardGroupWise: function (data) {
        return axios.get(`${QTurl}leadJourney/overall?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}&groupId=${data.groupId}`)
    },
    updateLeadCriteria : function (data) {
        return axios.put(`${QTurl}lead/updateLeadCriteria`, data)
    },
    removeCriteria:  function (data) {
        return axios.put(`${QTurl}lead/removeCriteria`, data)
    },
    getNewlyCreatedQuotation: function (id){
        return axios.get(`${QTurl}customer/getNewlyCreatedQuotation/${id}`)
    },
    updateSalesQuotation: function (data){
        return axios.put(`${QTurl}lead/updateSalesQuotation`,data);
    },
    updateDesignQuotation :function (data){
        return axios.put(`${QTurl}lead/updateDesignQuotation`,data);
    },
    latestQuotation: function (data){
        return axios.post(`${QTurl}lead/updateLatestQuotation`,data);
    },
    getQuotationDownloadLogs : function (id){
        return axios.get(`${QTurl}lead/getQuotationDownloadLogs/${id}`)
    },
    changePasswords : function (data){
        return axios.put(`${QTurl}customer/changePassword`, data)
    },
    userLogin: function(data){
        return axios.post(`${QTurl}customer/customer-login`,data);
    },
    createNewCustomer : function (data) {
        return axios.post(`${QTurl}lead/create-customer`,data);
    },
    getLeadCriteria : function (){
        return axios.get(`${QTurl}lead/getLeadCriteria`);
    },
    handleCustomerLogout : function(id){
        return axios.post(`${QTurl}customer/customer-logout/${id}`);
    },
    getcustomerSessionsData : function(page,rowsPerPage){
        return axios.get(`${QTurl}customerSession/getcustomerSessionsData?page=${page}&limit=${rowsPerPage}`);
    },
    getErpUserSessionsData : function(page,rowsPerPage,deviceType,source,appUsage,departmentId){
        const deviceTypeQuery = deviceType ? `&deviceType=${deviceType}` : '';
        const sourceQuery = source ? `&source=${source}` : '';
        const appUsageQuery = appUsage ? `&appUsage=${appUsage}` : '';
        const departmentIdQuery = departmentId ? `&departmentId=${departmentId}` : '';
        return axios.get(`${QTurl}erpUserSession/getErpUserSessionsData?page=${page}&limit=${rowsPerPage}${deviceTypeQuery}${sourceQuery}${appUsageQuery}${departmentIdQuery}`);
    },
    // --- Admin: Cache & Session Management (quotation_tool_server/routes/cacheControl.js) ---
    // How many users a target selection matches, plus a small sample, before anything is written.
    previewCacheClear: function (payload) {
        return axios.post(`${QTurl}cacheControl/preview`, payload);
    },
    // Writes the clear directive to every targeted user. Admin only.
    triggerCacheClear: function (payload) {
        return axios.post(`${QTurl}cacheControl/clear`, payload);
    },
    // Polled by the sidebar every 60s. The user id comes from the token, not from a parameter.
    getPendingCacheDirective: function () {
        return axios.get(`${QTurl}cacheControl/pending`);
    },
    // Called immediately BEFORE the browser wipes itself, so a failed wipe cannot loop.
    ackCacheDirective: function (requestId, legacy) {
        return axios.post(`${QTurl}cacheControl/ack`, { requestId, legacy: !!legacy });
    },
    getCacheClearHistory: function (page, limit) {
        return axios.get(`${QTurl}cacheControl/history?page=${page}&limit=${limit}`);
    },
    cancelCacheClear: function (logId) {
        return axios.post(`${QTurl}cacheControl/cancel/${logId}`);
    },
    getCacheClearTargets: function () {
        return axios.get(`${QTurl}cacheControl/targets`);
    },
    getChmManager: function(){
        return axios.get(`${QTurl}customer/getChmManager`)
    },
    getCustomerDetails: function(id){
        return axios.get(`${QTurl}customer/getcustomer/${id}`)
    },
    viewCustomerContact: function (customerId, leadId) {
        const params = leadId ? `?leadId=${leadId}` : '';
        return axios.get(`${QTurl}customer/view-contact/${customerId}${params}`);
    },
    getCustomerNewDetails:function(id){
        return axios.get(`${QTurl}customer/customer-otherpayment/${id}`)
    },
    getApprovedPaymentReceivedForLead : function(data) {
        return axios.put(`${QTurl}query/getApprovedPaymentReceivedForLead`, data)
    },
    getCustomerLogs: function(id){
        return axios.get(`${QTurl}customer/getcustomelogs/${id}`)
    },
    updateCustomerImage: function(data){
    return axios.put(`${QTurl}customer/update-customer`,data)
    },
    getCustomerQuotation: function(id){
        return axios.get(`${QTurl}customer/getcustomer-quotation/${id}`)
    },
    getAssignedUser: function(id){
        return axios.get(`${QTurl}customer/customer-assingusers/${id}`)

    },
    getCustomerPaymentAttachments: function(id){
        return axios.get(`${QTurl}customer/customerpayments/${id}`)
    },
    getCustomerData: function(){
        return axios.get(`${QTurl}customer/customer-details`)
    },
    forgotPassword: function (email) {
        return axios.put(`${Apiurl}user/forgotPassword`, email)
    },
    forgotCustomerPassword:function (email) {
        return axios.put(`${QTurl}customer/forgotPassword`, email)
    },
    getpaymentPatners: function () {
        return axios.get(`${QTurl}paymentPatners/getpaymentPatners`)
    },
    getPaymentPreview : function (id) {
        return axios.get(`${QTurl}paymentTransactions/getLeadWiseTransactionData/${id}`)
    },
    getPaymentAllPreview : function(data) {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.get(`${QTurl}paymentTransactions/getAllTransactionData?startDate=${data.startDate}&endDate=${data.endDate}&selectStage=${encodeURIComponent(data.selectedPaymentSearch.toString())}&searchCustomerName=${data.searchCustomerName}&page=${data.page}&rowsPerPage=${data.rowsPerPage}`)
    },
    getProjectExcelFile: function (project, data) {
        return axios.put(`${Apiurl}project/getProjectExcelFile/${project._id}?project_name=${project.searchName}`, data);
    },
    getAllManualTransactionsForApproval : function(data) {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.get(`${QTurl}paymentTransactions/getAllManualTransactionsForApproval?startDate=${data.startDate}&endDate=${data.endDate}&selectStage=${encodeURIComponent(data.selectedPaymentSearch.toString())}&searchCustomerName=${data.searchCustomerName}&page=${data.page}&rowsPerPage=${data.rowsPerPage}&selectedPaymentMode=${data.selectedPaymentMode}`)
    },
    getPaymentLogsOfLead: function(data)
    {
        return axios.put(`${QTurl}paymentLogs/getPaymentLogsOfLead`, data)
    },
    getPaymentLogsOfMultipleLeads: function(data)
    {
        return axios.put(`${QTurl}paymentLogs/getPaymentLogsOfMultipleLeads`, data)
    },
    getPaymentLogsOfMultipleLeadsForManualPayments: function(data)
    {
        return axios.put(`${QTurl}paymentLogs/getPaymentLogsOfMultipleLeadsForManualPayments`, data)
    },
    getApprovedPaymentTransactions : function() {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.get(`${QTurl}paymentTransactions/getApprovedPaymentTransactions`)
    },
    getApprovedPaymentTransactionsFiltered : function(data) {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.put(`${QTurl}paymentTransactions/getApprovedPaymentTransactionsFiltered`, data)
    },

    getCsvFileForCustomerInfo : function(data) {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.put(`${QTurl}paymentTransactions/getCsvFileForCustomerInfo`, data)
    },
    getApprovedPaymentTransactionsFilteredBySearch : function(data) {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.put(`${QTurl}paymentTransactions/getApprovedPaymentTransactionsFilteredBySearch`, data)
    },
    getApprovedPaymentTransactionsForLead : function(data) {
        // console.log(data,"data is callllllednjknnknkbkb")
        return axios.put(`${QTurl}paymentTransactions/getApprovedPaymentTransactionsForLead`, data)
    },
    getSalesDesignStages : function () {
    // getSalesDesignStages: function () {
        return axios.get(`${QTurl}paymentPatners/salesDesignStage`)
    },
    changePassword: function (data) {
        return axios.put(`${Apiurl}user/changePassword`, data)
    },
    changePasswordBeforeLogin: function (data) {

        return axios.put(`${Apiurl}user/changePasswordBeforeLogin`, data)
        
    },
    getAsideItems: function () {
        return axios.get(`${Apiurl}user/getLeftAside`)
    },
    getApprovedProjects: function () {
        return axios.get(`${Apiurl}finance/approved-projects`);
    },
    getUserAccessDeatails:function (id, selectedData){
        return axios.get(`${Apiurl}userAccess/userAccessDeatails/${id}?data=${selectedData}`);
    },
    addMainMenuNavigation:function (data){
        return axios.put(`${Apiurl}userAccess/addMainMenuItems`,data);
    },
    addSubMenuNavigation:function (data){
        return axios.put(`${Apiurl}userAccess/addSubMenuNavigation`,data);
    },
    getUserNavDeatails:function (id){
        return axios.get(`${Apiurl}userAccess/userNavDeatails/${id}`);
    },
    updateUserAccessDeatails :function (userAccess){
        return axios.put(`${Apiurl}userAccess/updateUserAccess`,userAccess);
    },
    getProjectsScopedData: function (data) {
        return axios.get(`${Apiurl}project/get-project-scope/${data}`);
    },
    getProjectsExcelFile: function (data,dateObj) {
        if(dateObj){
            return axios.put(`${Apiurl}project/getProjectsExcelFile/?startDate=${dateObj.startDate}&endDate=${dateObj.endDate}`, data);
        }
        else{
            return axios.put(`${Apiurl}project/getProjectsExcelFile`, data);
        }
    },
    // Getting Excel File for multiple projects from companyP&L dashboard
    getProjectsExcelFile: function (data) {
            return axios.put(`${Apiurl}project/getProjectsExcelFile`, data);
    },
    getProjectScopedProducts: function (projectId, scope) {
        return axios.get(`${Apiurl}project/scoped-materials/${projectId}?scope=${scope}`)
    },
    getProcurementsOfProjectByScope: function (projectId, scopeName) {
        return axios.get(`${Apiurl}procurement/getProcurementsOfProject/${projectId}?scope=${scopeName}`)
    },
    getServiceOrderOfProjectScope: function (projectId, scopeName) {
        if(projectId && scopeName) 
            return axios.get(`${Apiurl}serviceOrder/getServiceOrdersOfProject/${projectId}?scope=${scopeName}`)

        return axios.get(`${Apiurl}serviceOrder/getServiceOrdersOfProject/${"getAll"}`)
    },

    getBomOfProjectScope: function (projectId, scopeName, type) {
        return axios.get(`${Apiurl}project-material/bom-materials/${projectId}?scope=${scopeName}&type=${type}`)
    },
    getAllProjectsBomMaterials: function () {
        return axios.get(`${Apiurl}project-material/projects`)
    },
    getProcurementDetails: function (procurementId) {
        return axios.get(`${Apiurl}procurement/getProcurementById/${procurementId}`)
    },
    getServiceOrderDetails: function (serviceOrderId) {
        return axios.get(`${Apiurl}serviceOrder/getServiceOrderByOrderId/${serviceOrderId}`)
    },
    getServiceOrderDetailsById: function (serviceOrderId) {
        return axios.get(`${Apiurl}serviceOrder/getServiceOrderById/${serviceOrderId}`)
    },
    deleteSoByOrderId: function (serviceOrderId) {
        return axios.delete(`${Apiurl}serviceOrder/deleteSoByOrderId/${serviceOrderId}`)
    },
    getAllUnits: function () {
        return axios.get(`${Apiurl}unit`)
    },
    fetchUnits: function () {
        return axios.get(`${QTurl}unitTypeMaster/all`)
    },
    // In-app notifications (inventoryapi). Sending is tech-team only and the
    // server enforces that; reading is always scoped to the signed-in user.
    // departments narrow the role list; cities narrow the experience centres.
    getNotificationAudienceOptions: function (scope = {}) {
        const q = new URLSearchParams();
        if (scope.departments && scope.departments.length) q.set('departments', scope.departments.join(','));
        if (scope.cities && scope.cities.length) q.set('cities', scope.cities.join(','));
        const qs = q.toString();
        return axios.get(`${Apiurl}notification/audience-options${qs ? `?${qs}` : ''}`)
    },
    previewNotificationAudience: function (audience) {
        return axios.post(`${Apiurl}notification/preview`, { audience })
    },
    sendNotification: function (data) {
        return axios.post(`${Apiurl}notification`, data)
    },
    // multipart, field name "file". Returns { attachment: { name, url, size, mimeType } }.
    uploadNotificationAttachment: function (formData) {
        return axios.post(`${Apiurl}notification/attachment`, formData)
    },
    // Filters are optional; the Excel export reuses this with a higher limit so
    // the file always matches exactly what is on screen.
    getSentNotifications: function (params = {}) {
        const q = new URLSearchParams();
        q.set('limit', params.limit || 50);
        if (params.skip) q.set('skip', params.skip);
        if (params.categoryId) q.set('categoryId', params.categoryId);
        if (params.from) q.set('from', params.from);
        if (params.to) q.set('to', params.to);
        return axios.get(`${Apiurl}notification/sent?${q.toString()}`)
    },
    // all=1 includes the deactivated ones, for the Manage dialog only.
    getNotificationCategories: function (opts = {}) {
        return axios.get(`${Apiurl}notification/categories${opts.all ? '?all=1' : ''}`)
    },
    createNotificationCategory: function (data) {
        return axios.post(`${Apiurl}notification/categories`, data)
    },
    updateNotificationCategory: function (id, data) {
        return axios.put(`${Apiurl}notification/categories/${id}`, data)
    },
    setNotificationCategoryActive: function (id, isActive) {
        return axios.put(`${Apiurl}notification/categories/${id}/active`, { isActive })
    },
    // The bell passes a number and keeps its old behaviour; the My
    // Notifications page passes the filter object.
    getMyNotifications: function (arg) {
        if (typeof arg === 'object' && arg !== null) {
            const q = new URLSearchParams();
            q.set('limit', arg.limit || 20);
            if (arg.skip) q.set('skip', arg.skip);
            if (arg.status && arg.status !== 'all') q.set('status', arg.status);
            if (arg.categoryId) q.set('categoryId', arg.categoryId);
            if (arg.from) q.set('from', arg.from);
            if (arg.to) q.set('to', arg.to);
            return axios.get(`${Apiurl}notification/mine?${q.toString()}`)
        }
        return axios.get(`${Apiurl}notification/mine?limit=${arg || 20}`)
    },
    markNotificationRead: function (recipientId) {
        return axios.put(`${Apiurl}notification/${recipientId}/read`)
    },
    markAllNotificationsRead: function () {
        return axios.put(`${Apiurl}notification/read-all`)
    },
    getAllVendors: function () {
        return axios.get(`${Apiurl}vendor/getVendors`)
    },
    getVendorPoById: function (vendorId) {
        return axios.get(`${Apiurl}procurement/vendorPoById/${vendorId}`)
    },
    getVendorSoById: function (vendorId) {
        return axios.get(`${Apiurl}serviceOrder/vendorSoById/${vendorId}`)
    },
    getVendorsForApproval: function () {
        return axios.get(`${Apiurl}vendor/getVendorsForApproval`)
    },
    editVendorStatus: function (id, status) {
        return axios.put(`${Apiurl}vendor/editVendorStatus/${id}`, status)
    },
    getVendorMaterialMappingForApproval: function () {
        return axios.get(`${Apiurl}vendor/getVendorMaterialMappingForApproval`)
    },
    editVendorMaterialstatus: function (id, status) {
        return axios.put(`${Apiurl}vendor/editVendorMaterialstatus/${id}`, status)
    },
    getAllMaterialsNames: function () {
        return axios.get(`${Apiurl}materialMaster/materialNames/all`)
    },
    getProcurementsForApprovalByProject: function (projectId, scopeId) {
        return axios.get(`${Apiurl}procurement/getProcurementsForApprovalByProject/${projectId}?scopeId=${scopeId}`)
    },
    getServiceOrdersForApprovalByProject: function (projectId, scopeId) {
        return axios.get(`${Apiurl}serviceOrder/getServiceOrdersForApprovalByProject/${projectId}?scopeId=${scopeId}`)
    },
    generateSO: function (SoId) {
        return axios.get(`${Apiurl}serviceOrder/generateSo/${SoId}`)
    },
    generateMaskedSo: function (SoId) {
        return axios.get(`${Apiurl}serviceOrder/generateMaskedSo/${SoId}`)
    },
    getApprovedPoForPayment: function (projectId, scopeId) {
        return axios.get(`${Apiurl}procurement/procurement/${projectId}?scopeId=${scopeId}`)
    },
    getApprovedSoForPayment: function (projectId, scopeId) {
        return axios.get(`${Apiurl}serviceOrder/service-order/${projectId}?scopeId=${scopeId}`)
    },
    getPaymentRequestForPo: function (projectId, scopeId) {
        return axios.get(`${Apiurl}procurement/payment-request/${projectId}?scopeId=${scopeId}`)
    },
    getPaymentRequestForSo: function (projectId, scopeId) {
        return axios.get(`${Apiurl}serviceOrder/payment-request/${projectId}?scopeId=${scopeId}`)
    },
    getAllPaymentRequestForSo: function () {
        return axios.get(`${Apiurl}serviceOrder/payment-request`)
    },
    getProjectProductByScopeForSo: function (projectId, scopeId) {
        return axios.get(`${Apiurl}projectProducts/projectProductByScope/${projectId}?scopeId=${scopeId}`)
    },
    createServiceOrderFromBomMaterials: function (SO, scope) {
        return axios.post(`${Apiurl}serviceOrder/create-service-order-from-bom?scope=${scope}`, SO)
    },
    createPurchaseOrder: function (PO) {
        return axios.post(`${Apiurl}procurement/createOpenProcurement`, PO)
    },
    editServiceOrderStatus: function (soId, body) {
        return axios.put(`${Apiurl}finance/editServiceOrderStatus/${soId}`, body)
    },
    raiseSOPaymentRequest: function (soId, amount, scopeName) {
        return axios.post(`${Apiurl}serviceOrder/payment-request/${soId}?scope=${scopeName}`, amount)
    },
     raiseSoGstPaymentRequest: function (soId, obj, scopeName) {
        return axios.post(`${Apiurl}serviceOrder/gst-payment-request/${soId}?scope=${scopeName}`, obj)
    },
    getSoGstPaymentHistoryBySo: function (soNumber) {
        return axios.get(`${Apiurl}serviceOrder/gst-payment-history-by-so?soNumber=${soNumber}`)
    },
    getSoGstPaymentApproverRequest: function (status, page = 1, limit = 200) {
        return axios.get(`${Apiurl}serviceOrder/gst-payment-approver-request`, {
            params: { ...(status ? { status } : {}), page, limit }
        })
    },
    approveRejectSoGstPaymentRequest: function (paymentId, data) {
        return axios.put(`${Apiurl}serviceOrder/gst-payment-approver-request/${paymentId}`, data)
    },
    soPaymentCompltedRequest: function (soId, obj, scopeName) {
        return axios.post(`${Apiurl}serviceOrder/payment-completed/${soId}?scope=${scopeName}`, obj)
    },
    raisePOPaymentRequest: function (poId, amount, scopeName) {
        if (scopeName)
            return axios.post(`${Apiurl}procurement/payment-request/${poId}?scope=${scopeName}`, amount)
        return axios.post(`${Apiurl}procurement/payment-request/${poId}`, amount)
    },
    raisePOPaymentCompleted: function (poId, obj, scopeName) {
        if (scopeName)
            return axios.post(`${Apiurl}procurement/payment-completed/${poId}?scope=${scopeName}`, obj)
        return axios.post(`${Apiurl}procurement/payment-completed/${poId}`, obj)
    },
    editServiceOrderPaymentStatus: function (paymentId, data) {
        return axios.put(`${Apiurl}serviceOrder/payment-request/${paymentId}`, data)
    },
    approvereditServiceOrderPaymentStatus: function (paymentId, data) {
        return axios.put(`${Apiurl}serviceOrder/payment-approver-request/${paymentId}`, data)
    },
    getAllRooms: function () { //ajit
        return axios.get(`${Apiurl}space-names`)
    },
    getAllScopes: function () {
        return axios.get(`${Apiurl}scoping/getScopes`)
    },
    fetchScopeMaster: function () {
        return axios.get(`${QTurl}scopeMaster/all`)
    },
    getAllSubCategory: function () {
        return axios.get(`${Apiurl}sub-category/sub-category/all`)
    },
    getSelectedScopeSubCategory: function (scopeId) {
        return axios.get(`${Apiurl}sub-category/${scopeId}`)
    },
    getSelectedSubCategoryMaterial: function (subCatId) {
        return axios.get(`${Apiurl}materialMaster/${subCatId}`)
    },
    createProjectMaterialFromBom: function (projectId, projectMaterial) {
        return axios.put(`${Apiurl}project-material/${projectId}`, projectMaterial)
    },
    getSavedProjectMaterialForBom: function (projectId, bomType, includeSaved) {
        const params = []
        if (bomType) params.push(`bomType=${encodeURIComponent(bomType)}`)
        if (includeSaved) params.push(`includeSaved=true`)
        const query = params.length ? `?${params.join("&")}` : ""
        return axios.get(`${Apiurl}project-material/bom/${projectId}${query}`)
    },
    uploadBomData: function (projectId, bomdata) {
        return axios.post(`${Apiurl}project-material/${projectId}`, bomdata)
    },
    sendMailToItTeam: function(mailData) {
        return axios.post(`${Apiurl}project-material/sendEmail/forMissingMaterial`, mailData)
    },
    uploadModularBomData: function (projectId, bomdata) {
        return axios.post(`${Apiurl}project-material/modularBom/${projectId}`, bomdata)
    },
    uploadSnagBomData: function (projectId, bomdata) {
        return axios.post(`${Apiurl}project-material/snagBom/${projectId}`, bomdata)
    },
    checkImosStatus: function(projectId) {
        return axios.get(`${Apiurl}project-material/check-bom-status/${projectId}`)
    },
    editBomStatus: function (projectId, status) {
        return axios.put(`${Apiurl}project-material/edit-status/${projectId}`, status)
    },
    getProjectDocuments: function (projectId) {
        return axios.get(`${Apiurl}project/getProjectDoc/${projectId}`)
    },
    productDocumentUpload: function (data) {
        return axios.post(`${Apiurl}fileUpload/productDocumentUpload`, data)
    },
    getProductDocAndCreateProject: function (data) {
        return axios.post(`${Apiurl}fileUpload/getProductDocAndCreateProject`, data)
    },
    uploadVendorDocs: function (data) {
        return axios.post(`${QTurl}file/upload?type=vendorDocs`, data)
    },
    UploadVirtualPayments: function (data) {
        return axios.post(`${QTurl}virtualPayments/UploadVirtualPayments`, data)
    },
    getVirtualPaymentsData: function (data) {
        return axios.get(`${QTurl}virtualPayments/getAllPayments?startDate=${data.startDate}&endDate=${data.endDate}&searchQuery=${data.searchQuery}`);
    },
    uploadDesignKickOffDocs: function (data) {
        return axios.post(`${QTurl}file/upload?type=designKickOffDocs`, data);
    },
    getAllProjects: function () {
        return axios.get(`${Apiurl}project/getProjects`)
    },
    mandatoryDocumentsUpload: function (data) {
        return axios.post(`${Apiurl}fileUpload/mandatoryDocumentsUpload`, data)
    },
    getProjectDocumentsForDesign: function () {
        return axios.get(`${Apiurl}project/getProjectsForDesign`)
    },
    sendToFinanceForApproval: function (projectId, data) {
        return axios.put(`${Apiurl}design/sendToFinanceForApproval/${projectId}`, data)
    },
    sendToSiteQcForApproval: function (projectId, data) {
        return axios.put(`${Apiurl}design/sendToSiteQcForApproval/${projectId}`, data)
    },
    deleteProjectDocument: function (docId) {
        return axios.delete(`${Apiurl}projectDocument/deleteDocument/${docId}`)
    },
    getAllProjectForApproval: function () {
        return axios.get(`${Apiurl}finance/getAllProjectForApproval`)
    },
    opsOneTableData:function(obj){        
        return axios.get(`${QTurl}lead/opsTableData?startDate=${obj.startDate}&endDate=${obj.endDate}`)
    },
    getProjectForApproval: function (projectId) {
        return axios.get(`${Apiurl}finance/getProjectForApproval/${projectId}`)
    },
    sendToDesign: function (projectId, data) {
        return axios.put(`${Apiurl}finance/sendBackToDesign/${projectId}`, data)
    },
    approveProject: function (projectId, data) {
        return axios.put(`${Apiurl}finance/approveProject/${projectId}`, data)
    },
    getFilteredProjects: function () {
        return axios.get(`${Apiurl}project/getFilteredProjects?status=Scoping`)
    },
    getFilteredProjectsList: function (status, expCenter) {
        return axios.get(`${Apiurl}project/getFilteredProjects?status=${status}&expCenter=${expCenter}`)
    },
    getIMOSProjects: function (expCenter) {
        return axios.get(`${QTurl}imosProjects?expCenter=${expCenter}`)
    },
    getSBOMProjects: function (expCenter,userId) {
        return axios.get(`${QTurl}siteBomProject/${userId}?expCenter=${expCenter}`)
    },
    getFactoryBomProjects: function (userId, expCenter) {
        return axios.get(`${QTurl}lead/getFactoryBomProjects/${userId}?expCenter=${expCenter}`)
    },
    getImosCompletedProject: function (expCenter) {
        return axios.get(`${QTurl}imosProjects/completedProjects?expCenter=${expCenter}`)
    },
    getProjectsMaterialsList: function (data) {
        return axios.get(`${Apiurl}project/getBomApprovedProject/${data.projectId}`)
    },
    updateMaterialReceivedStatus: function (orderId, data) {
        return axios.put(`${Apiurl}project/updateMaterialReceivedStatus/${orderId}`, data)
    },
    sendFinalEmailToCustomer: function (data) {
        return axios.post(`${QTurl}lead/sendFinalEmailToCustomer`, data)
    },
    updateStatusMaterialDispatched: function (data) {
        return axios.post(`${QTurl}lead/updateStatusMaterialDispatched`, data)
    },
    updateStatusUnderExecution: function (data) {
        return axios.post(`${QTurl}lead/updateStatusUnderExecution`, data)
    },
    sendForCityManagerApproval: function (data) {
        return axios.put(`${QTurl}lead/sendForCityManagerApproval`, data)
    },
    getExecutionApprovals() {
        return axios.get(`${QTurl}lead/executionApprovals`)
    },
    approveExecution(data) {
        return axios.put(`${QTurl}lead/approveExecution`, data)
    },
    rejectExecution(data) {
        return axios.put(`${QTurl}lead/rejectExecution`, data)
    },
    updateStatusFromUnderExecutionTo: function (data) {
        return axios.post(`${QTurl}lead/updateStatusFromUnderExecutionTo`, data)
    },
    updateCustomerPaymentAndSendToFinance: function (leadId, data) {
        return axios.put(`${QTurl}lead/updateCustomerPaymentAndSendToFinance/${leadId}`, data)
    },
    changeErpProjectNo: function (erpProjectNo, newErpProjectNo, leadId, autoGenerated = false) {
        return axios.put(`${QTurl}lead/changeErpProjectNo/${erpProjectNo}?newErpProjectNo=${newErpProjectNo}&leadId=${leadId}${autoGenerated ? '&autoGenerated=true' : ''}`)
    },
    getProjectProducts: function (projectId, scopeId) {
        if (scopeId !== undefined)
            return axios.get(`${Apiurl}scoping/getProjectProducts/${projectId}?scopeId=${scopeId}`)
        return axios.get(`${Apiurl}scoping/getProjectProducts/${projectId}`)
    },
    deleteProjectProduct: function (productId) {
        return axios.delete(`${Apiurl}projectProducts/deleteProduct?prodId=${productId}`)
    },
    addProductToProject: function (data) {
        return axios.post(`${Apiurl}scoping/addProductToProject`, data)
    },
    getAllProducts: function () {
        return axios.get(`${Apiurl}productMaster/getAllProducts`)
    },
    getServicesComponent: function () { //ajit
        return axios.get(`${Apiurl}productMaster/services`)
    },
    editCategoryPositionPriority: function (data) {
        return axios.put(`${QTurl}projectComponent/changePriority`, data)
    },
    getFinish: function () { //ajit
        return axios.get(`${QTurl}finishTypeMaster/all`)
    },
    editProjectProduct: function (productId, data) {
        return axios.put(`${Apiurl}scoping/editProjectProduct/${productId}`, data)
    },
    createProcurementForProject: function (data) {
        return axios.post(`${Apiurl}procurement/createProcurementForProject`, data)
    },
    approveProcurement: function (procurementId, data) {
        return axios.put(`${Apiurl}procurement/approveProcurement/${procurementId}`, data)
    },
    approveProcurementByOperationHead: function (procurementId, data) {
            return axios.put(`${Apiurl}procurement/procurement-approved-by-operation-head/${procurementId}`, data)
    },

    // Endpoint to get all open procurements inwarded
    getAllInwardedOpenProcurements: function () {
        return axios.get(`${Apiurl}procurement/get-all-open-procurements-inwarded`)
    },

    getAllProcurementsApprovedByOperationHead: function () {
        return axios.get(`${Apiurl}procurement/get-procurement-approved-by-operation-head`)
    },

    // getting procurements approved by operation head for reports dashboard
    getAllProcurementsDetailsApprovedByOperationHead: function (page,rowsPerPage,startDate, endDate) {
        return axios.get(`${Apiurl}procurement/get-procurement-details-approved-by-operation-head?page=${page}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}`)
    },

    // getting service orders approved by operation head
    getServiceOrdersApprovedByOperationHead: function () {
        return axios.get(`${Apiurl}serviceOrder/get-service-orders-approved-by-operation-head`)
    },

    // getting service orders approved by operation head for reports dashboard
    getServiceOrderDetailsApprovedByOperationHead: function (page,rowsPerPage,startDate, endDate) {
        return axios.get(`${Apiurl}serviceOrder/get-service-order-details-approved-by-operation-head?page=${page}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}`)
    },

    approveProcurementUpdateStdRate: function (procurementId, data) {
        return axios.put(`${Apiurl}procurement/approveProcurement-updateStdRate/${procurementId}`, data)
    },
    rejectProcurement: function (procurementId, data) {
        return axios.put(`${Apiurl}procurement/rejectProcurement/${procurementId}`, data)
    },
    generatePO: function (poId) {
        return axios.put(`${Apiurl}procurement/generatePo/${poId}`)
    },
    generateMaskedPo: function (poId) {
        return axios.put(`${Apiurl}procurement/generateMaskedPo/${poId}`)
    },
    getAllProcurementsForInwarding: function (code, type) {
        if (code)
            return axios.get(`${Apiurl}procurement/getAllProcurementsForInwarding?projectCode=${code}`)
        return axios.get(`${Apiurl}procurement/getAllProcurementsForInwarding?procurementType=${type}`)
    },

    // Get All PO of a projects using projectId
    getAllProcurementsUsingProjectId: function (projectId) {
        return axios.get(`${Apiurl}procurement/get-all-procurements-of-project?projectId=${projectId}`)
    },
    
    // Getting All Procurements Including Project, Store and Factory
    getAllProcurementsForInwardingIncludingOpenPO: function (page = 0, limit = 500) {
        return axios.get(
            `${Apiurl}procurement/getAllProcurementsForInwardingIncludingOpenPO`,
            {
                params: {
                    page: Number(page) || 0,
                    limit: Number(limit) || 500,
                },
            }
        );
    },
    // Getting All Invoices of a procurement using procurement id 
	getInwardingMaterialInvoices: function(procId){
        return axios.get(
            `${Apiurl}procurement/getInwardingMaterialInvoices/${procId}`
        );
    },
    getAllOpenProcurements: function () {
        return axios.get(`${Apiurl}procurement/getAllOpenProcurements`)
    },
    getAllProcurements: function (vendorId) {
        return axios.get(`${Apiurl}procurement/getAllProcurements/${vendorId}`)
    },
    getProcurementsforVendors: function (data) {
        return axios.put(`${Apiurl}procurement/getProcurementsforVendors`, data)
    },
    getServiceOrdersforVendors: function (data) {
        return axios.put(`${Apiurl}serviceOrder/getServiceOrdersforVendors`, data)
    },
    getServiceOrdersforVendor: function (data) {
        return axios.put(`${Apiurl}serviceOrder/getServiceOrdersforVendor`, data)
    },
    gatAllMaterialTransferForInwarding: function (code, type) {
        return axios.get(`${Apiurl}material-transfer/material-transfer/for-inwarding?transferFrom=${type}`)
    },
    getMtrByOrderIdForInwarding: function (mtrOrderId) {
        return axios.get(`${Apiurl}material-transfer/getMtrByOrderIdForInwarding/${mtrOrderId}`)
    },
    getMaterialTransferForOutwarding: function (transferFrom) {
        return axios.get(`${Apiurl}material-transfer/material-transfer/for-outwarding?transferFrom=${transferFrom}`)
    },
    materialReturnRequest: function (data) {
        return axios.post(`${Apiurl}materialMaster/materials/material-return-request`, data)
    },
    handleReturnAction: function (data) {
        return axios.put(`${Apiurl}materialMaster/materials/material-return-action`, data)
    },
    getMaterialDispatchedQty: function (projectId, materialId) {
        return axios.get(`${Apiurl}material-transfer/material-transfer/project-material-qty/${projectId}/?materialId=${materialId}`)
    },
    outwardMaterial: function (id, data) {
        return axios.put(`${Apiurl}material-transfer/material-transfer/outward-material/${id}`, data)
    },
    getProcurementByOrderIdForInwarding: function (poOrderId) {
        return axios.get(`${Apiurl}procurement/getProcurementByOrderIdForInwarding/${poOrderId}`)
    },

    // Endpoint to get all inwarding linked to a invoice number
    getAllInwardingsOfProcurement: function (payload) {
        return axios.get(`${Apiurl}inwardingApprovals/fetch-all-inwarding-of-invoice/${payload.procurementId}/?inwardingRecordId=${payload.inwardingRecordId}`)
    },

    // function to get all grn(s) for a purchase order
    getGrnForProcurementId: function (procurementId) {
        return axios.get(`${Apiurl}inwardingApprovals/getGrnByProcurementId/${procurementId}`);
    },

    // Endpoint to get all finance executives
    getAllFinanceExecutive: function (store) {
        return axios.put(`${Apiurl}user/getAllFinanceExecutive`, store)
    },

    // function to assign factory finance executive role
    roleAssignFactoryFinanceExecutive: function (data) {
        return axios.put(`${Apiurl}user/giveFinanceExecutiveFactoryFinanceExecutive`, data)
    },
    // function to get all new inwarding approvals
    getDataForNewInwardingApproval: function (startDate, endDate, page = 0, rowsPerPage = 100,searchType,searchQuery) {
        return axios.get(
            `${Apiurl}inwardingApprovals/getDataForNewInwardingApproval?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${rowsPerPage}&searchType=${searchType}&searchQuery=${searchQuery}`
        );
    },
    getApprovalDataofInwardingCsv: function (startDate,endDate) {
        return axios.get(`${Apiurl}inwardingPaymentRequest/download-inwarding-approvals?startDate=${startDate}&endDate=${endDate}`, {
          responseType: 'blob' 
        });
      }, 
    // function to get all price change logs of material
    fetchMaterialPriceChangeHistory: function (startDate, endDate, page, limit, vendorId, materialId, poSoMaterials) {
        return axios.get(`${Apiurl}material-price-updates/get-all-price-change-logs?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}&vendorId=${vendorId}&materialId=${materialId}&poSoMaterials=${poSoMaterials}`);
    },

    // Getting data for payment excel download// Getting data for inwarding freight approval  
    getDataForInwardingFreightApprovals: function () {
        return axios.get(`${Apiurl}inwardingApprovals/getDataForInwardingFreightApprovals`);
    },

    // Getting data for inwarding freight approval  
    generateBankFormatReportForApprovedInwarding: function (startDate, endDate, dateFilterType, vendorId) {
        return axios.get(`${Apiurl}inwardingApprovals/generate-bank-format-report-for-approved-inwarding?startDate=${startDate}&endDate=${endDate}&dateFilterType=${dateFilterType}&vendorId=${vendorId}`);
    },

    // Getting data for inwarding freight approval  
    getDataForPaymentExcelDownloads: function (startDate, endDate, dateFilterType, vendorId,page,limit) {
        return axios.get(`${Apiurl}inwardingApprovals/getDataForPaymentExcelDownloads?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&dateFilterType=${dateFilterType}&vendorId=${vendorId}`);
    },

    // getting data for Pedning Inwarding Approval Page
    getDataForPendingInwardingApproval: function () {
        return axios.get(`${Apiurl}inwardingApprovals/getDataForPendingInwardingApproval`);
    },
    
    // getting data for Raised Payment Request Page
    fetchInwardingApprovedForPaymentRequests: function (payload) {
        return axios.get(`${Apiurl}inwardingApprovals/getDataForInwardingApprovedForPaymentRequest?startDate=${payload.startDate}&endDate=${payload.endDate}&paymentRaisedStatus=${payload.paymentRaisedStatus}&vendorId=${payload.vendorId}`);
    },
    
    // getting data for Inwarding Payment Approval Page
    fetchInwardingPaymentRequest: function (payload) {
        return axios.get(`${Apiurl}inwardingPaymentRequest/inwarding-payment-request?startDate=${payload.startDate}&endDate=${payload.endDate}&vendor=${payload.vendor}&requester=${payload.requester}`);
    },
   fetchVendorListForPaymentApproval() {
        return axios.get(`${Apiurl}inwardingPaymentRequest/inwarding-payment/vendors`);
    },
    
    fetchRequesterListForPaymentApproval() {
        return axios.get(`${Apiurl}inwardingPaymentRequest/inwarding-payment/requesters`);
    },
     //  paginated versions for the finance-factory-inwarding/paymentRequestApproval page 
    fetchInwardingPaymentRequestForApprovalPage: function (payload) {
        const page = payload.page || 1;
        const limit = payload.limit || 100;
        return axios.get(`${Apiurl}inwardingPaymentRequest/inwarding-payment-request-for-approval-page?startDate=${payload.startDate}&endDate=${payload.endDate}&vendor=${payload.vendor}&requester=${payload.requester}&page=${page}&limit=${limit}`);
    },
    
    // getting data for Inwarding Payment Approval Page By Id
    fetchInwardingPaymentRequestById: function (inwardingPaymentRequestId) {
        return axios.get(`${Apiurl}inwardingPaymentRequest/inwarding-payment-request/${inwardingPaymentRequestId}`);
    },
    
    // getting for Rejected Inwarding Approval Page
    getInwardingApprovalDataRejectedByFincance: function () {
        return axios.get(`${Apiurl}inwardingApprovals/getInwardingApprovalDataRejectedByFincance`);
    },
    
    // getting for Pending Inwarding Approval Page
    getDataForEditedInwardingApproval: function () {
        return axios.get(`${Apiurl}inwardingApprovals/getDataForEditedInwardingApproval`);
    },
    
    // Get data requested for po edit approval
    getPOEditApprovalRequestData: function () {
        return axios.get(`${Apiurl}poEditRequest/getPOEditApprovalRequestData`);
    },

    // Get data requested for po edit approval for l1 manager
    getPOEditApprovalRequestDataL1: function () {
        return axios.get(`${Apiurl}poEditRequest/getPOEditApprovalRequestDataForL1Manager`);
    },

    // Update the PO Edit Request status
    updatePOEditRequestStatus: function (data) {
        return axios.put(`${Apiurl}poEditRequest/updatePOEditRequestStatus`, data);
    },

    // Update the PO Edit Request status for l1 manager
    updatePOEditRequestStatusL1: function (data) {
        return axios.put(`${Apiurl}poEditRequest/updatePOEditRequestStatusForL1Manager`, data);
    },
    
    // Function to update the status of an edited PO sent for finance approval
    updateEditedPOFinanceApprovalStatus: function (data) {
        return axios.put(`${Apiurl}poEditRequest/po/edited/update-finance-approval-status`, data);
    },

    // Function to update the status of an edited PO sent for finance approval
    raisePaymentRequestsForInwarding: function (data) {
        return axios.put(`${Apiurl}inwardingPaymentRequest/raise-payment-request-for-inwarding`, data);
    },
    
    // Function to update the status of an inwarding payment request sent for finance approval
    handlePaymentRequestApproval: function (data) {
        return axios.put(`${Apiurl}inwardingPaymentRequest/handle-payment-request-for-inwarding`, data);
    },
    
    // Function to update the status of an inwarding payment request sent for finance approval
    handlePaymentRequestApprovalForSingleInwarding: function (data) {
        return axios.put(`${Apiurl}inwardingPaymentRequest/handle-payment-request-for-single-inwarding`, data);
    },

    // Function to updated Inwarding Status Sent for Finance Manager for Freight Approval
    updateInwardingStatusSentForFreightApproval: function (data) {
        return axios.put(`${Apiurl}inwardingApprovals/finance-manager/freight-charge-approval`, data);
    },

    // Function to updated Rejected Inwarding Status By Procurement Executive
    updateRejectedInwardingStatus: function (data) {
        return axios.put(`${Apiurl}inwardingApprovals/updateRejectedInwardingStatus`, data);
    },
    
    // Function to updated Rejected Inwarding Status By Procurement Executive to sent to Procurement Manager's approval
    sendPOEditRequestToProcurementManager: function (data) {
        return axios.put(`${Apiurl}inwardingApprovals/sendPOEditRequestToProcurementManager`, data);
    },

    inwardMaterialToProcurement: function (procId, data) {
        return axios.put(`${Apiurl}procurement/inwardMaterialToProcurement/${procId}`, data)
    },
    mtrInwardMaterialToSite: function (mtrId, data) {
        return axios.put(`${Apiurl}material-transfer/inwarding-material/${mtrId}`, data)
    },
    editProcurementOrderPaymentStatus: function (paymentId, data) {
        return axios.put(`${Apiurl}procurement/payment-request/${paymentId}`, data)
    },
    approverProcurementOrderPaymentStatus: function (paymentId, data) {
        return axios.put(`${Apiurl}procurement/payment-approver-request/${paymentId}`, data)
    },
    getProcurementsForApproval: function () {
        return axios.get(`${Apiurl}procurement/getProcurementsForApproval`)
    },
    deleteProcurementById: function (PoId) {
        return axios.delete(`${Apiurl}procurement/deleteProcurementById/${PoId}`)
    },
    getServiceOrdersForApproval: function () {
        return axios.get(`${Apiurl}serviceOrder/getServiceOrdersForApproval`)
    },
    getOpenProcurements: function () {
        return axios.get(`${Apiurl}procurement/openProcurement`)
    },
    getOpenProcurementsPaymentRequest: function (procurementType) {
        if (procurementType)
            return axios.get(`${Apiurl}procurement/payment-request?procurementType=${procurementType}`)
        return axios.get(`${Apiurl}procurement/payment-request`)
    },
    addUser: function (data) {
        return axios.post(`${Apiurl}user/addUser`, data)
    },
    getUsers: function (store) {
    return axios.put(`${Apiurl}user/getUsers`,store)
    },
    getUsersforUsersPage: function (store) {
        return axios.put(`${Apiurl}user/getUsersforUsersPage`,store)
    },
    getAllUsersforAcess : function (store) {
        return axios.put(`${Apiurl}user/getAllUsers`,store)
    },
    getUsersData: function () {
        return axios.get(`${QTurl}user/getUsersData/`);
    },
    deleteUser: function (userId) {
        return axios.put(`${Apiurl}user/deleteUser/${userId}`)
    },
    getUserById: function (userId) {
        return axios.get(`${Apiurl}user/getUserById/${userId}`)
    },
    getAllRoles: function () {
        return axios.get(`${Apiurl}roles/allRoles`)
    },
    getUniqueRoleFields: function () {
        return axios.get(`${Apiurl}roles/getUniqueRoleFields`)
    },
    addVendor: function (data) {
        return axios.post(`${Apiurl}vendor/addVendor`, data)
    },
    editVendor: function (data) {
        return axios.put(`${Apiurl}vendor/editVendor/${data._id}`, data)
    },
    getVendorById: function (vendorId) {
        return axios.get(`${Apiurl}vendor/getVendorById/${vendorId}`)
    },
    getVendorMaterialById: function (vendorId) {
        return axios.get(`${Apiurl}vendor/getVendorMaterialById/${vendorId}`)
    },
    //Getting Vendor details and mtr quantity while adding new material to the PO/SO/MTR By materialId
    getVendorDetailsMaterialById: function (data) {
        return axios.post(`${Apiurl}project-material/getVendorDetails`,data)
    },
    getAllMaterials: function (type) {
        if (type)
            return axios.get(`${Apiurl}materialMaster/materials/allMaterials?type=${type}`)
        return axios.get(`${Apiurl}materialMaster/materials/allMaterials`)
    },
    // getting all materials of stock including available, consumed and raised MTR
    getAllMaterialsStock: function (type) {
        if (type)
            return axios.get(`${Apiurl}materialMaster/materials/allMaterials/stocks?type=${type}`)
        return axios.get(`${Apiurl}materialMaster/materials/allMaterials/stocks`)
    },
    getAllMaterialsStockAndMoq: function (type) {
        return axios.get(`${Apiurl}materialMaster/materials/allMaterialsStockAndMoq/?type=${type}`)
    },
    getAllMaterialsNameAndCode: function() {
        return axios.get(`${Apiurl}materialMaster/materials/allMaterialsNameAndCode`)
    },
    getSelectedSearchMaterialData: function(data){
        return axios.post(`${Apiurl}materialMaster/materials/selectedSearchMaterialData`,data)
    },
    getAllMaterial: function(limit,page){
        return axios.get(`${Apiurl}materialMaster/materials/allMaterial?limit=${limit}&page=${page}`)
    },

    getMtrReturns: function() {
        return axios.get(`${Apiurl}materialMaster/materials/allMtrReturns`)
    },
    getMtrPendingReturns: function() {
        return axios.get(`${Apiurl}materialMaster/materials/allPendingReturns`)
    },
    getProjectMaterials: function (projectId) {
        return axios.get(`${Apiurl}materialMaster/materials/projectMaterials/${projectId}`)
    },
    imosUploadBomData: function (fileUrl) {
        return axios.get(`${QTurl}imosHardwareFileData/imosHardwareFileData?fileUrl=${encodeURIComponent(fileUrl)}`)
    },
    mapMaterialsForVendor: function (vendorId, data) {
        return axios.post(`${Apiurl}vendor/mapMaterialsForVendor/${vendorId}`, data)
    },
    addRole: function (data) {
        return axios.post(`${Apiurl}roles/addRole`, data)
    },
    editRole: function (data) {
        return axios.put(`${Apiurl}roles/editRole`, data)
    },
    editScope: function (data) {
        return axios.put(`${Apiurl}roles/editScope`, data)
    },
    editUserRole: function (data) {
        return axios.put(`${Apiurl}user/editUserRole`, data)
    },
    editUser: function (data) {
        return axios.put(`${Apiurl}user/editUser/${data._id}`, data)
    },
    raiseMaterialTransferRequest: function (data) {
        return axios.post(`${Apiurl}material-transfer`, data)
    },
    getMaterialTransferRequest: function () {
        return axios.get(`${Apiurl}material-transfer`)
    },
    materialTransferDetails: function (materialId) {
        return axios.get(`${Apiurl}material-transfer/details/${materialId}`)
    },
    generateMTR: function (mtrId) {
        return axios.put(`${Apiurl}material-transfer/generateMTR/${mtrId}`)
    },
    updateBarcodeGeneration : function (data){
        return axios.put(`${Apiurl}project-material/update-patterns`,data)
    },
    updatedisPatternPrint: function (data){
        return axios.put(`${Apiurl}project-material/update-patternprint`,data)
    },
    updateBarcodeScan : function (data){
        return axios.put(`${Apiurl}project-material/scan-barcode`,data)
    },
    getBomProjectDetails : function(data) {
        return axios.put(`${Apiurl}project-material/materials-details`, data)
    },
    generateOutwarding: function (mtrId) {
        return axios.put(`${Apiurl}material-transfer/material-transfer/generate-outwarding/${mtrId}`)
    },
    editMaterialTransfer: function (transferId, data) {
        return axios.put(`${Apiurl}material-transfer/${transferId}`, data)
    },
    getMaterailTransferRequestsByScopeForProject: function (projectId, scopeName) {
        return axios.get(`${Apiurl}material-transfer/material-transfer/all?projectId=${projectId}&scopeName=${scopeName}`)
    },
    getPreviousBomForProject: function (projectId) {
        return axios.get(`${Apiurl}project-material/view-previous-bom/${projectId}`)
    },
    getBomPendingForApproval: function () {
        return axios.get(`${Apiurl}project-material/bom-pending-for-approval`)
    },

    // Route to get bom whose approval is pending
    getBomPendingForApprovalProjectId: function (projectId) {
        return axios.get(`${Apiurl}project-material/bom-pending-for-approval/${projectId}`)
    },

    generatePaymentReportForPo: function (data) {
        return axios.post(`${Apiurl}procurement/generate-payment-report`, data)
    },
    generatePaymentReportForSo: function (data) {
        return axios.post(`${Apiurl}serviceOrder/generate-payment-report`, data)
    },
    generatebankformatPaymentReportForPo: function (data) {
        return axios.post(`${Apiurl}procurement/bank-format-generate-payment-report`, data)
    },
    generatebankformatPaymentReportForSo: function (data) {
        return axios.post(`${Apiurl}serviceOrder/bank-format-generate-payment-report`, data)
    },
    addCategory: function (data) {
        return axios.post(`${Apiurl}space-names`, data)
    },
    updateCategory: function (data, id) {
        return axios.put(`${Apiurl}space-names/${id}`, data)
    },
    addScope: function (data) {
        return axios.post(`${Apiurl}scoping`, data)
    },
    updateScope: function (data, id) {
        return axios.put(`${Apiurl}scoping/${id}`, data)
    },
    deleteCategory: function (id) {
        return axios.delete(`${Apiurl}space-names/${id}`)
    },
    deleteUnit: function (id) {
        return axios.delete(`${Apiurl}unit/${id}`)
    },
    deletePaymentMode: function (id) {
        return axios.delete(`${QTurl}paymentModes/${id}`)
    },
    deleteScope: function (id) {
        return axios.delete(`${Apiurl}scoping/${id}`)
    },
    addSubCategory: function (data) {
        return axios.post(`${Apiurl}sub-category`, data)
    },
    updateSubCategory: function (data, id) {
        return axios.post(`${Apiurl}sub-category/${id}`, data)
    },
    deleteSubCategory: function (id) {
        return axios.post(`${Apiurl}sub-category/${id}`)
    },
    addMaterial: function (data) {
        return axios.post(`${Apiurl}materialMaster`, data)
    },
    updateMaterial: function (data, id) {
        return axios.put(`${Apiurl}materialMaster/${id}`, data)
    },
    deleteMaterial: function (id) {
        return axios.post(`${Apiurl}materialMaster/${id}`)
    },
    updateOrgRateCardPrices: function (data, rateCardMasterId) {
        return axios.put(`${Apiurl}org-rate-card/${rateCardMasterId}`, data)
    },
    cloneOrgRateCard: function (rateCardMasterId, locationId, markUp) {
        console.log(rateCardMasterId, locationId, markUp)
        return axios.post(`${Apiurl}org-rate-card/clone-rate-card/${rateCardMasterId}`, { markUp, locationId })
    },
    makeDefault: function (rateCardMasterId, locationId) {
        return axios.put(`${Apiurl}org-rate-card/makeDefault/${rateCardMasterId}`, { locationId })
    },

    //QT Integration API
    getAllLeads: function (limit, page, search, expCenterId) {
        return axios.get(`${QTurl}lead/all?limit=${limit}&page=${page}&search=${search}&experienceCenterId=${expCenterId}`)
    },
    getDatefilterLeads: function (limit, page, expCenterId, data) {
        return axios.get(`${QTurl}lead/all?limit=${limit}&page=${page}&startDate=${data.startDate}&endDate=${data.endDate}&departmentId=${data.departmentId}&experienceCenterId=${expCenterId}&search=${data.search}`)
    },
    getAllSearchLeads: function (searchType, search, expCenterId, data) {
        if (data.role === 'admin' || data.role === 'TeleCaller')
            return axios.get(`${QTurl}lead/all-search-lead?searchType=${searchType}&search=${search}&experienceCenterId=${expCenterId}&startDate=${data.startDate}&endDate=${data.endDate}`)
        return axios.get(`${QTurl}lead/all-search-lead?searchType=${searchType}&search=${search}&experienceCenterId=${expCenterId}`)
    },
    getAllLeadsForChangeRate: function (search = '') {
        return axios.get(`${QTurl}lead/allLeadsForProjectRateCard?search=${encodeURIComponent(search)}&limit=30`)
    },
    getFilterResponse: function (data) {
        if (data.startDate && data.endDate)
            return axios.get(`${QTurl}lead/filter-lead-for-admin?teamId=${data.teamId}&departmentId=${data.departmentId}&stage=${data.stage}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.expCenterId}&sourceOfLead=${data?.sourceOfLead}`)
        return axios.get(`${QTurl}lead/filter-lead-for-admin?teamId=${data.teamId}&departmentId=${data.departmentId}&stage=${data.stage}&experienceCenterId=${data.expCenterId}&sourceOfLead=${data?.sourceOfLead}`)
    },
    getdateFilterResponse: function (data) {
        return axios.get(`${QTurl}lead/filter-lead-for-admin?startDate=${data.startDate}&endDate=${data.endDate}&departmentId=${data.departmentId}&experienceCenterId=${data.expCenterId}`)
    },
    getAllLeadsNames: function () {
        return axios.get(`${QTurl}lead/all/names`)
    },
    saveKnowledgeDetails : function (data){
        return axios.post(`${QTurl}knowledge-taging/createTag`,data)
    },
    saveKnowledgeTaging : function (data) {
        return axios.post(`${QTurl}knowledge-taging`,data)
    },
    getKnowledgeTaging : function () {
        return axios.get(`${QTurl}knowledge-taging/getKnowledgeTaging`)
    },
    getAllKnowLedgeDetails : function (data) {
        return axios.put(`${QTurl}knowledge-taging/getAllKnowLedgeDetails`,data)
    },
    deleteKnowledgeDetails : function (id){
        return axios.put(`${QTurl}knowledge-taging/deleteKnowledgeDetails`,id)
    },
    updateProjectRatePrices: function (data, projectId) {
        return axios.put(`${QTurl}project-rate-card/${projectId}`, data)
    },
    getOrgRateCardForRateCardMaster: function (rateCardMasterId) {
        return axios.get(`${QTurl}org-rate-card/${rateCardMasterId}`)
    },
    getAllRateCardMaster: function (locationId) {
        return axios.get(`${QTurl}rate-card-master?locationId=${locationId}`)
    },
    getProjectRateCard: function (projectId) {
        return axios.get(`${QTurl}project-rate-card/default-rate-card/${projectId}`)
    },
    customerProject: function (data) {
        return axios.get(`${QTurl}project/customer/${data}`)
    },
    getDepartments: function () {
        return axios.get(`${Apiurl}department/all`);
    },
    getWhatsAppNotificationTemplates: function () {
        return axios.get(`${QTurl}whatsApp/all_notification_templates`);
    },
    updateWhatsAppNotificationTemplate: function (data) {
        return axios.post(`${QTurl}whatsApp/update_whatsApp_notification_template`, data);
    },
    createDepartment: function (data) {
        return axios.post(`${Apiurl}department/addDepartment/`, data)
    },
    editDepartment: function (data, id) {
        return axios.put(`${Apiurl}department/editDepartment/${id}`, data)
    },
    editTeam: function (data, id) {
        return axios.put(`${Apiurl}team/editTeam/${data.teamId}`, data)
    },
    deleteDepartment: function (deptID) {
        return axios.delete(`${Apiurl}department/deleteDepartment/${deptID}`)
    },
    getTeams: function (params = {}) {
        return axios.get(`${Apiurl}team/all`, { params });
      },      
    createTeam: function (data) {
        return axios.post(`${Apiurl}team/addTeam/`, data)
    },
    getQTTeamUsers: function (id) {
        return axios.get(`${Apiurl}user/usersOfTeam/${id}`);
    },
    getQtTeamManager: function (id) {
        return axios.get(`${QTurl}user/managerOfTeam/${id}`);
    },
    assignProject: function (data) {
        return axios.post(`${QTurl}assignTo`, data);
    },
    leadUpdateMeeting:function (data) {
        return axios.post(`${QTurl}assignTo/leadUpdateMeeting`, data);
    },
    wdFileUpload: function (data) {
        return axios.post(`${QTurl}file/upload`, data)
    },
    // Re-upload of the documents captured at Design Sign-Off (Admin / Naraci Tech only)
    searchDesignSignOffLeads: function (q) {
        return axios.get(`${QTurl}designSignOffDocs/search?q=${encodeURIComponent(q)}`)
    },
    getDesignSignOffDocs: function (leadId) {
        return axios.get(`${QTurl}designSignOffDocs/${leadId}`)
    },
    updateDesignSignOffDocs: function (leadId, data) {
        return axios.put(`${QTurl}designSignOffDocs/${leadId}`, data)
    },
    // Payment QR regeneration (Admin / Naraci Tech only). The QR encodes the
    // UPI virtual account the customer pays into, so the server re-checks the
    // role on every one of these.
    getPaymentQrLead: function (leadId) {
        return axios.get(`${QTurl}paymentQrCode/${leadId}`)
    },
    regeneratePaymentQr: function (leadId, data) {
        return axios.post(`${QTurl}paymentQrCode/${leadId}/regenerate`, data)
    },
    // Hold revoke dashboard. Read-only; the sweep's own endpoints sit behind
    // the HoomanLabs api key, so the browser reads through these instead.
    // Takes { startDate, endDate } as YYYY-MM-DD. A bare number is still
    // accepted and sent as ?days=, which the server also still understands.
    getHoldRevokeOverview: function (range) {
        const q = new URLSearchParams()
        if (range && range.startDate && range.endDate) {
            q.set('startDate', range.startDate)
            q.set('endDate', range.endDate)
        } else {
            q.set('days', typeof range === 'number' ? range : 30)
        }
        if (range && range.city && range.city.length) q.set('city', range.city.join(','))
        if (range && range.experienceCenterId && range.experienceCenterId.length) {
            q.set('experienceCenterId', range.experienceCenterId.join(','))
        }
        return axios.get(`${QTurl}holdRevokeDashboard/overview?${q.toString()}`)
    },
    getHoldRevokeRun: function (sweepId) {
        return axios.get(`${QTurl}holdRevokeDashboard/runs/${sweepId}`)
    },
    // `scope` is { city, experienceCenterId } - arrays of ids, sent only when
    // something is actually picked so an empty selection never reaches the
    // server as an empty string meaning "no centre".
    getHoldRevokeLeads: function (bucket, limit, scope = {}) {
        const q = new URLSearchParams()
        q.set('bucket', bucket)
        q.set('limit', limit || 100)
        if (scope.city && scope.city.length) q.set('city', scope.city.join(','))
        if (scope.experienceCenterId && scope.experienceCenterId.length) {
            q.set('experienceCenterId', scope.experienceCenterId.join(','))
        }
        return axios.get(`${QTurl}holdRevokeDashboard/leads?${q.toString()}`)
    },
    // Cron job monitor - runs are written by the cron server, read here.
    getCronRunDashboard: function (hours) {
        return axios.get(`${QTurl}cronRunLog/dashboard?hours=${hours || 24}`)
    },
    // Re-runs one job now. The server re-fires the endpoint recorded against
    // that job's last run and logs the attempt as triggeredBy: 'manual'.
    triggerCronJob: function (jobName) {
        return axios.post(`${QTurl}cronRunLog/trigger/${encodeURIComponent(jobName)}`)
    },
    getCronRunHistory: function ({ jobName, status, limit } = {}) {
        const params = new URLSearchParams()
        if (jobName) params.set('jobName', jobName)
        if (status) params.set('status', status)
        params.set('limit', String(limit || 100))
        return axios.get(`${QTurl}cronRunLog?${params.toString()}`)
    },
    uploadAndSendToImosAndSiteBOM: function (leadId,data) {
        return axios.put(`${QTurl}lead/sendToImosAndSiteQc/${leadId}`,data)
    },
    uploadIMOSFile: function (leadId, data) {
        return axios.put(`${QTurl}lead/uploadImosFiles/${leadId}`, data)
    },
    updateToReadyToDispatch: function (leadId, data) {
        return axios.put(`${QTurl}lead/updateToReadyToDispatch/${leadId}`, data)
    },
    updateFactoryStage: function (leadId, data) {
        return axios.put(`${QTurl}lead/updateFactoryStage/${leadId}`, data)
    },
    uploadUpdatedFileAndData: function (leadId, data) {
        return axios.put(`${QTurl}lead/uploadUpdatedData/${leadId}`, data)
    },
    getReadyToDispatchProjects: function (expcenter) {
        return axios.get(`${QTurl}lead/getReadyToDispatchProjects/${expcenter}`);
    },
    gerRawLeads: function (data) {
        {
        if(data.startDate !=="" && data.endDate !==""){
            return axios.put(`${QTurl}lead/getrawleads/?page=${data.page}&limit=${data.limit}&startDate=${data.startDate}&endDate=${data.endDate}`);
        }
        else{
            return axios.put(`${QTurl}lead/getrawleads/?page=${data.page}&limit=${data.limit}&startDate=${data.startDate = ""}&endDate=${data.endDate = ""}`);
        }
    }},
    pushRawLead : function (data) {
    return axios.post(`${QTurl}lead/createWebSiteLead`, data)
    },
    getReadyToDispatchProjectsForCHM: function (expcenter, chmId) {
        return axios.get(`${QTurl}lead/getReadyToDispatchProjectsForCHM/${expcenter}?chmId=${chmId}`);
    },
    getAllSiteQcDetails: function () {
        return axios.get(`${QTurl}lead/getAllSiteQcDetails`)
    },
    getAllDesignKickOffLeads: function (selectedExpCenter) {
        return axios.get(`${QTurl}lead/getAllDesignKickOffLeads/${selectedExpCenter}`);
    },
    assignSiteQC_Manually: function(data)
    {
        return axios.put(`${QTurl}lead/assignSiteQC_Manually`,  data)
    },
    getUnderExecutionProjects:function (expcenter,obj)
    {
        return axios.put(`${QTurl}lead/getUnderExecutionProjects/${expcenter}`, obj);
    },
    getCompletedProjects:function (expcenter,obj)
    {
        return axios.put(`${QTurl}lead/getCompletedProjects/${expcenter}`, obj);
    },
    getCompletedMWPProjects:function (expcenter,obj)
    {
        return axios.put(`${QTurl}lead/getCompletedMWPProjects/${expcenter}`, obj);
    },
    getQTUsers(id) {
        return axios.get(`${QTurl}user/usersOfTeam/${id}`);
    },
    getAllQuotationsForProject(projectId) { //ajit
        return axios.get(`${QTurl}quotation/all/${projectId}`)
    },
    sendMeetingData(payload) {
        return axios.put(
          `${QTurl}lead/meetingHandler`,
          payload
        );
      },
      
    getProjectDetails(projectId) {
        return axios.get(`${QTurl}lead/details/?leadId=${projectId}`);
    },
    getProjectLeadDetails(projectId) { //ajit
        return axios.get(`${QTurl}lead/leadDetails/?leadId=${projectId}`);
    },
    getLeadDetails(leadID) {
        return axios.get(`${QTurl}user/leadData/?leadId=${leadID}`);
    },
    generateQuotationExcel(quotationId) { //ajit
        return axios.get(`${QTurl}quotation/excel/${quotationId}`)
    },
    finalPaymentApprovedByFm(leadId) {
        return axios.get(`${QTurl}lead/getFinalPaymentsApproved/${leadId}`)
    },
    updateDesignKickOffCustomerFromDesign(data)
    {
        return axios.put(`${QTurl}lead/updateDesignKickOffCustomerFromDesign`, data)
    },
    updateDesignKickOffCustomerFromChm(data)
    {
        return axios.put(`${QTurl}lead/updateDesignKickOffCustomerFromChm`, data)
    },
    updateDesignKickOffInternalFromSalesUser(data) {
        return axios.put(`${QTurl}lead/designKickOffInternalActionHandle`, data)
    },
    enableDesignKickOffInternalForDesigner(data) {
        return axios.put(`${QTurl}lead/enableDesignKickOffInternalForDesigner`, data);
    },
    sendDesignKickOffCustomerReminderForDesigner(data) {
        return axios.put(`${QTurl}lead/sendDesignKickOffCustomerReminderForDesigner`, data);
    },
    sendDesignSignOffCustomerReminder(data) {
        return axios.put(`${QTurl}lead/sendDesignSignOffCustomerReminder`, data);
    },
    raiseDesignKickOffInternal: function (data) {
        return axios.post(`${QTurl}lead/raiseInternalKickoff`, data)
    },
    updateDesignKickOffCustomerFromSalesUser(data) {
        return axios.put(`${QTurl}lead/designKickOffInternalActionHandle`, data)
    },
    getProjectComponent: function (projectId) { //ajit
        return axios.get(`${QTurl}projectComponent/${projectId}`)
    },
    addProjectComponent: function (data) { //ajit
        return axios.post(`${QTurl}projectComponent/new`, data)
    },
    getAllProductsFromRateCard: function (projectId) { //ajit
        return axios.get(`${QTurl}project-rate-card/default-rate-card/${projectId}`)
    },
    editProjectComponentQuotation: function (data) {
        return axios.put(`${QTurl}projectComponent/edit`, data)
    },
    getDiscountMasterData: function () { //ajit
        return axios.get(`${QTurl}discount/all`)
    },
    newDiscount: function (data) {
        return axios.post(`${QTurl}discount/new`, data)
    },
    editDiscount: function (id, data) {
        return axios.put(`${QTurl}discount/edit/${id}`, data)
    },
    sendDataToERP: function(payload) {
        if(payload.barcode.includes('_HW_')){
            console.log("it is calleddd")
            return axios.post(`${TrackingURL}/sendDataToERPForHardware`, payload);
        }else{
            console.log("second called")
        return axios.post(`${TrackingURL}/sendDataToERP`, payload);
        }
      },
    sendScanData : function (data) {
        return axios.post(`${QTurl}scanpiece/storeScanPiece`, data)
    },
    getStatusWiseData : function (data) {
        return axios.post(`${QTurl}scanpiece/getProjectPackagess`, data)
    },
    updateStatusUnderExecution: function (data) {
        return axios.post(`${QTurl}lead/updateStatusToInTransit`, data)
    },
    // Updated HTTP Service method to support pagination
getProjectWiseReports: function (creatorId, page = 1, limit = 50) {
    return axios.get(`${QTurl}scanpiece/getProjectWiseReports`, {
        params: {
            page: page,
            limit: limit
        }
    });
},    
      getInTransitProjects : function (locations) {
        const locationIds = locations?.map(loc => loc._id) || [];

        return axios.post(`${QTurl}lead/getInTransitProjects`, locationIds);
    },
    checkPackage: function(params) {
        if(params.package_name.includes('_HW_')){
            return axios.post(`${QTurl}scanpiece/checkHardware`, params);
        }else{
        return axios.post(`${QTurl}scanpiece/checkPackage`, params);
        }
      },
    changeStateToUnderExecution : function(data) {
        return axios.post(`${QTurl}lead/updateStatusUnderExecution`, data)
    },
      // Store scan piece
       storeScanPiece: function(data) {
        if(data?.type === 'hardware'){
            return axios.post(`${QTurl}scanpiece/storeScanHardware`, data);
        }else{
        return axios.post(`${QTurl}scanpiece/storeScanPiece`, data);
        }
      },
         calculateCompletionPiece: function(data = null) {
        // If data is provided, include it in the URL, otherwise call the endpoint without a parameter
        const url = data 
          ? `${QTurl}scanpiece/getPackageCountsByProject/${data}`
          : `${QTurl}scanpiece/getPackageCountsByProject/`;
          
        return axios.get(url);
      },
      // Reset scan status
      resetScanStatus: function(packageName) {
        return axios.post(`${QTurl}scanpiece/resetScanStatus`, { packageName });
      },
      
      // Get scanned packages
      getScannedPackages: function() {
        return axios.get(`${QTurl}scanpiece/getScannedPackages`);
      },
     

    inActiveDiscount: function (id) {
        let data = '';
        return axios.put(`${QTurl}discount/deactivate/${id}`, data)
    },
    discountApproval: function (data, leadId) {
        return axios.put(`${QTurl}lead/discountApproval/${leadId}`, data)
    },
    complimentaryApproval: function (data, leadId) {
        return axios.put(`${QTurl}lead/complimentaryApproval/${leadId}`, data)
    },
    getComplimentaryItemsApprovalLeads: function (selectedExpCenter) {
        return axios.get(`${QTurl}lead/complimentaryItemApprovalLeads/${selectedExpCenter}`)
    },
    getLostLeadRequests: function(page = 1, limit = 100, expCenterIds = []) {
    let url = `${QTurl}lead/lostRequestApproval`;
    let params = [];
    
    params.push(`page=${encodeURIComponent(page)}`);
    params.push(`limit=${encodeURIComponent(limit)}`);
    
    if (expCenterIds && expCenterIds.length > 0) {
        const ids = expCenterIds.map(ec => ec._id || ec).join(',');
        params.push(`experienceCenterIds=${encodeURIComponent(ids)}`);
    }
    
    if (params.length > 0) {
        url += `?${params.join('&')}`;
    }
    
    return axios.get(url);
    },
    getDesignSignoffHoldProjects: function () {
        return axios.get(`${QTurl}lead/DesignSignoffHOLD`)
    },
    approveLostLead: function  (data) {
        return axios.put(`${QTurl}lead/lostApprovalStatus`,data);
    },
    approveComplimentaryItems: function (projectId, data) {
        return axios.put(`${QTurl}lead/approveComplimentaryItems/${projectId}`, data)
    },
    deleteProjectComponent: function (compId) {
        return axios.delete(`${QTurl}projectComponent/remove/${compId}`)
    },
    saveQuotation: function (data) {
        return axios.post(`${QTurl}quotation/new`, data);
    },
    getProjectLog: function (projId, page) {
        return axios.get(`${QTurl}leadLog/${projId}?page=${page}`);
    },
     uploadTaxInvoice: function (leadId, data) {
        return axios.post(`${QTurl}leadLog/taxInvoice/${leadId}`, data);
    },
    getTaxInvoiceTypes: function (leadId) {
        return axios.get(`${QTurl}leadLog/taxInvoiceTypes/${leadId}`);
    },
    getTaxInvoicesList: function (page, limit, filters = {}) {
        return axios.get(`${QTurl}leadLog/taxInvoices`, { params: { page, limit, ...filters } });
    },
    getProjectLogCount: function (projId) {
        return axios.get(`${QTurl}leadLog/leadLogsLength/${projId}`);
    },
    comparedPdf : function (data) {
        return axios.post(`${QTurl}quotation/comparedPdf`, data)
    },
    // Getting Lead-Logs using leadId of Sales-User and Sales-Manager
    getLeadLogsUsingLeadId: function (leadId) {
        return axios.get(`${QTurl}leadLog/leadLogsUsingLeadId/${leadId}`);
    },

    uploadFile: function (data) {
        return axios.post(`${QTurl}file/upload?type=attachment`, data);
    },
    updateOptimisationFiles: function (data)
    {
        return axios.post(`${QTurl}project/updateOptimisationFiles`, data)
    },
    getOptimisationFiles: function ()
    {
        return axios.get(`${QTurl}project/getOptimisationFiles`)
    },
    getOptimisationFilesNew: function (page = 1, limit = 10, search = "") {
        return axios.get(`${QTurl}project/getOptimisationFilesNew?page=${page}&limit=${limit}&search=${search}`)
    },
    addNotes: function (data) {
        return axios.post(`${QTurl}leadLog`, data);
    },
    pinNote: function (id) {
        return axios.post(`${QTurl}leadLog/pin/${id}`);
    },
    unpinNote: function (id) {
        return axios.post(`${QTurl}leadLog/unpin/${id}`);
    },
    getPinnedNotes: function (leadId) {
        return axios.get(`${QTurl}leadLog/pinnedNotes/${leadId}`);
    },
    getPlyTypeMaster: function () {
        return axios.get(`${QTurl}plyTypeMaster/all`);
    },
    getManagersOfSalesTeam: function () {
        return axios.get(`${QTurl}user/managerOfSales`);
    },
    getLeadMaster: function () {
        return axios.get(`${QTurl}leadMaster/all/`);
    },
    checkCustomer: function (id) {
        return axios.get(`${QTurl}customer/checkCustomer/${id}`);
    },
    checkCustomerContact: function (id) {
        return axios.get(`${QTurl}customer/checkCustomerForEditLead/${id}`);
    },
    checkCustomerEmail: function (id) {
        return axios.get(`${QTurl}customer/checkCustomerEmailForEditLead/${id}`);
    },
    createMarketingSourceLead: function (data) {
        return axios.post(`${QTurl}leadMaster/new`, data);
    },
    changeSourceStatus: function (id, status) {
        return axios.put(`${QTurl}leadMaster/isActive/${id}`, status);
    },
    updateOptimizedSingleFile: function (id, data) {
        return axios.put(`${QTurl}project/updateOptimizedSingleFile/${id}`, data);
    },
    discountedProject: function (selectedExpCenter) {
        return axios.get(`${QTurl}lead/discountedProjects/${selectedExpCenter}`);
    },
    approveDiscount: function (projId, data) {
        return axios.put(`${QTurl}lead/approveDiscount/${projId}`, data);
    },
    getTeamUsersList: function (teamId) {
        return axios.get(`${Apiurl}team/getTeamUser/${teamId}`);
    },
    getDocumentUploaderCount: function (expCenterId) {
        return axios.get(`${QTurl}lead/getDocumentUploaderCount/${expCenterId}`);
    },
    getImosProjectCount: function (expCenterId) {
        return axios.get(`${QTurl}imosProjects/getProjectCount/${expCenterId}`);
    },
    getExecutionProjectCount: function (expCenterId,data) {
        return axios.get(`${QTurl}project/getExecutionProjectCount/${expCenterId}/?startDate=${data.startDate}&endDate=${data.endDate}&isUser=${data.isUser}`);
    },
    getImosStageProject: function (data) {
        return axios.get(`${QTurl}imosProjects/getProjectsByStage/?imosStage=${data.stage}&experienceCenterId=${data.expcenterId}&assignTo=${data.assignTo}`);
    },
    getExecutionStage: function (data) {
        return axios.get(`${QTurl}lead/getExecutionStage/?stage=${data.stage}&assignTo=${data.assignTo}`);
    },
    getSalesDepartmentUsers: function (teamId, expcenter) {
        return axios.get(`${Apiurl}team/getSalesDepartmentUsers/${teamId}/${expcenter}`);
    },
    getSelectedUsersRecords: function (users) {
        return axios.post(`${QTurl}lead/getSelectedUsersData`, users);
    },
    userRecord: function (user) {
        return axios.get(`${QTurl}user/getUserDetails/${user}` );
    },
    getOrganisationList: function () {
        return axios.get(`${Apiurl}organisation/all/`);
    },
    getBudgetSelectedYear: function (year, loc, exp) {
        return axios.get(`${QTurl}sourceOfLead/all/?year=${year}&location=${loc}&expcenter=${exp}`);
    },
    createCustomer: function (data) {
        return axios.post(`${QTurl}lead`, data);
    },
    createLeadVerification: function (data) {
        return axios.post(`${QTurl}lead/create-lead-verification`, data);
    },
    createBulkLeadVerification: function (data) {
        return axios.post(`${QTurl}lead/upload-bulk-leads-ai-verification`, data);
    },
    // createBulkLeadVerification only kicks the job off (202 + jobId) - poll
    // this to find out when it's done and read back successful/failed/
    // duplicate rows.
    getBulkLeadVerificationJobStatus: function (jobId) {
        return axios.get(`${QTurl}lead/upload-bulk-leads-ai-verification/${jobId}`);
    },
    editMarketBudget: function (id, data) {
        return axios.put(`${QTurl}sourceOfLead/edit/${id}`, data);
    },
    addNewBudget: function (data) {
        return axios.post(`${QTurl}sourceOfLead/addBudget`, data);
    },
    getAllLeadData: function () {
        return axios.get(`${QTurl}lead`);
    },
    getStatusWiseLeadData: function (data) {
        if (data.hasOwnProperty("status") && data.status === undefined) {
            return axios.get(`${QTurl}lead/details/?startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("status") && data.status === 'NA') {
            return axios.get(`${QTurl}lead/details/?leadStatus=${data.leadStatus}&startDate=${data.startDate}&endDate=${data.endDate}&assignTo=${data.assignTo}&experienceCenterId=${data.experienceCenterId}&filterOption=${data.filterOption}`);
        } else if (data.hasOwnProperty("status") && data.status === 'salesuser') {
            return axios.get(`${QTurl}lead/details/?salesStage=${data.stageStatus}&startDate=${data.startDate}&endDate=${data.endDate}&assignTo=${data.assignTo}&experienceCenterId=${data.experienceCenterId}&filterOption=${data.filterOption}`);
        } else if (data.hasOwnProperty("status") && data.status === 'salesHead') {
            return axios.get(`${QTurl}lead/details/?salesStage=${data.stageStatus}&startDate=${data.startDate}&endDate=${data.endDate}&assignTo=${data.assignTo}&experienceCenterId=${data.experienceCenterId}&filterOption=${data.filterOption}&userRole=${data.status}`);
        } else if (data.hasOwnProperty("status") && data.status === 'Lead Received') {
            return axios.get(`${QTurl}lead/details/?salesStage=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("teamId")) {
            return axios.get(`${QTurl}lead/details/?startDate=${data.startDate}&endDate=${data.endDate}&teamId=${data.teamId}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("status") && data.status === 'Total-Leads-Generated') {
            return axios.get(`${QTurl}lead/details/?startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("status") && data.status === 'Leads-Assiged-(Stage-1)') {
            return axios.get(`${QTurl}lead/details/?salesStage=${data.salesStage}&assignTo=${data.assignTo}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("status") && data.status === 'Leads Pending Assignment' && data.isUserSelected === 'false') {
            return axios.get(`${QTurl}lead/details/?status=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}&isUser=${data.isUserSelected}&filterOption=${data.filterOption}`);
        } else if (data.hasOwnProperty("status") && data.status === 'Leads Pending Assignment' && data.isUserSelected === 'true') {
            return axios.get(`${QTurl}lead/details/?status=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}&selectedUser=${data.selectedUserList}&isUser=${data.isUserSelected}&filterOption=${data.filterOption}`);
        } else if (data.hasOwnProperty("leadRetunedBySales") && data.leadRetunedBySales === 'Lead Returned By Sales') {
            return axios.get(`${QTurl}lead/details/?status=${data.leadRetunedBySales}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("leadType")) {
            return axios.get(`${QTurl}lead/details/?leadType=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else {
            return axios.get(`${QTurl}lead/details/?leadType=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}`);
        }
    },
    // API for marketing inside pages data
    getMarketingStatusWiseData: function (data) {
        if (data.hasOwnProperty("type")) {
            return axios.get(`${QTurl}lead/marketingDetails/?leadType=${data.type}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("totalLead")) {
            return axios.get(`${QTurl}lead/marketingDetails/?startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("status")) {
            return axios.get(`${QTurl}lead/marketingDetails/?status=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        } else if (data.hasOwnProperty("teamId")) {
            return axios.get(`${QTurl}lead/marketingDetails/?teamId=${data.teamId}&startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
        }
    },

    getStageWiseLeadData: function (data) {
        if (data.startDate) {
            return axios.get(`${QTurl}lead/getStageWiseLeadData/?experienceCenterId=${data.experienceCenterId}&salesStage=${data.salesStage}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else {
            return axios.get(`${QTurl}lead/getStageWiseLeadData/?experienceCenterId=${data.experienceCenterId}&salesStage=${data.salesStage}`);
        }
    },
    getWonCustomerInOtherDeptList: function (data) {
        return axios.get(`${QTurl}lead/won-deals-other-dept/?experienceCenterId=${data.experienceCenterId}&filterOption=${data.selectedFilterOption}&startDate=${data.startDate}&endDate=${data.endDate}`);
    },
    getDesignerAssigmentLeadData: function (data) {
        if (data.option === 'user') {
            return axios.get(`${QTurl}lead/details/?assignTo=${data.assignTo}&salesStage=${data.salesStage}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else if (data.option === 'sales') {
            return axios.get(`${QTurl}lead/details/?experienceCenterId=${data.experienceCenterId}&assignTo=${data.assignTo}&salesStage=${data.salesStage}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else if (data.option === 'designHead') {
            return axios.get(`${QTurl}lead/details/?experienceCenterId=${data.experienceCenterId}&designHeadAssigned=${data.designHeadAssigned}&startDate=${data.startDate}&endDate=${data.endDate}&asUser=${data.option}`);
            // return axios.get(`${QTurl}lead/details/?experienceCenterId=${data.experienceCenterId}&assignTo=${data.assignTo}&designHeadAssigned=${data.designHeadAssigned}&startDate=${data.startDate}&endDate=${data.endDate}&asUser=${data.option}`); // Enable if need to show that lead moved to design stage
        } else if (data.option === 'team' && data.isUserSelected === "false") {
            return axios.get(`${QTurl}lead/details/?experienceCenterId=${data.experienceCenterId}&teamId=${data.teamId}&isUser=${data.isUserSelected}&salesStage=${data.salesStage}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else {
            return axios.get(`${QTurl}lead/details/?experienceCenterId=${data.experienceCenterId}&teamId=${data.teamId}&isUser=${data.isUserSelected}&selectedUser=${data.selectedUserList}&salesStage=${data.salesStage}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        }

    },
    getAchivedVsTargetList: function (data) {
        if (data.currentSelecredRole === 'Sales Head') {
            return axios.get(`${QTurl}lead/targetAchivedVsTarget/?experienceCenterId=${data.experienceCenterId}&departmentId=${data.userInfo}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else if (data.currentSelecredRole === 'Sales Manager') {
            return axios.get(`${QTurl}lead/targetAchivedVsTarget/?experienceCenterId=${data.experienceCenterId}&teamId=${data.userInfo}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else if (data.currentSelecredRole === 'Assistant Sales Manager') {
            return axios.get(`${QTurl}lead/targetAchivedVsTarget/?experienceCenterId=${data.experienceCenterId}&teamId=${data.userInfo}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        } else if (data.currentSelecredRole === 'Sales User') {
            return axios.get(`${QTurl}lead/targetAchivedVsTarget/?experienceCenterId=${data.experienceCenterId}&assignTo=${data.userInfo}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
        }
    },
    getDesignLeads :function(data)
    {
        return axios.put(`${QTurl}lead/getDesignLeads`, data);
    },
    getContractLeads :function(data)
    {
        return axios.put(`${QTurl}lead/getContractLeads`, data);
    },
    getLeadsOnSelectedDate: function (data) {
        return axios.get(`${QTurl}lead/?startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.experienceCenterId}`);
    },
    getMargetingTargetCount: function () {
        return axios.get(`${QTurl}marketingtarget`);
    },
    getFilterWiseLeadData: function (data) {
        return axios.put(`${QTurl}lead/filter`, data);
    },
    userTarget: function (year, team) {
        return axios.get(`${QTurl}target/all?year=${year}&teamId=${team}`);
    },
    editTarget: function (id, data) {
        return axios.put(`${QTurl}target/edit/${id}`, data);
    },
    newTarget: function (data) {
        return axios.post(`${QTurl}target/new`, data);
    },
    getAllSalesLeadData: function () {
        return axios.get(`${QTurl}lead/sales`);
    },
    getSalesLeadOnSelectedDate: function (data) {
        return axios.get(`${QTurl}lead/sales/?experienceCenterId=${data.experienceCenterId}&startDate=${data.startDate}&endDate=${data.endDate}&filterOption=${data.filterOption}`);
    },
    getAllCustomer: function () {
        return axios.get(`${QTurl}customer/all`);
    },
    editCustomer: function (id, data) {
        return axios.put(`${QTurl}customer/edit/${id}`, data);
    },
    reminderLogs: function (data) {
        return axios.put(`${QTurl}leadLog/remindersOfDate`, data);
    },
    // updateRevisedProjectedDesignSignOffDate: function (revisedProjectedDesignSignOffDate, projectId) {
    //     return axios.put(`${QTurl}lead/updateRevisedProjectedDesignSignOffDate/${projectId}`, revisedProjectedDesignSignOffDate);
    // },
    // uploadPaymentAttachment: function (obj, projectId) {
    //     return axios.put(`${QTurl}lead/uploadPaymentAttachment/${projectId}`, obj);
    // },
    getAllClosureLead: function (salesStage) {
        return axios.get(`${QTurl}lead/details/?salesStage=${salesStage}`);
    },
    departmentManagers: function (deptId) {
        return axios.get(`${QTurl}user/managerOfDepartment/${deptId}`);
    },
    updateLeadStageStatus: function (leadstatus, leadid) {
        return axios.put(`${QTurl}lead/updateLeadStageStatus/${leadid}`, leadstatus);
    },
    updateAgainDesignHold: function (leadstatus, leadid) {
        return axios.put(`${QTurl}lead/updateAgainDesignHold/${leadid}`, leadstatus);
    },
    updateChmUser: function (data) {
        return axios.put(`${QTurl}lead/updateChmUser`, data)
    },
    updateExpectedDesignSignOffDate: function (designSignOff, projectId) {
        return axios.put(`${QTurl}lead/updateExpectedDesignSignOffDate/${projectId}`, designSignOff);
    },

    updateExpectedSalesClosureDate: function (obj, projectId) {
        return axios.put(`${QTurl}lead/updateExpectedSalesClosureDate/${projectId}`, obj);
    },

    updateLead: function (leadid, leadstage) {
        return axios.put(`${QTurl}lead/updateLead/${leadid}`, leadstage);
    },

    updateLeadDetails: function (data) {
        return axios.put(`${QTurl}lead/updateLeadDetails`, data);
    },

    updateTicketDetails: function (data) {
        return axios.put(`${QTurl}chmTicket/updateTicketDetails`, data);
    },
    leadWonRejection: function (leadid, obj) {
        return axios.put(`${QTurl}lead/leadWonRejection/${leadid}`, obj);
    },
    customerActions: function (leadid, leadstage) {
        return axios.put(`${QTurl}user/updateLead/${leadid}`, leadstage);
    },
    salesManagersApprovedLead: function (leadid, data) {
        return axios.put(`${QTurl}lead/salesManagersApprovedLead/${leadid}`, data);
    },
    urgentRequestAction: function (data) {
        return axios.put(`${QTurl}lead/urgentRequestHandler`, data);
    },
    createNewProjectForAdditionalQuotation: function (data) {
        return axios.post(`${QTurl}project/new`, data)
    },
    getDesginManagersUserList: function (designManager) {
        return axios.get(`${QTurl}user/getDesginManagersUserList/${designManager}`);
    },
    assignLeadToDesginUser: function (leadid, data) {
        return axios.put(`${QTurl}lead/assignLeadToDesginUser/${leadid}`, data);
    },
    sendOtpMessage: function (data) {
        return axios.post(`${QTurl}user/sendOtpMessage`, data)
    },
    sendOtpAccordingToContactTypeEmailOrMobile: function (data) {
        return axios.post(`${QTurl}user/sendOtpAccordingToContactTypeEmailOrMobile`, data)
    },
    sendHandoverCompletionOtp: function (data) {
        return axios.post(`${QTurl}user/sendHandoverCompletionOtp`, data)
    },
    approveCustomerCheckList: function (leadid, data) {
        return axios.put(`${QTurl}lead/approveCustomerCheckList/${leadid}`, data);
    },
    createDesignMom: function (data)
    {
        return axios.post(`${QTurl}lead/createDesignMom`, data)
    },
    creteLeadCriteria: function (data) {
        return axios.post(`${QTurl}lead/lead-criteria`, data);
    },
    getLocationRateCardMasterList: function (locationId) {
        return axios.get(`${QTurl}rate-card-master/${locationId}`)
    },
   
getLocationList: async function () {
    try {
        const token = localStorage.getItem("TOKEN_KEY");
        if (!token) {
            console.warn("No token found in localStorage.");
            return null;
        }

        // Check cache
        const compressedData = localStorage.getItem("locationListCache");
        const cacheTimestamp = localStorage.getItem("locationListCacheTimestamp");

        if (compressedData && cacheTimestamp && (Date.now() - cacheTimestamp < cacheLifetime)) {
            console.log("Returning cached location list from localStorage.");
            return JSON.parse(LZString.decompress(compressedData));
        }

        console.log("Cache expired or empty. Fetching new data...");

        // Fetch new data
        const response = await axios.get(`${QTurl}location`);
        console.log("API response received:", response);

        // Compress and store in localStorage
        const compressedResponse = LZString.compress(JSON.stringify(response));
        localStorage.setItem("locationListCache", compressedResponse);
        localStorage.setItem("locationListCacheTimestamp", Date.now());

        return response;

    } catch (error) {
        console.error("Error fetching location list:", error.message);

        // Return cached data if API fails
        const fallbackData = localStorage.getItem("locationListCache");
        if (fallbackData) {
            console.warn("Returning stale cache data due to API failure.");
            return JSON.parse(LZString.decompress(fallbackData));
        }

        return null;
    }
},

getExpericenCenters: async function () {
    console.log("getExpericenCenters function called");

    try {
        // alert(1024 * 1024 * 5 - unescape(encodeURIComponent(JSON.stringify(localStorage))).length);
        // Check if the token exists in localStorage
        const token = localStorage.getItem("TOKEN_KEY");
        if (!token) {
            console.warn("No token found in localStorage.");
            return null;
        }

        // Get cached data from localStorage
        const compressedData = localStorage.getItem("experienceCentersCache");
        const cacheTimestamp = localStorage.getItem("experienceCentersCacheTimestamp");

        if (compressedData && cacheTimestamp && (Date.now() - cacheTimestamp < cacheLifetime)) {
            console.log("Returning cached experience centers from localStorage.");
            
            // Decompress and parse the cached data
            const decompressedData = JSON.parse(LZString.decompress(compressedData));
            return decompressedData;
        }

        console.log("Cache expired or empty. Fetching new data...");

        // Fetch new data from API
        const response = await axios.get(`${QTurl}experience-center`);
        console.log("API response received:", response);

        // Compress data before storing in localStorage
        const compressedResponse = LZString.compress(JSON.stringify(response));
        localStorage.setItem("experienceCentersCache", compressedResponse);
        localStorage.setItem("experienceCentersCacheTimestamp", Date.now());

        return response;
    
    } catch (error) {
        console.error("Error fetching experience centers:", error.message);

        // If API fails, return cached data if available
        const fallbackData = localStorage.getItem("experienceCentersCache");
        if (fallbackData) {
            console.warn("Returning stale cache data due to API failure.");
            return JSON.parse(LZString.decompress(fallbackData));
        }

        return null;
    }
},
    getAllExpCenter : function () {
        return axios.get(`${QTurl}customerServey/allExpCenterDetails`);
    },
    getExpericenCentersByLocation: function (locationId) {
        return axios.get(`${QTurl}experience-center/${locationId}`);
    },
    deleteLeadConfirm: function (leadData) {
        return axios.put(`${QTurl}lead/deleteLeadConfirm/${leadData}`)
    },
    addLocation: function (name) {
        return axios.post(`${QTurl}location`, name)
    },
    getLocation: function () {
        return axios.get(`${QTurl}location`)
    },
    updateLocation: function (id, data) {
        return axios.put(`${QTurl}location/${id}`, data)
    },
    deleteLocation: function (id) {
        return axios.delete(`${QTurl}location/${id}`)
    },
    addExperinceCenter: function (data) {
        return axios.post(`${QTurl}experience-center`, data)
    },
    getExperinceCenter: function () {
        return axios.get(`${QTurl}experience-center`)
    },
    updateExperinceCenter: function (id, data) {
        return axios.put(`${QTurl}experience-center/${id}`, data)
    },
    deleteExperinceCenter: function (id) {
        return axios.delete(`${QTurl}experience-center/${id}`)
    },
    getApprovedLeadLists: function (expCenterId) {
        return axios.get(`${QTurl}lead/getApprovedLeadLists/?experienceCenterId=${expCenterId}`)
    },
    getDesignData: function (data) {
        return axios.get(`${QTurl}lead/design/?startDate=${data.startDate}&endDate=${data.endDate}&experienceCenterId=${data.expcenterId}`);
    },
    getDesignDataForContract: function (data, expCtr) {
        return axios.put(`${QTurl}lead/getDesignDataForContract/?experienceCenterId=${expCtr}`, {data});
    },
    saveProjectDetails: function (leadId, data) {
        return axios.put(`${QTurl}lead/edit/${leadId}`, data)
    },
    saveProjectEditAddress :  function (leadId, data) {
        return axios.put(`${QTurl}lead/edit-address/${leadId}`, data)
    },
    getAllUsers: function () {
        return axios.get(`${QTurl}user/all`)
    },
    updateOrgRateCardMaterial: function (rateCardId, data) {
        return axios.put(`${QTurl}org-rate-card/editProductInOrgRateCard/${rateCardId}`, data)
    },
    addOrgRateCardMaterial: function (rateCardId, data) {
        return axios.put(`${QTurl}org-rate-card/addProductInOrgRateCard/${rateCardId}`, data)
    },
    inActiveProduct(id, data) {
        return axios.put(`${QTurl}org-rate-card/deactivate/${id}`, data)
    },
    isComplimentaryItem(id, data) {
      return axios.put(`${QTurl}org-rate-card/isComplimentaryItem/${id}`, data)
    },
    remapMaterials: function (data, projectId) {
        if (projectId)
            return axios.put(`${Apiurl}project-material/bom-material/remap-material?projectId=${projectId}`, data)
        return axios.put(`${Apiurl}project-material/bom-material/remap-material`, data)
    },
    sendMaterialForApproval: function (materialId) {
        return axios.put(`${Apiurl}project-material/bom/send-for-approval/${materialId}`)
    },
    getMaterialsForApproval: function () {
        return axios.get(`${Apiurl}project-material/bom-material-for-approval`)
    },
    approveMaterial: function (materialId) {
        return axios.put(`${Apiurl}materialMaster/materials/approve-materials/${materialId}`)
    },
    inActiveUser: function (userId) {
        let data = '';
        return axios.put(`${QTurl}user/deactivate/${userId}`, data)
    },
    deactivateTeam: function (teamId) {
        let data = '';
        return axios.put(`${QTurl}team/deactivate/${teamId}`, data)
    },
    sendRequrestToFinanceAndDesgin: function (leadId, data) {
        return axios.put(`${QTurl}lead/designToExecutionFlow/${leadId}`, data)
    },
    getDesignToFinanceLeadApprovalLeadList: function (expcenter) {
        return axios.get(`${QTurl}lead/designToExecutionLogs/${expcenter}`)
    },
    updateDesignToFinanceLeadApprovalStatus: function (leadId, data) {
        return axios.put(`${QTurl}lead/designToExecutionLogs/${leadId}`, data)
    },
    updateDesignToFinanceLeadRejectStatus: function (leadId, data) {
        return axios.put(`${QTurl}lead/designToExecutionRejectLogs/${leadId}`, data)
    },
    customerContractSingActions: function (leadid, data) {
        return axios.put(`${QTurl}user/updateCustomerContractSingedStatus/${leadid}`, data);
    },
    getAllContractSignedLeads: function (expcenter) {
        return axios.get(`${QTurl}lead/contractApprovedLeads/${expcenter}`)
    },
    getAllQuotationsSingleProject(quotationno) {
        return axios.get(`${QTurl}quotation/customerquote/${quotationno}`)
    },
    customerQuotationsActions: function (leadid, data) {
        return axios.put(`${QTurl}user/updatecustomerQuotationsActions/${leadid}`, data);
    },
    CustomerPrivewQuotationView(leadId) {
        return axios.get(`${QTurl}lead/CustomerPrivewQuotationView/${leadId}`)
    },
    reinstate(leadId, obj) {
        return axios.put(`${QTurl}lead/reinstateProcess/${leadId}`, obj)
    },
    cloneSelectedQuotation: function (cloneData) {
        return axios.get(`${QTurl}quotation/cloneSelectedQuotation/?versionId=${cloneData.versionId}&leadId=${cloneData.leadId}&lastVersion=${cloneData.lastVersionNo}`)
    },
    getMaskedQuotation: function (quotationId) {
        return axios.get(`${QTurl}quotation/getMaskedQuotation/${quotationId}`)
    },
    submitSurveyForm: function (data) {
        return axios.post(`${QTurl}customerServey/addCustomerSurvey`, data)
    },
    getSurveyFormList: function (type, obj) {
        if (obj.experienceCenterId) return axios.get(`${QTurl}customerServey/getCustomerSurveyList/?typeOption=${type}&experienceCenterId=${obj.experienceCenterId}&page=${obj.page}&limit=${obj.limit}`);
        return axios.get(`${QTurl}customerServey/getCustomerSurveyList/?typeOption=${type}&page=${obj.page}&limit=${obj.limit}`);
    },
    findExistingCustomerSurveyLead: function (leadId, type) {
        return axios.get(`${QTurl}customerServey/checkCustomerSurveyByLead/?leadId=${leadId}&typeOption=${type}`);
    },

    getSalesDataBasedOnExpCenterForSalesGroup:  function (data) {
        return axios.get(`${QTurl}leadJourney/dataBasedexpCenterBasedDataForGroup?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}&groupId=${data.groupId}`)
    },
    getSalesDataBasedOnExpCenterForSalesGroupForCustomer:  function (data) {
        return axios.get(`${QTurl}leadJourney/dataBasedexpCenterBasedDataForGroupForCustomer?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}&groupId=${data.groupId}`)
    },
    getAllMangers: function () {
        return axios.get(`${QTurl}user/getallManagersData`);
    }, allRateCardsMaster: function () {
        return axios.get(`${QTurl}rate-card-master/masterRateCardData`)
    },
    update_project_rate_card: function (obj) {
        return axios.get(`${QTurl}rate-card-master/update_project_rate_card/?leadId=${obj.leadId}&rateCardId=${obj.rateCardId}`)
    },
    getDefaultProjectRateCardMaster: function (selectedLeadId) {
        return axios.get(`${QTurl}project-rate-card-master/getDefaultProjectRateCardMaster/?leadId=${selectedLeadId}`)
    },
    getCheckList() {
        return axios.get(`${QTurl}checklist`)
    },
    addCheckList(data) {
        return axios.post(`${QTurl}checklist`, data)
    },
    editCheckList(id, data) {
        return axios.put(`${QTurl}checklist/update/${id}`, data)
    },
    getAllFinalPaymentApproveRequest(type) {
        return axios.get(`${QTurl}lead/getFinalPayments?stageType=${type}`)
    },
    updateFinalPaymentStatus(id, data) {
        return axios.put(`${QTurl}lead/updateFinalPaymentStatus/${id}`, data)
    },
    updateDesignerPaymentStatus(id, data) {
        return axios.put(`${QTurl}lead/updateDesignerPaymentStatus/${id}`, data)
    },
    rejectContractSignedDocument(leadId, data) {
        return axios.put(`${QTurl}lead/rejectContractSignedDocuments/${leadId}`, data)
    },
    getDesignUserByTeam(teamId) {
        return axios.get(`${QTurl}user/getTeamUser?teamId=${teamId}`)
    },
    updateDesignerAssignementDetail: function (leadid, data) {
        return axios.put(`${QTurl}lead/updateDesignerAssignementDetail/${leadid}`, data);
    },
    getCHMLeadLists: function (data) {
        return axios.put(`${QTurl}chmleads/getData`,data)
    },
    getChmUser: function () {
        return axios.get(`${QTurl}chmleads/getAllChmUsers`)
    },
    get_chm_lead_counts: function (expcenter) {
        return axios.get(`${QTurl}chmleads/chm_lead_counts/${expcenter}`)
    },
    get_sales_statistics_data: function (query) {
        return axios.put(`${QTurl}lead/sales_statistics`,query)
    },
    moveLeadToFactory: function (data) {
        return axios.put(`${QTurl}lead/moveLeadToFactory/${data.leadId}`, data)
    },
    getSiteQcDocument: function (leadId) {
        return axios.put(`${QTurl}lead/getSiteQcDocument/${leadId}`)
    },
    extraDaysDuetoClientDependency: function (leadid,obj) {
        return axios.put(`${QTurl}lead/extraDaysDuetoClientDependency/${leadid}`,obj);
    },
    getDetailsOfImosProject: function(leadid) {
        return axios.get(`${QTurl}imosProjects/getDetailsOfImosProject/${leadid}`);
    },
    filteredSurveyFormList: function (type, obj) {
        return axios.get(`${QTurl}customerServey/filteredCustomerSurveyList/?typeOption=${type}&selectedLocation=${obj.selectedLocation}&startDate=${obj.startDate}&endDate=${obj.endDate}&experienceCenterId=${obj.experienceCenterId}&customerId=${obj.customerId}&page=${obj.page}&limit=${obj.limit}&searchType=${obj.searchType}&search=${obj.search}&selectUserId=${obj.selectUserId}&dateFilterType=${obj.dateFilterType}`);
    },
    removeMtr: function (mtrId) {
        return axios.delete(`${Apiurl}material-transfer/removeMtr/${mtrId}`)
    },
    removePO: function (poId) {
        return axios.delete(`${Apiurl}procurement/removePO/${poId}`)
    },removeSo: function ( soId) {
        return axios.delete(`${Apiurl}finance/removeSo/${soId}`)
    },
    siteBomcomplted: function (leadId) {
        return axios.put(`${QTurl}siteBomProject/siteBomcomplted/${leadId}`)
    },
    getTeamsBasedOnTeamId:function(teamId){
        return axios.get(`${QTurl}Team/getTeamofUser/${teamId}`)
    },
    UpdateExecutionUser: function (leadId,obj) {
        return axios.put(`${QTurl}lead/assignLeadToExecutionUsers/${leadId}`,obj)
    },
    getTheVendorSOManage:function(data){
        return axios.get(`${Apiurl}vendorAssignmentLeads/getProjectsSoData/?user=${data}`)
    },
    getVendorSoExecutives: function () {
        return axios.get(`${QTurl}vendorAssignmentLeads/getVendorRoleBasedUsers`);
    },
    updateVendorSoExecutive: function (VendorSoId,assignTo) {
        return axios.put(`${QTurl}vendorAssignmentLeads/assignVendorExcutive/${VendorSoId}/?user=${assignTo}`);
    },
    floorPlanUpdate:function (leadid,obj) {
        return axios.put(`${QTurl}lead/floorPlanUpdate/${leadid}?floorPlanAttachment=${obj}`,obj);
    },

    // Getting Exp Centre wise data for Statistics Dashboard based on stages "Sales", "Design", "Material Delivery", "Completed" 
    getExpCenterBasedData: function (data) {
        return axios.get(`${QTurl}lead/expCenterBasedData?stage=${data.stage}&startDate=${data.startDate}&endDate=${data.endDate}&leadStatus=${data?.leadStatus}&tokenValue=${data.tokenValue}`);
    },

    // Getting Sales Data, Sales Manager & Sales User wise
    getSalesUsersAndManagersBasedData: function (startDate,endDate,leadStatus,tokenValue) {
        return axios.get(`${QTurl}lead/salesUsersAndManagersBasedData?startDate=${startDate}&endDate=${endDate}&leadStatus=${leadStatus}&tokenValue=${tokenValue}`);
    },

    // Getting Design Data, Design Manager & Design User wise
    getDesignUsersAndManagersBasedData: function (startDate,endDate,leadStatus,tokenValue) {
        return axios.get(`${QTurl}lead/designUsersAndManagersBasedData?startDate=${startDate}&endDate=${endDate}&leadStatus=${leadStatus}&tokenValue=${tokenValue}`);
    },

    // Getting Data Based On Click On Count/Value of the table of Statistics
    getDataBasedOnQuery: function (data) {
        return axios.put(`${QTurl}lead/sendDataBasedOnQuery`,data);
    },

    // Getting Modular delivery data for for factory review sheet based on locations
    getMaterialDeliveryCityWise: function (data) {
        return axios.get(`${QTurl}lead/getMaterialDeliveryCityWise?startDate=${data.startDate}&endDate=${data.endDate}&searchType=${data.searchType}&search=${data.search}`);
    },

    // Getting data for factory review sheet which under execution
    getUnderExecutionDataCityWise: function (data) {
        return axios.get(`${QTurl}lead/getUnderExecutionDataCityWise?startDate=${data.startDate}&endDate=${data.endDate}&searchType=${data.searchType}&search=${data.search}`);
    },
    // Getting Project Completion data for factory review sheet 
    getProjectCompletionDataCityWise: function (data) {
        return axios.get(`${QTurl}lead/getProjectCompletionDataCityWise?startDate=${data.startDate}&endDate=${data.endDate}&searchType=${data.searchType}&search=${data.search}`);
    },

    // Getting Completed MWP data for factory review sheet
    getCompletedMWPDataUserWise: function (data) {
        return axios.get(`${QTurl}lead/getCompleted-MWPDataUserWise?searchType=${data.searchType}&search=${data.search}&cityId=${data.cityId}`);
    },
    
    // Getting Completed Project data User - Wise for factory review sheet
    getProjectCompletionDataUserWise: function (data) {
        return axios.get(`${QTurl}lead/getProjectCompletionDataUserWise?searchType=${data.searchType}&search=${data.search}`);
    },

    // Getting Factory Manager data for factory review sheet
    getFactoryStageData: function (data) {
        let url = `${QTurl}lead/getFactoryStageData?searchType=${data.searchType}&search=${data.search}`;
        if (data.startDate && data.endDate) {
            url += `&startDate=${data.startDate}&endDate=${data.endDate}`;
        }
        return axios.get(url);
    },

    // Getting Factory Manager data for factory review sheet
    getDataForOps1Tab: function (data) {
        return axios.get(`${QTurl}lead/getDataForOps1Tab?searchType=${data.searchType}&search=${data.search}`);
    },

    getPopaymentreq:function () {
        return axios.get(`${Apiurl}procurement/payment-approver-request`);
    },
    getSopaymentreq:function () {
        return axios.get(`${Apiurl}serviceOrder/payment-approver-request`);
    },
    getSelectedExpCenterDetails:function(experienceCenter){
        return axios.get(`${QTurl}experience-center/experienceCenterDetails?experienceCenter=${experienceCenter}`)
    },
    createTransactionPineLabs:function(obj){
        return axios.post(`${QTurl}paymentTransactions/createTransaction`,obj)
    },
    addTransactionPineLabs:function(obj){
        return axios.post(`${QTurl}paymentTransactions/addTransactionData`,obj)
    },
    cancelTransactionPineLabs:function(obj){
        // console.log('obj in http', obj)
        return axios.post(`${QTurl}paymentTransactions/cancelTranscation`,obj)
    },
    knowTransactionsNoforLead : function (leadId){
        return axios.get(`${QTurl}paymentTransactions/knowTransactionsNoforLead/${leadId}`)
    },
    checkTrxIdExists : function (trxId){
        return axios.get(`${QTurl}paymentTransactions/checkTrxIdExists?trxId=${encodeURIComponent(trxId)}`)
    },
    checkChequeNoExists : function (cheQueNo){
        return axios.get(`${QTurl}paymentTransactions/checkChequeNoExists?cheQueNo=${encodeURIComponent(cheQueNo)}`)
    },

    // Function to get approved payments data
    fetchApprovedPaymentsData: function (payload) {
        return axios.get(`${QTurl}paymentTransactions/fetch-approved-payments-data?startDate=${payload.startDate}&endDate=${payload.endDate}&page=${payload.page}&rowsPerPage=${payload.rowsPerPage}`)
    },
    
    // Function to add receipt date by reference number
    addReceiptDateByReference: function (payload) {
        return axios.put(`${QTurl}paymentTransactions/add-receipt-date-by-reference`, payload)
    }, 
    
    // Function to add receipt date by approval code for card pine labs
    addBankReceiptDateByAppCode: function (payload) {
        return axios.put(`${QTurl}paymentTransactions/add-bank-receipt-date-for-card-pinelabs-by-approval-code`, payload)
    },
    sendRequestForLink : function (leadId){
        return axios.put(`${QTurl}lead/sendRequestForLink/${leadId}`)
    },
    getThePaymentRequestDetails :function (expCenter){
        return axios.get(`${QTurl}lead/getThePaymentRequestDetails/${expCenter}`)  
    },
    updateRequestForLink : function (leadId,status){
        return axios.put(`${QTurl}lead/updateRequestForLink/${leadId}/?status=${status}`)
    },
    addOtherTransaction : function (data){
        return axios.post(`${QTurl}paymentTransactions/addOtherTransaction`, data)
    },
    updateFinancePaymentAction : function (data){
        return axios.put(`${QTurl}paymentTransactions/updateFinancePaymentAction`, data)
    },
    approveManualPayment : function (data){
        return axios.put(`${QTurl}paymentTransactions/approveManualPayment`, data)
    },
    // api function to approve/reject automatic payment
    approveAutomaticPayment : function (data){
        return axios.put(`${QTurl}paymentTransactions/approveAutomaticPayment`, data)
    },
    editPaymentTransaction : function (data){
        return axios.put(`${QTurl}paymentTransactions/editPaymentTransaction`, data)
    },
    updateFinan : function (data){
        return axios.post(`${QTurl}paymentTransactions/addOtherTransaction`, data)
    },
    getAllPaymentModes : function (){
        // console.log('http called')
        return axios.get(`${QTurl}paymentModes/getAllPaymentModes`)
    },
    getSelectedUsersBasedOnRolesForSurveyForms: function (data) {
        return axios.get(`${QTurl}user/usersOfDepartment/${data}`);
    },
    addPaymentMode : function (data){
        // console.log('http called')
        return axios.post(`${QTurl}paymentModes/addPaymentMode`, data)
    },
    updatePaymentMode : function (data){
        // console.log('http called')
        return axios.post(`${QTurl}paymentModes/updatePaymentMode`, data)
    },
    leadUpdateMeeting:function (data) {
        return axios.post(`${QTurl}assignTo/leadUpdateMeeting`, data);
    },
    getDataForMeetingTracket: function (data) {
        return axios.post(`${QTurl}leadLog/getMeetingDetails?leadId=${data}`)
    },
    updateMeetingLogs: function (data) {
        return axios.post(`${QTurl}assignTo/updateMeetingLogs`, data);
    },
    paymentpatners : function (){
        return axios.get(`${QTurl}paymentPatners/getpaymentPatners`)
    },
    // cashFreePaymentUpload : function (leadId,data){
    //     return axios.post(`${QTurl}paymentTransactions/cashFreeTransactionCreate/${leadId}`,data)
    // },
    phopePePaymentUpload : function (leadId,data){
        return axios.post(`${QTurl}paymentTransactions/phonePeTransactionCreate/${leadId}`,data)
    },
    getSalesDesginUserDetail : function (){
        return axios.get(`${QTurl}paymentPatners/getSalesDesginUserDetail`)
    },
    getDataforSentforFinanceApproval:function(){
        return axios.get(`${Apiurl}procurement/getDataforSentforFinanceApproval`);   
    },
    updateFinanceStatus:function (data){
        return axios.put(`${Apiurl}inwardingApprovals/updateFinanceStatus`,data);
    },

    // Endpoint to Approve all inwarding all at once
    approveAllInwardingsBatch: function (data) {
        return axios.put(`${Apiurl}inwardingApprovals/inwarding-approvals/approve-bulk-inwardings`, data);
    },
    
    getAllMaterialsStockAndMoq: function (type) {
        return axios.get(`${Apiurl}materialMaster/materials/allMaterialsStockAndMoq/?type=${type}`)
    },
    getAllMaterialsNameAndCode: function() {
        return axios.get(`${Apiurl}materialMaster/materials/allMaterialsNameAndCode`)
    },
    getSelectedSearchMaterialData: function(data){
        return axios.post(`${Apiurl}materialMaster/materials/selectedSearchMaterialData`,data)
    },
    getAllProcurementsForInwardingPaginated: function (code, type,page,limit) {
        if (code)
            return axios.get(`${Apiurl}procurement/getAllProcurementsForInwardingPaginated?projectCode=${code}`)
        return axios.get(`${Apiurl}procurement/getAllProcurementsForInwardingPaginated?procurementType=${type}&page=${page}&limit=${limit}`)
    },
    getLeadsCreated: function (data) {
        return axios.get(`${QTurl}leadJourney/marketingDashboard?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&selectedSourceOfLead=${data.selectedSourceOfLead}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&moveToMarketing=${data.moveToMarketing}&lostPostMeeting=${data.lostPostMeeting}&salesWon=${data.salesWon}&designWon=${data.designWon}&completion=${data.completion}&selectedLeadMode=${data.selectedLeadMode}`)
    },
    getLeadSourceTypeBookings: function (data) {
        return axios.get(`${QTurl}leadJourney/lead-source-type-booking-report?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}`)
    },
    getSourceOfLeadsDashboard: function (data) {
        return axios.get(`${QTurl}leadJourney/sourceOfLeadMarketingDashboard?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&moveToMarketing=${data.moveToMarketing}&selectedLeadMode=${data.selectedLeadMode}`)
    },
    getSalesDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/dataBasedexpCenterBasedData?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    // getDesignSignOffDataBasedOnExpCenter: function (data) {
    //     return axios.get(`${QTurl}leadJourney/dataBasedexpCenterBasedData?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}`)
    // },
    overallMISDashBoard: function (data) {
        return axios.get(`${QTurl}leadJourney/overallMISDashboard?startDate=${data.startDate}&endDate=${data.endDate}&token=${data.tokenPercentage}&searchType=${data.searchType}&search=${data.search}`)
    },
    overallReviewDashBoard: function (data) {
        return axios.put(`${QTurl}leadJourney/overallReview?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}`, data)
    },
    internalDSOSummaryDashboard: function (data) {
        return axios.get(`${QTurl}internalDesignSignOff/internalDSOSummary?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    overallSummaryDashBoard: function (data) {
        return axios.get(`${QTurl}leadJourney/overallSummary?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&department=${data.department}&searchType=${data.searchType}&search=${data.search}`)
    },
    designStageDaysSummary: function (data) {
        return axios.get(`${QTurl}leadJourney/designStageDaysSummary?startDate=${data.startDate || ''}&endDate=${data.endDate || ''}&selectedExperienceCenter=${data.selectedExperienceCenter || ''}&selectedLocation=${data.selectedLocation || ''}&token=${data.token || data.tokenPercentage || ''}&users=${data.users || ''}&selectedRole=${data.selectedRole || ''}&userExpCenter=${data.userExpCenter || ''}&userLocation=${data.userLocation || ''}&searchType=${data.searchType || ''}&search=${data.search || ''}`)
    },
    designStageDaysDetails: function (data) {
        return axios.put(`${QTurl}leadJourney/designStageDaysDetails`, data);
    },
    designKickOffCustomerDaysSummary: function (data) {
        return axios.get(`${QTurl}leadJourney/designKickOffCustomerDaysSummary?startDate=${data.startDate || ''}&endDate=${data.endDate || ''}&selectedExperienceCenter=${data.selectedExperienceCenter || ''}&selectedLocation=${data.selectedLocation || ''}&token=${data.token || data.tokenPercentage || ''}&users=${data.users || ''}&selectedRole=${data.selectedRole || ''}&userExpCenter=${data.userExpCenter || ''}&userLocation=${data.userLocation || ''}&searchType=${data.searchType || ''}&search=${data.search || ''}`)
    },
    designKickOffCustomerDaysDetails: function (data) {
        return axios.put(`${QTurl}leadJourney/designKickOffCustomerDaysDetails`, data);
    },
    designKickOffInternalDaysSummary: function (data) {
        return axios.get(`${QTurl}leadJourney/designKickOffInternalDaysSummary?startDate=${data.startDate || ''}&endDate=${data.endDate || ''}&selectedExperienceCenter=${data.selectedExperienceCenter || ''}&selectedLocation=${data.selectedLocation || ''}&token=${data.token || data.tokenPercentage || ''}&users=${data.users || ''}&selectedRole=${data.selectedRole || ''}&userExpCenter=${data.userExpCenter || ''}&userLocation=${data.userLocation || ''}&searchType=${data.searchType || ''}&search=${data.search || ''}`)
    },
    designKickOffInternalDaysDetails: function (data) {
        return axios.put(`${QTurl}leadJourney/designKickOffInternalDaysDetails`, data);
    },
    opsReview: function (data) {
        return axios.get(`${QTurl}opsReviewDashboard/opsReview?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&users=${data.users}&selectedRole=${data.selectedRole}&selectedMonths=${data.selectedMonths}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    admSummary: function (data) {
        return axios.get(`${QTurl}opsReviewDashboard/summaryOfADMs?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&users=${data.users}&selectedRole=${data.selectedRole}&selectedMonths=${data.selectedMonths}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    monthlyContractReviewDashBoard: function (data) {
        return axios.get(`${QTurl}monthlyContract/monthlyContractReview?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&users=${data.users}&selectedRole=${data.selectedRole}&selectedMonths=${data.selectedMonths}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    lostDataAnalysis: function (data) {
        return axios.get(`${QTurl}leadJourney/lostDataAnalysis?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&department=${data.department}&searchType=${data.searchType}&search=${data.search}`)
    },
    getSalesDatoverallReviewDashBoard: function (data) {
        return axios.put(`${QTurl}leadJourney/salesOverallReview?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&lost=${data.lost}`,data)
    },
    getSelectedUsersBasedOnRoles: function (data) {
        return axios.get(`${QTurl}leadJourney/SelectedusersBasedOnRole?roleName=${data.role}&pivotValue=${data.pivotValue}`)
    },
    getDataBasedClickOverallMIS: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickOverallMIS`, data)
    },
    getDataBasedClickSourceOfLead: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickSourceOfLead`, data)
    },
    getDataBasedClickOverallSummary: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickOverallSummary`, data)
    },
    getDataBasedClickMonthlyContractReview: function (data) {
        return axios.put(`${QTurl}monthlyContract/getDataBasedClickMonthlyContractReview`, data)
    },
    getDataBasedClickOveralReview: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickOveralReview`, data)
    },
    getDataBasedClickMarketing: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickMarketing`, data)
    },
    getDataBasedClickSales: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickSales`, data)
    },
    // getDataBasedClickDesignSignOff: function (data) {
    //     return axios.put(`${QTurl}leadJourney/getDataBasedClickSales`, data)
    // },
    getDataBasedClickSalesOverview: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickSalesOverview`, data)
    },
    getDataBasedClickLost: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickLost`, data)
    },
    addCustomersToErp : function(filepath){
        return axios.post(`${QTurl}lead/addCustomersToErp`,filepath);
    },
    // show quotation which is send by approval request
    getSentApprovalQuotation() {
        return axios.get(`${QTurl}lead/quotationApproval`);
    },
    // when quotation is approved or rejected by approval request
    approvalQuotation(projectId,data){
        return axios.post(`${QTurl}lead/approvalQuoationStatus/${projectId}`,data);
    },
    // Send for Approval Quotation Changes
    quotationChangesApproval : function (data) {
        return axios.post(`${QTurl}lead/sendQuotationChangesApproval`, data);
    },
    // when approver making request for quotation changes
    approverEditViewAction(projectId,data){
        return axios.post(`${QTurl}lead/approverEditViewAction/${projectId}`,data);
    },
    getAllLeadDetailsForCHMticketGeneration : function(searchType, searchValue){
        return axios.get(`${QTurl}lead/getAllLeadDetailsForCHMticketGeneration?searchType=${searchType}&searchValue=${searchValue}`);
    },
    createCHMticket: function (obj){
        return axios.post(`${QTurl}chmTicket/new`, obj);
    },
    allusersOfDepartment: function (departmentId) {
        return axios.get(`${QTurl}department/allusersOfDepartment/${departmentId}`);
    },
    getTicketsForUser: function () {
        return axios.get(`${QTurl}chmTicket/getTickets`);
    },
    getFilteredTickets: function (ribbonTagValue,dateObj,categories, chmUsers) {
        return axios.get(`${QTurl}chmTicket/getFilteredTickets/?ribbonTagValue=${ribbonTagValue}&startDate=${dateObj.startDate}&endDate=${dateObj.endDate}&categories=${categories}&chmUsers=${chmUsers}`);
    },
    addCHMticketCategory: function (obj) {
        return axios.post(`${QTurl}CHMticketCategory/new`,obj);
    },
    editCHMticketCategory: function (obj, categoryId) {
        return axios.put(`${QTurl}CHMticketCategory/edit/?categoryId=${categoryId}`,obj);
    },
    getAllCHMticketCategory: function () {
        return axios.get(`${QTurl}CHMticketCategory/all`);
    },
    deleteCHMticketCategory: function (data) {
        return axios.put(`${QTurl}CHMticketCategory/delete/?categoryId=${data}`);
    },
    closeCHMticekt: function (data, remarks) {
        return axios.put(`${QTurl}chmTicket/closeIssue/?ticketId=${data}`,remarks);
    },
    resolveCHMticekt: function (data, remarks) {
        // console.log('remarks are ',remarks);
        return axios.put(`${QTurl}chmTicket/resolveIssue/?ticketId=${data}`,remarks);
    },
    deleteCHMticekt: function (data, remarks) {
        // console.log('remarks are ',remarks);
        return axios.delete(`${QTurl}chmTicket/soft-delete/?ticketId=${data}`);
    },
    getAllCHMusers: function () {
        return axios.get(`${QTurl}user/all`);
    },
    getSearchedTicket: function(ticketId){
        // console.log('search api hit')
        return axios.get(`${QTurl}chmTicket/searchByTicketId/?ticketId=${ticketId}`)
    },
    getRibbonNumberInfo: function(){
        return axios.get(`${QTurl}chmTicket/getRibbonNumberInfo`)
    },
    getOrderedMaterialsQty: function(type){
        return axios.get(`${Apiurl}procurement/getOrderedMaterialsQty?type=${type}`)
    },
    getAmountPaid : function(leadId){
        return axios.get(`${QTurl}lead/getAmountPaid/?leadId=${leadId}`);
    },
    updateCompanyPLData : function(data){
        return axios.post(`${Apiurl}fileUpload/updateCompanyP&LData`, data)
    },
    getPostDesignSignOffObj : function(){
        return axios.get(`${QTurl}lead/postDesignSignOffCategoryObject`)
    },
    getLeadDetailsForChmTicket: function(leadId){
        return axios.get(`${QTurl}lead/getLeadDetailsForChmTicket/?leadId=${leadId}`)
    },
    changeCHMticketAssignedUser: function(ticketId, userId, departmentId, teamId){
        return axios.put(`${QTurl}chmTicket/changeAssignedUser/?ticketId=${ticketId}&userId=${userId}&departmentId=${departmentId}&teamId=${teamId}`)
    },
    getDesignStageList: function(){
        return axios.get(`${QTurl}customer/getAllDesignStages`)
    },
    get_call_center_logs: function(rowsPerPage){
        return axios.get(`${QTurl}call_center/get_call_center_logs?rowsPerPage=${rowsPerPage}`)
    },
    get_filtered_call_center_logs: function(data){
        return axios.put(`${QTurl}call_center/get_filtered_call_center_logs`, data)
    },
    updateCustomerStages : function(data){
        return axios.post(`${QTurl}customer/updateCustomerStages`, data);
    },
    updateWhatsAppNotificationStages : function(data){
        return axios.post(`${QTurl}lead/updateWhatsAppNotificationStages`, data);
    },
    discussionNotesData : function(obj){
        return axios.put(`${QTurl}lead/discussionNotes`,obj)
    },
    editTicketDetails: function(obj){
        return axios.put(`${QTurl}chmTicket/editTicketDetails`,obj)
    },
    updateCustomerDesignHold(leadId,obj) {
        return axios.post(`${QTurl}user/updateCustomerDesignHold/${leadId}`,obj);
    },  
    getAllDesignHoldLeads: function(){
        return axios.get(`${QTurl}lead/getAllDesignHoldLeads`)
    },
    updateDesignHoldApprovalStatus: function(obj,projectId){
        return axios.post(`${QTurl}lead/updateDesignHoldApprovalStatus/${projectId}`,obj)
    },
    getDesignHoldAnalysisData: function (data) {
        return axios.put(`${QTurl}leadJourney/getDesignHoldAnalysisData`, data)
    },
    changeCHMticketAssignedUserFromEmail: function(ticketId, email){
        return axios.put(`${QTurl}chmTicket/changeAssignedUserFromEmail/?ticketId=${ticketId}&email=${email}`)
    },
    createTask: function (obj){
        return axios.post(`${QTurl}taskTicket/new`, obj);
    },
    getFilteredTaskTickets: function (ribbonTagValue, dateObj, status, createTicketFromNotes, selectedAssignedTo, source = "", page = 0, limit = 100) {  
    // Check if ribbonTagValue includes "Customer" to determine type
    const type = ribbonTagValue.includes("Customer") ? "customer" : "";
    const assignedTo = selectedAssignedTo && selectedAssignedTo !== "" ? selectedAssignedTo : "";
    return axios.get(`${QTurl}taskTicket/getFilteredTickets/?ribbonTagValue=${ribbonTagValue}&startDate=${dateObj.startDate}&endDate=${dateObj.endDate}&status=${status}&createTicketFromNotes=${createTicketFromNotes}&assignedTo=${assignedTo}&type=${type}&source=${source}&page=${page}&limit=${limit}`);
    },
    getAssingeToTaskticket: function () {
        return axios.get(`${QTurl}taskTicket/getAssignedToUsers`);
    },
    searchProjectsByNumber: function (value) {
        return axios.get(`${QTurl}taskTicket/searchProjectsByNumber?searchValue=${value}`);
    },
    reopenTaskTicket: function (data, remarks) {
        // console.log('remarks are ',remarks);
        return axios.put(`${QTurl}taskTicket/reopenTask/?ticketId=${data}`,remarks);
    },
    closeTaskticket: function (data, remarks) {
        return axios.put(`${QTurl}taskTicket/closeIssue/?ticketId=${data}`,remarks);
    },
    resolveTaskticket: function (data, remarks) {
        // console.log('remarks are ',remarks);
        return axios.put(`${QTurl}taskTicket/resolveIssue/?ticketId=${data}`,remarks);
    },
    deleteTaskTicket: function (data, remarks) {
        // console.log('remarks are ',remarks);
        return axios.delete(`${QTurl}taskTicket/soft-delete/?ticketId=${data}`);
    },
    getSearchedTaskTicket: function(ticketId){
        // console.log('search api hit')
        return axios.get(`${QTurl}taskTicket/searchByTicketId/?ticketId=${ticketId}`)
    },
    getTaskRibbonNumberInfo: function(selectedStatusData, createTicketFromNotes,assignedToId){
        return axios.get(`${QTurl}taskTicket/getRibbonNumberInfo/?status=${selectedStatusData}&createTicketFromNotes=${createTicketFromNotes}&assignedTo=${assignedToId}`)
    },
    changeTaskTicketAssignedUserFromEmail: function(ticketId, email){
        return axios.put(`${QTurl}taskTicket/changeAssignedUserFromEmail/?ticketId=${ticketId}&email=${email}`)
    },
    editTaskTicketDetails: function(obj){
        return axios.put(`${QTurl}taskTicket/editTicketDetails`,obj)
    },
     // Refund Request api here 
     sendApprovalRefundRequest: function(leadId, obj){
        return axios.put(`${QTurl}lead/sendRefundRequestApproval/${leadId}`,obj);
    },
    sendChmRefundApproval: function(obj, leadId){
        return axios.put(`${QTurl}lead/sendChmRefundRequestApproval/${leadId}`,obj);
    },
    getAllRefundRequestData: function(){
        return axios.get(`${QTurl}lead/getAllRefundRequestData`)
    },
    approveRefundRequestStatus: function(obj,leadId){
        return axios.put(`${QTurl}lead/approveRefundRequestStatus/${leadId}`,obj)
    },
    getFinanceRefundLead: function(obj){
        return axios.put(`${QTurl}lead/getFinanceRefundLead`,obj)
    },
    updateUnpaidLead: function(obj){
        return axios.put(`${QTurl}lead/updateUnpaidLead`,obj)
    },
    updateCompanyPLByRefundRaise : function(data){
        return axios.post(`${Apiurl}fileUpload/updateCompanyPLByRefundRaise`, data)
    },
    moveRefundLeadLost: function(obj,leadId){
        return axios.put(`${QTurl}lead/moveRefundrequestLeadToLost/${leadId}`,obj);
    },
    approveRefundLeadLostStatus: function(obj,leadId){
        return axios.put(`${QTurl}lead/approveRefundrequestLeadLost/${leadId}`,obj);
    },
    getRefundRequestSearchLeads: function (searchType, search, expCenterId) {
        return axios.get(`${QTurl}lead/all-refundReq-search-lead?searchType=${searchType}&search=${search}&experienceCenterId=${expCenterId}`)
    },
    moveLeadToLostUnified: function(leadId, obj) {
        return axios.post(`${QTurl}lead/moveLeadToLost/${leadId}`, obj);
    },
    
    // Lost / Lost with Refund approval bypass (Admin only)
    getRefundApprovalsForBypass: function(params) {
        return axios.get(`${QTurl}refund-approval-bypass/pending`, { params });
    },
    bypassRefundApproval: function(leadId, obj) {
        return axios.put(`${QTurl}refund-approval-bypass/${leadId}`, obj);
    },
    
    // Unified Lost + Refund Approval APIs
    getUnifiedLostRefundApprovals: function() {
        return axios.get(`${QTurl}lead/getUnifiedLostRefundApprovals`);
    },
    
    approveUnifiedLostRefund: function(leadId, data) {
        return axios.put(`${QTurl}lead/approveRefundrequestLeadLost/${leadId}`, data);
    },
    
    categoryTableData: function () {
        // console.log('remarks are ',remarks);
        return axios.get(`${QTurl}chmTicket/categoryTableData`);
    },
    getDesignRevokeDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/DesignRevokeDataBasedexpCenterBasedData?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}&designHoldReason=${data.designHoldReason}&designStatus=${data.designHoldStage}`)
    },
    getDataBasedClickDesignHoldRevoke: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickDesignHoldRevoke`, data)
    },

    getAllExperienceCenterSurveyForm:function (userId) {
        return axios.get(
          `${QTurl}user/allExperienceCenter/${userId}`
        );
    },
    createTarget: function (obj) {
        return axios.post(
          `${QTurl}target/assign-targetToSM`,
          obj
        );
      },

    getUserData: function (userId, year) {
        return axios.get(
            `${QTurl}target/DGM/targets?year=${year}`
          );
        },
    getTargetOfDGM: function (userInfo) {
        if (userInfo.teamId && userInfo.teamId !== "all") {
            return axios.get(`${QTurl}target/get-DGM-Target/${userInfo.userId}?teamId=${userInfo.teamId}&year=${userInfo.year}`);
          
        } else if (userInfo.teamId === "all" || userInfo.teamId === "") {
            return axios.get(`${QTurl}target/get-DGM-Target/${userInfo.userId}?year=${userInfo.year}`);
          }
        },
        
        getDgmsTeam:function (userId) {
          return axios.get(`${QTurl}user/getTeams/${userId}`);
        },
  
    
    
      editAmount: function (obj) {
        return axios.put(
          `${QTurl}target/DGM/targets`,
          obj
        );
      },
    getAllMemberOfTeam:function(userInfo){
        return axios.get(`${QTurl}target/getAllMember/${userInfo.userId}/${userInfo.teamId}`)
    },
    setTargetForAllMemberOfTeam:function(userInfo,userId){
        return axios.post(`${QTurl}target/assignTargetToAuser`,userInfo)
    },
    
    getSelectExperienceOptionAndTeam: function (userId) {
      return axios.get(`${QTurl}user/getTeams/${userId}`);
    },
    
      getTargetOfSM: function (userId) {
       
        return axios.get(`${QTurl}target/get-target/${userId}`);
      },
    
      distributeAmountSM: function (obj) {
        return axios.post(
          `${QTurl}target/assign-targetToASM`,
          obj
        );
      },
    
      distributeAmountASM: function (obj) {
        return axios.post(
          `${QTurl}target/assign-targetToSE`,
          obj
        );
      },
    
      tableDataForUsr: function (userInfo) {
        return axios.get(`${QTurl}target/fetch-targets/${userInfo.userId}/${userInfo.teamId}?year=${userInfo.year}`);
        
      },
    
      editAmountOfSmAsmSe: function (userInfo,userId) {
        return axios.put(
          `${QTurl}target/editTarget/${userId}`,
           userInfo
        );
      },
    
      // Performance API........
    
      performanceApi: function (userInfo) {
       
        return axios.get(
          `${QTurl}target/targetVsPerformance/${userInfo.userId}/${userInfo.teamId}?year=${userInfo.year}`
        );
      },
    // Admin Performance Api
    
      adminPerformanceApi: function (year) {
        return axios.get(
          `${QTurl}target/allPerformance?year=${year.year}`
        );
      },
    
      teamInfoCorrespondingsUser: function (userInfo) {
       
        return axios.get(
          `${QTurl}target/getAllMember/${userInfo.userId}/${userInfo.teamId}`
        );
      },
    
      teamWiseDataApiPerformance:function (userInfo) {
       
        return axios.get(
          `${QTurl}target/targetVsPerformance/${userInfo.userId}/${userInfo.teamId}?year=${userInfo.year}`
        );
      },
    // Reminder close api
    closeReminder: function (leadLogId, obj) {
        return axios.post(`${QTurl}leadLog/closeReminder/${leadLogId}`,obj);
    },
    leadBuilderAutofillValues: function (formData) {
        return axios.put(
          `${QTurl}lead/leadBuilderAutofillValues`,formData
        );
    },
    getLeadBuilderData: function (data) {
        return axios.put(
          `${QTurl}lead/getLeadBuilderData`,data
        );
    },
  
    getDesignHoldRevokeAnanlysisMonthBasedData: function (data) {
        return axios.get(`${QTurl}leadJourney/designHoldRevokeAnanlysisMonthBasedData?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}&designHoldReason=${data.designHoldReason}&designStatus=${data.designHoldStage}`)
    },

    getDataBasedClickMonthDesignHoldRevoke: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickMonthDesignHoldRevoke`, data)
    },

     // new Requirement code
    uploadCsvAdmin:function(formData){
        return axios.post(
           `${QTurl}target/assignTargetToAll`,{filePath:formData}
          );
    },
    
    targetVisiabilityForAdmin:function(year,ecId){
        return axios.get(
           `${QTurl}target/getRoleWiseTargets?year=${year}&experienceCenterId=${ecId==="all" ? " " : ecId}`
          );
    },

    targetHierarchyWise:function(userId,year){
        return axios.get(
            `${QTurl}target/fetch-targets/${userId}?year=${year}`
           );
    },
    performanceHierarchyWise:function(userId,year){
        return axios.get(
            `${QTurl}target/performanceHierarchyWise/${userId}?year=${year}`
           );
    },
    performanceVisiabilityForAdmin:function(year,ecId,isDeactivatedToggle,pivot){
        return axios.get(`${QTurl}target/allTargetsAndPerformance?year=${year}&experienceCenterId=${ecId==="all" ? "" : ecId}&isDeactivatedToggle=${isDeactivatedToggle}&pivot=${pivot}`);
    },
    getTemplateCsvDataApi:function(){
        return axios.get(
            `${QTurl}user/allUser`
           );
    },
    getAllExperienceCenter:function(){
        return axios.get(
            `${QTurl}target/allExperienceCenterAdmin`
           );
    },


    // Incentives....

    getIncentivesApi : function(year,month,userId){
        return axios.get(
         `${QTurl}target/incentiveHierarchyWise/${userId}?month=${month}&year=${year}`); 
    },
    getAdminIncentivesApi: function(year, month, ecId,isDeactivatedToggle) {
        return axios.get(
            `${QTurl}target/allTargetsPerformanceIncentives?year=${year}&experienceCenterId=${ecId === "all" ? "" : ecId}&month=${month === "all" ? "" : month}&isDeactivatedToggle=${isDeactivatedToggle}`
        );
    },

    // Pip Flow

    sendPipApi : function(userId){
        return axios.post(
         `${QTurl}target/pipEmail/${userId}`);
    },

    notSendReasonPipApi: function(userId,obj){
        return axios.post(
          `${QTurl}target/notSendReason/${userId}`,obj);
    },

    reasonHistoryApi : function(userId){
        return axios.get(
         `${QTurl}target/notSendReason/${userId}`); 
    },

    pipNotificationApi: function(userId){
        return axios.get(
         `${QTurl}target/dispalyPipForAUser/${userId}`); 
    },


    // //QT Integration API
    // getAllQtProjects: function (data) {
    //     return axios.post(`${QTurl}project/activeDashboard`, data)
    // },
    // getOrgRateCardForRateCardMaster: function (rateCardMasterId) {
    //     return axios.get(`${QTurl}org-rate-card/${rateCardMasterId}`)
    // },
    // cloneOrgRateCard: function (rateCardMasterId) {
    //     return axios.post(`${QTurl}org-rate-card/clone-rate-card/${rateCardMasterId}`)
    // },
    // getAllRateCardMaster: function () {
    //     return axios.get(`${QTurl}rate-card-master`)
    // },
    // customerProject: function (data) {
    //     return axios.get(`${QTurl}project/customer/${data}`)
    // },
    // getDepartments: function () {
    //     return axios.get(`${Apiurl}department/all`);
    // },
    // createDepartment: function (data) {
    //     return axios.post(`${Apiurl}department/addDepartment/`, data)
    // },
    // editDepartment: function (data, id) {
    //     return axios.put(`${Apiurl}department/editDepartment/${id}`, data)
    // },
    // deleteDepartment: function (deptID) {
    //     return axios.delete(`${Apiurl}department/deleteDepartment/${deptID}`)
    // },
    // getTeams: function () {
    //     return axios.get(`${Apiurl}team/all`)
    // },
    // createTeam: function (data) {
    //     return axios.post(`${Apiurl}team/addTeam/`, data)
    // },
    // getQTTeamUsers: function (id) {
    //     return axios.get(`${Apiurl}user/usersOfTeam/${id}`);
    // },
    // getQtTeamManager: function (id) {
    //     return axios.get(`${QTurl}user/managerOfTeam/${id}`);
    // },
    // assignProject: function (data) {
    //     return axios.post(`${QTurl}assignTo`, data);
    // },
    // wdFileUpload: function (data) {
    //     return axios.post(`${QTurl}file/upload?type=attachment`, data)
    // },
    // getQTUsers(id) {
    //     return axios.get(`${QTurl}user/usersOfTeam/${id}`);
    // },
    // getAllQuotationsForProject(projectId) {
    //     return axios.get(`${QTurl}quotation/all/${projectId}`)
    // },
    // getProjectDetails(projectId) {
    //     return axios.get(`${QTurl}project/${projectId}`)
    // },
    // generateQuotationExcel(quotationId) {
    //     return axios.get(`${QTurl}quotation/excel/${quotationId}`)
    // },
    // getProjectComponent: function (projectId) {
    //     return axios.get(`${QTurl}projectComponent/${projectId}`)
    // },
    // addProjectComponent: function (data) {
    //     return axios.post(`${QTurl}projectComponent/new`, data)
    // },
    // getAllProductsFromRateCard: function (projectId) {
    //     return axios.get(`${QTurl}project-rate-card/default-rate-card/${projectId}`)
    // }
    getCallLogsForLead : function(data) {
        return axios.put(`${QTurl}call_center/getCallLogsForLead`, data)
    },
    updateUserCacheById: function(id){
        return axios.put(`${Apiurl}user/updateUserCacheById/${id}`);
    },
    departmentStages: function (departmentName) {
        return axios.get(`${QTurl}department/department_stages/${departmentName}`);
    },
    
    // Function to update attachement for lead
    updateAttachmentsForLead(payload) {
        return axios.put(`${QTurl}lead/update-new-attachment-for-lead/?leadId=${payload.leadId}`, payload);
    },

    getProjectExpCenter(projectId) {
        return axios.get(`${QTurl}lead/leadExpCenter/?leadId=${projectId}`);
    },

    getCurrentMonthPlDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getCurrentMonthPlDataBasedOnExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&expectedClosureMonth=${data.expectedClosureMonth}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
    getDataBasedClickCurrentMonthPl: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickCurrentMonthPl`, data)
    },

    getProjectionAcvDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getProjectionAcvDataBasedOnExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
    getDataBasedClickProjectionAcv: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickProjectionAcv`, data)
    },

    getExpectedClosureDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getExpectedClosureDataBasedOnExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
    getDataBasedClickExpectedClosure: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickExpectedClosure`, data)
    },

    getReminderNotCloseDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getReminderNotCloseDataBasedOnExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },

    getMeetingTrackerBasedOnUserExpCenter: function (data) {
        let url = `${QTurl}leadJourney/getMeetingTrackerBasedOnUserExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedlocation=${data.selectedlocation}&token=${data.tokenPercentage}&lost=${data.lost}&pivotValue=${data.pivotValue}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`;
        if (data.sourceOfLead && Array.isArray(data.sourceOfLead) && data.sourceOfLead.length > 0) {
            url += `&sourceOfLead=${data.sourceOfLead.join(',')}`;
        }
        return axios.get(url);
    },
    getDataBasedClickMeetingTracker: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickMeetingTracker`, data)
    },
    getRNCRevival: function (data) {
        return axios.get(`${QTurl}automationLead/rncRevival?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}&userExpCenter=${data.userExpCenter}`)
    },
    getSalesLostRevival: function (data) {
        return axios.get(`${QTurl}automationLead/salesLostRevival?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}&userExpCenter=${data.userExpCenter}`)
    },

    getDataBasedDateMeetingTracker: function (storeDateFilter) {
        let url = `${QTurl}leadJourney/daily-counts-with-leads?startDate=${storeDateFilter.startDate}&endDate=${storeDateFilter.endDate}&selectedLocation=${storeDateFilter.selectedLocation}&selectedExperienceCenter=${storeDateFilter.selectedExperienceCenter}`;
        if (storeDateFilter.sourceOfLead && Array.isArray(storeDateFilter.sourceOfLead) && storeDateFilter.sourceOfLead.length > 0) {
            url += `&sourceOfLead=${storeDateFilter.sourceOfLead.join(',')}`;
        }
        return axios.get(url);
    },
    getDataBasedClickMeetingTrackerCount: function (data) {
        return axios.post(`${QTurl}leadJourney/getDataBasedClickMeetingTrackerCount`,data)
    },
    
    getStageReviewDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getStageReviewDataBasedOnExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
    getStageReviewDataBasedOnExpCentertable2: function (data) {
        return axios.get(`${QTurl}leadJourney/getStageReviewDataBasedOnExpCentertable2?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
    getStageReviewDataBasedOnExpCentertable3: function (data) {
        return axios.get(`${QTurl}leadJourney/getStageReviewDataBasedOnExpCentertable3?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
     getReminderNotCloseDataBasedOnExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getReminderNotCloseDataBasedOnExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&token=${data.tokenPercentage}&users=${data.users}&selectedRole=${data.selectedRole}&userExpCenter=${data.userExpCenter}&searchType=${data.searchType}&search=${data.search}`)
    },
    getDataBasedClickReminderNotClose: function (data) {
        return axios.put(`${QTurl}leadJourney/getDataBasedClickReminderNotClose`, data)
    },
    chatGroups(userId) {
        return axios.get(`${decorURL}chat/groups-with-chats?userId=${userId}`);
    },
    groupMessages(groupId) {
        return axios.get(`${decorURL}chat/group/messages/${groupId}`);
    },
    leadMessages(leadId, offset = 0) {
        return axios.get(`${QTurl}chat/group/lead/messages/${leadId}?offset=${offset}`);
    },
    sendMessage(messageData) {
        return axios.post(`${QTurl}chat/group/message`, messageData);
    },
    updateParticipantRole(payload) {
        return axios.put(`${decorURL}chat/group/update-participant-role`, payload);
    },
    addOrRemoveParticipant(payload) {
        return axios.put(`${decorURL}chat/group/participants/${payload.groupId}`, payload);
    },
    getAllUsersForGroupChat: function () {
        return axios.get(`${decorURL}chat/users`)
    },
    pushFollowUpData:function(link){
        return axios.post(
           `${QTurl}call_center/push-follow-up-data`,{filePath:link}
          );
    },
    getAllUserlogs: function(startDate,endDate,page,limit){
        return axios.get(`${Apiurl}user/getAllUserlogs?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`);
    },
    getAllUserLogCount: function(startDate,endDate){
        return axios.get(`${Apiurl}user/getAllUserLogCount`);
    },
    getAllSkpApprovals: function (selectedExpCenter) {
        return axios.get(`${QTurl}lead/getAllSkpApprovals/${selectedExpCenter}`);
    },
    updateSkpAppovalsForDesign(data) {
        return axios.put(`${QTurl}lead/skpApprovalsHandle`, data)
    },
    moveToMarketingFromSmApproval: function (data) {
        // console.log('http service',data)
        return axios.put(`${QTurl}lead/moveToMarketingFromSmApproval`,data);
    },
    getm2mleads: function(obj){
        return axios.get(`${QTurl}lead/getm2mleads?page=${obj.page}&limit=${obj.limit}&filter=${obj.filter}&searchType=${obj.searchType}&search=${obj.search}&startDate=${obj.startDate}&endDate=${obj.endDate}&dateType=${obj.dateType}&selectedExperienceCenter=${obj.selectedExperienceCenter}&selectedlocation=${obj.selectedlocation}`);
    },
    updateM2MApproval: function(data){
        return axios.put(`${QTurl}lead/updateM2MApproval`,data);
    },
    updateM2Mrejection: function(data){
        return axios.put(`${QTurl}lead/updateM2Mrejection`,data);
    },
    // src/pages/skpApprovalsPage/index.js

    // Knowledgw hub email send
    sendMailKnowledgeHub: function (mailInfo) {
        return axios.get(`${QTurl}knowledge-taging/sendMailKnowledgeHub`, { params: mailInfo, }) // Send mailInfo as query parameters
    },

    // quotation Change paid
    updateUnpaidQuotation: function(obj){
        return axios.put(`${QTurl}lead/updateUnpaidQuotation`,obj)
    },

    // Sales Dashbaord all 13 dashbaord
    getDataBasedOnClickAcvAmount: function(obj){
        return axios.get(`${QTurl}leadJourney/getDataBasedOnClickAcvAmount?year=${obj.year}&month=${obj.month}`)
    },
    // task assign by manager
    getTaskAssignedData: function (data) {
        return axios.get(`${QTurl}leadJourney/getTaskAssignedData?userExpCenter=${data.userExpCenter}`)
    },
    //task assigned not due
    getTaskAssignedNotDueData: function (data) {
        return axios.get(`${QTurl}leadJourney/getTaskAssignedNotDueData?userExpCenter=${data.userExpCenter}`)
    },
    // Reminder Due
    getReminderDueData: function (data) {
        return axios.get(`${QTurl}leadJourney/getReminderDueData?userExpCenter=${data.userExpCenter}`)
    },
    // Reminder Today
    getReminderTodayData: function (data) {
        return axios.get(`${QTurl}leadJourney/getReminderTodayData?userExpCenter=${data.userExpCenter}`)
    },
    // reminder Tomorrow
    getReminderTomorrowData: function (data) {
        return axios.get(`${QTurl}leadJourney/getReminderTomorrowData?users=${data.users}&userExpCenter=${data.userExpCenter}`)
    },
    // Lead Receive SE Dashboard
    getLeadReceivedData: function (data) {
        return axios.get(`${QTurl}leadJourney/getLeadReceivedData?userExpCenter=${data.userExpCenter}`)
    },
    getLeadReminderNotSetData: function (data) {
        return axios.get(`${QTurl}leadJourney/getLeadReminderNotSetData?userExpCenter=${data.userExpCenter}`)
    },
    getProjectNotCloseData: function (data) {
        return axios.get(`${QTurl}leadJourney/getProjectNotCloseData?userExpCenter=${data.userExpCenter}`)
    },
    getTodayTomoExpectedData: function (data) {
        return axios.get(`${QTurl}leadJourney/getTodayTomoExpectedData?userExpCenter=${data.userExpCenter}`)
    },
    // close 80% percent dadhboard in se dashboard
    getClose80PercentData: function (data) {
        return axios.get(`${QTurl}leadJourney/getClose80PercentData?userExpCenter=${data.userExpCenter}`)
    },
    getMeetingTitleDetail: function (leadId) {
        return axios.get(`${QTurl}leadJourney/getMeetingTitleDetail/${leadId}`)
    },
    getCxNotCallData: function (data) {
        return axios.get(`${QTurl}leadJourney/getCxNotCallData?userExpCenter=${data.userExpCenter}`)
    },
    getCountSeDashboardData : function (data) {
        return axios.get(`${QTurl}leadJourney/countSeDashboardData?userExpCenter=${data.userExpCenter}`)
    },
    getDataForMeetingTracket: function (data) {
        return axios.post(`${QTurl}leadLog/getMeetingDetails?leadId=${data}`)
    },

     //  getting all referral
     getReferralData(type, paymentStatus, stageFilter, referralMode, page = 1, limit = 100, startDate = null, endDate = null) {
        let url = `${QTurl}referral/get_referral`;
        let params = [];
        
        if (type && type !== "all") {
            params.push(`referralType=${encodeURIComponent(type)}`);
        }
        
        if (paymentStatus && paymentStatus !== "all") {
            params.push(`paymentStatus=${encodeURIComponent(paymentStatus)}`);
        }
        
        if (stageFilter && stageFilter !== "all") {
            params.push(`stageFilter=${encodeURIComponent(stageFilter)}`);
        }

        if (referralMode) {
            params.push(`referralMode=${encodeURIComponent(referralMode)}`);
        }
        // Add date range parameters if provided
        if (startDate) {
            params.push(`startDate=${encodeURIComponent(startDate)}`);
        }
        
        if (endDate) {
            params.push(`endDate=${encodeURIComponent(endDate)}`);
        }
        
        params.push(`page=${encodeURIComponent(page)}`);
        params.push(`limit=${encodeURIComponent(limit)}`);
        
        if (params.length > 0) {
            url += `?${params.join('&')}`;
        }
        
        return axios.get(url);
    },
    //  updating payment according to stage
    paymentUpdate(leadId, data) {
        const url = `${QTurl}referral/update_payment/${leadId}`;
        return axios.put(url, data);
    },
    //  saving bank details of the cx/employee..
    referalBankDetailsSave(formData) {
        const url = `${QTurl}referral/submit_referal_bank_details`;
        return axios.post(url, formData);
    },
    //  GETTING CUSTOMER DETAILS..
    getcustomerDetailsForReferral: function (id) {
        return axios.get(`${QTurl}customer/getcustomerDetails/${id}`)
    },
    getAllProjectsForAdmin: function (data) {
        return axios.get(`${Apiurl}project/all-projects?page=${data.page}&rowsPerPage=${data.rowsPerPage}&filters=${encodeURIComponent(JSON.stringify(data.filters))}&sortColumn=${data.sortColumn}&sortOrder=${data.sortOrder}`)
    },
    editProject: function (data) {
        return axios.put(`${Apiurl}project/edit-project`, data)
    },
    createProject: function (data) {
        return axios.post(`${Apiurl}project/create`, data)
    },
    // getCallLogs: function (data) {
    //     return axios.get(`${Apiurl}callRecordings/logs?startDate=${data.startDate}&endDate=${data.endDate}&callType=${data.callType}&page=${data.page}&rowsPerPage=${data.rowsPerPage}`);
    // },
    getCallLogsUntagged: function (data) {
        return axios.get(`${QTurl}runo/untaggedLogs?startDate=${data.startDate}&endDate=${data.endDate}&callType=${data.callType}&overallCallStatus=${data.overallCallStatus}&users=${data.users}&page=${data.page}&rowsPerPage=${data.rowsPerPage}`);
    },
    viewCdrPhone: function (cdrId, field) {
        return axios.get(`${QTurl}runo/view-cdr-phone/${cdrId}?field=${field}`);
    },
    runoClickToCall: function (data) {
        return axios.post(`${QTurl}runo/click-to-call`, data);
    },

    // Daily missed-call report (Sales / Design / Operations).
    // No params -> yesterday, which is the window the daily mail reports on.
    getMissedCallReport(params = {}) {
        return axios.get(`${QTurl}runo/missedCallReport`, { params });
    },
    // Calling Desk - HoomanLabs AI calls for one lead or every lead in a summary cell
    // With leadIds the server also says which call types each lead's stage allows.
    getCallingDeskCallTypes: function (leadIds) {
        return leadIds
            ? axios.post(`${QTurl}callingDesk/call-types`, { leadIds })
            : axios.get(`${QTurl}callingDesk/call-types`);
    },
    initiateCallingDeskCalls: function (data) {
        return axios.post(`${QTurl}callingDesk/initiate-calls`, data);
    },
    getCallingDeskBatch: function (batchId) {
        return axios.get(`${QTurl}callingDesk/batch/${batchId}`);
    },
    getCallingDeskResults: function (params) {
        return axios.get(`${QTurl}callingDesk/results`, { params });
    },
    getCallingDeskResultCall: function (resultId) {
        return axios.get(`${QTurl}callingDesk/results/${resultId}/call`);
    },
    getCallLogsTagged : function (data) {
        return axios.get(`${QTurl}runo/taggedLogs?startDate=${data.startDate}&endDate=${data.endDate}&callType=${data.callType}&overallCallStatus=${data.overallCallStatus}&users=${data.users}&searchType=${data.searchType}&search=${data.search}&page=${data.page}&rowsPerPage=${data.rowsPerPage}`);
    },
    // getCDRForLead : function(data) {
    //     return axios.get(`${QTurl}runo/getCDRForLead?leadId=${data.leadId}`)
    // },
    getCallReport: function (data) {
        return axios.get(`${QTurl}runo/call-report-runo?startDate=${data.startDate}&endDate=${data.endDate}&users=${data.users}&page=${data.page}&rowsPerPage=${data.rowsPerPage}&departments=${data.departments}&roles=${data.roles}`);
    },
    getCallProductivityReportExport: function (data) {
        return axios.get(`${QTurl}runo/call-report-runo?startDate=${data.startDate}&endDate=${data.endDate}&users=${data.users}&departments=${data.departments}&roles=${data.roles}&export=${data.export}`);
    },
    getCDRForLead: function(id, data) {
        return axios.get(`${QTurl}runo/getCDRForLead/${id}?startDate=${data.startDate}&endDate=${data.endDate}&callType=${data.callType}&overallCallStatus=${data.overallCallStatus}&page=${data.page}&rowsPerPage=${data.rowsPerPage}`);
    },
    // Additive - used only to gate the "Move to Marketing" button on
    // manageProjectLog (eligible once there are enough unanswered Runo calls,
    // or at least one transcribed call). Doesn't touch any existing flow.
    getMoveToMarketingRunoEligibility: function (leadId) {
        return axios.get(`${QTurl}runo/moveToMarketingEligibility/${leadId}`);
    },
    // Runo-gated "Move to Marketing": sends the selected reason + latest
    // Runo call data to the backend, which forwards it to an outside
    // classifier and moves the lead to Junk or reverts it based on the
    // verdict. The outside classifier's URL/response contract is still a
    // placeholder on the backend (see routes/lead.js) pending the real API.
    submitMoveToMarketingWithRunoData: function (data) {
        return axios.put(`${QTurl}lead/moveToMarketingWithRunoData`, data);
    },
    // Call Recordings Check: lightweight query that returns the latest conversation
    // that will be analysed. Used by the pre-analysis popup before the user confirms
    // sending for AI analysis. scope 'lead' (Sign-off Date and Design Hold): anyone's on
    // the lead; scope 'designer': only the assigned designer's.
    getCallRecordings: function (leadId, scope) {
        return axios.get(`${QTurl}lead/getCallRecordings/${leadId}`, scope ? { params: { scope } } : undefined);
    },
    // Design Sign-off Date: extracts the expected design sign-off date from
    // Runo call transcripts and notes using AI analysis. Called when a designer
    // clicks "Expected Design Sign-off Date" — replaces the OCR image upload.
    extractDesignSignoffDate: function (leadId) {
        return axios.put(`${QTurl}lead/extractDesignSignoffDate/${leadId}`);
    },
    // Design Hold Verification: verifies if a design hold request is
    // legitimate by analyzing Runo call transcripts against the stated reason.
    // Called before submitting a Design Hold status change.
    verifyDesignHold: function (data, leadId) {
        return axios.put(`${QTurl}lead/verifyDesignHold/${leadId}`, data);
    },
    // AI Deal Activity: Creates a LeadLog entry with dealActivity field
    // so AI analysis results appear under "Deal Activity" tab (not Notes).
    addAiDealActivity: function (leadId, dealActivity) {
        return axios.post(`${QTurl}lead/add-ai-deal-activity/${leadId}`, { dealActivity });
    },
    updateLeadInfoCDR: function(data) {
        return axios.put(`${QTurl}runo/updateLeadInfoCDR`, data)
    },
    getTranscriptsForLead: function(leadId) {
        return axios.get(`${Apiurl}callRecordings/getTranscriptsForLead/${leadId}`);
    },
    getAvailabilityLogs: function(params) {
        return axios.get(`${Apiurl}callRecordings/getAvailabilityLogs`, { params });
    },
    untagLead: function(data) {
       return axios.put(`${QTurl}runo/untagLead`, data)
    },
    getUsersCDR: function() {
        return axios.get(`${QTurl}runo/getUsers`)
    },
    matChecklistSubmitted(data) {
        return axios.post(`${QTurl}user/matChecklistSubmitted`,data)
    },
    getElectricChecklistData(leadID) {
        return axios.get(`${QTurl}user/getElectricCheckListData/${leadID}`);
     },
     getEleChecklistApprovals: function (selectedExpCenter) {
         return axios.get(`${QTurl}lead/getAllEleChecklistApprovals/${selectedExpCenter}`);
     },  
    getIncomingWhatsAppMessages: function (data) {
        return axios.get(`${QTurl}whatsApp/get-incoming-whatsapp-messages?page=${data.page}&rowsPerPage=${data.rowsPerPage}&from=${data.contact_no || null}`)
    },
    whatsAppRepliesFromCustomer: function (leadId, offset = 0) {
        return axios.get(`${QTurl}whatsApp/customer-replies?leadId=${leadId}&offset=${offset}`)
    },
    getUniqueCustomers: function(params = {}) {
        return axios.get(`${QTurl}whatsApp/get-all-active-customers`, { 
            params: {
                page: params.page || 1,
                limit: params.limit || 10,
                contact_no: params.contact_no
            }
        });
    },
    getLeadToMeetingOrderData(obj) {
        return axios.get(`${QTurl}lead/getLeadToMeetingOrderData?startDate=${obj.startDate}&endDate=${obj.endDate}&selectedLocation=${obj.selectedLocation}&selectedExpCenter=${obj.selectedExpCenter}&selectedRole=${obj.selectedRole}&selectedUser=${obj.selectedUser}&userWithTeamId=${obj.userWithTeamId}`);
    },
    getAllActiveUserInOnce : function () {
        return axios.get(`${Apiurl}user/getAllActiveUsers`);
      },
    
    // updatRequirementsNotCollected
    updateRequirementsNotCollected: function (obj) {
        return axios.post(`${QTurl}assignTo/updateRequirementsNotCollected/${obj.leadId}`,obj)
    },
    // Requirement Collected API
    updateRequirementsCollected: function (obj) {
        return axios.post(`${QTurl}assignTo/updateRequirementsCollected/${obj.leadId}`,obj)
    },
    // Quotation Sent Stage API
    updateQuotationSentStage: function (obj) {
        return axios.post(`${QTurl}assignTo/updateQuotationSentStage/${obj.leadId}`, obj)
    },

     // design team target , performance , Incentives services..
    //  getting all active design- person to get templateCSV..
    getTemplateCsvDataApiForDesign: function () {
        return axios.get(
            `${QTurl}user/allUserOfDesign`
        );
    },
    //  design team - target-performance-incentive api are from here  //
    targetVisiabilityForAdminForDesign: function (year, ecId) {
        return axios.get(
            `${QTurl}target/getRoleWiseTargetsDesign?year=${year}&experienceCenterId=${ecId === "all" ? " " : ecId}`
        );
    },
    targetHierarchyWiseForDesign: function (userId, year) {
        return axios.get(
            `${QTurl}target/fetch-targets-hierarchy-design/${userId}?year=${year}`
        );
    },
    performanceHierarchyWiseForDesign: function (userId, year) {
        return axios.get(
            `${QTurl}target/performanceHierarchyWiseForDesign/${userId}?year=${year}`
        );
    },
    performanceVisiabilityForAdminForDesign: function (year, ecId,isDeactivatedToggle) {
        return axios.get(`${QTurl}target/allTargetsAndPerformanceForDesign?year=${year}&experienceCenterId=${ecId === "all" ? "" : ecId}&isDeactivatedToggle=${isDeactivatedToggle}`);
    },
     // Incentives....
     // incentives for design team hierarchywise
     getIncentivesHierarchyWiseForDesign : function(year,month,userId){
        return axios.get(
         `${QTurl}target/incentiveHierarchyWiseForDesign/${userId}?month=${month}&year=${year}`); 
    },
    //  admin api to get incetives for design 
    getAdminIncentivesApiForDesign: function(year, month, ecId,isDeactivatedToggle) {
        return axios.get(
            `${QTurl}target/allTargetsPerformanceIncentivesForDesign?year=${year}&experienceCenterId=${ecId === "all" ? "" : ecId}&month=${month === "all" ? "" : month}&isDeactivatedToggle=${isDeactivatedToggle}`
        );
    },

    // project classification routes
    getProjectManagementData: function (data) {
        return axios.get(`${Apiurl}project/project-transactions?dateType=${data.selectedDateType}&startDate=${data.startDate}&endDate=${data.endDate}`)
    },
    getProjectManagementCapexOverHeadData: function (data) {
        return axios.get(`${Apiurl}project/project-transactions-overHead-capex?dateType=${data.selectedDateType}&startDate=${data.startDate}&endDate=${data.endDate}`)
    },
    getCapexProjects: function (data) {
        return axios.get(`${Apiurl}project/capex-projects?page=${data.page}&limit=${data.limit}`)
    },
    getOverheadProjects: function (data) {
        return axios.get(`${Apiurl}project/overhead-projects?page=${data.pageNum}&limit=${data.limit}`)
    },
    getOverheadProjectsNew: function (data) {
        return axios.get(`${Apiurl}project/overhead-projects?page=${data.pageNum}&limit=${data.limit}`)
    },
    getCapexProjectsForApproval: function (data) {
        return axios.get(`${Apiurl}project/capex-projects-pending-approval?page=${data.page}&limit=${data.limit}`)
    },
    markProjectComplete: function (projectId) {
        return axios.put(`${Apiurl}project/mark-completed/${projectId}`)
    },
    createCapexProject: function (data) {
        return axios.post(`${Apiurl}project/capex-project`, data)
    },
    getSnagSeriesTemplates: function (search) {
        return axios.get(`${Apiurl}snag-series/templates`, { params: { search } })
    },
    getSnagSeriesNextNumber: function (prefix) {
        return axios.get(`${Apiurl}snag-series/next-number`, { params: { prefix } })
    },
    createSnagSeries: function (data) {
        return axios.post(`${Apiurl}snag-series/create`, data)
    },
    getExperienceCentersByCity: function (locationId) {
        return axios.get(`${QTurl}experience-center/location-expCenters/${locationId}`);
    },
    createOverheadProject: function (data) {
        return axios.post(`${Apiurl}project/overhead-project-new`, data)
    },
    updateCapexProjectStatus: function (projectId, status) {
        return axios.put(`${Apiurl}project/capex-project-status?projectId=${projectId}&status=${status}`)
    },
    getOverheadProjectsForApproval: function (data) {
        return axios.get(`${Apiurl}project/overhead-projects-pending-approval?page=${data.page}&limit=${data.limit}`)
    },
    automationLeadSummaryDashboard: function (data) {
        return axios.get(`${QTurl}automationLead/getAutomationData?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}&selectedSources=${data.selectedSources}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    manualLeadSummaryDashboard: function (data) {
        return axios.get(`${QTurl}automationLead/getManualData?startDate=${data.startDate}&endDate=${data.endDate}&dateType=${data.dateType}&selectedSources=${data.selectedSources}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}&searchType=${data.searchType}&search=${data.search}`)
    },
    redirectEC: function(data) {
        return axios.post(`${QTurl}automationLead/redirectEC`, data);
    },
    getRedirectEC: function() {
        return axios.get(`${QTurl}automationLead/getRedirectEC`)
    },
    deleteRedirectEC: function(data) {
        return axios.post(`${QTurl}automationLead/deleteRedirectEC`, data);
    },
    //  log page for any kind of changed in for user/ec/team/department
    logDetailed(page = 1, limit = 250,startDate = null, endDate = null) {
        const params = [];
      
        if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
        if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
        params.push(`page=${encodeURIComponent(page)}`);
        params.push(`limit=${encodeURIComponent(limit)}`);
      
        const query = params.length ? `?${params.join("&")}` : "";
        const url = `${Apiurl}user/log-detailed${query}`;
      
        return axios.get(url);
    },
    // get monthly conversion goal % data
    getMonthlyConversionGoalsData: function(obj){
        return axios.get(`${QTurl}lead/getMonthlyConversionGoalsData?startDate=${obj.startDate}&endDate=${obj.endDate}&page=${obj.page}&rowsPerPage=${obj.rowsPerPage}`);
    },
    getMonthlyConversionGoalsDataOnL2M: function(obj){
        return axios.get(`${QTurl}lead/getMonthlyConversionGoalsDataOnL2M?startDate=${obj.startDate}&endDate=${obj.endDate}&expCenter=${obj.expCenter}`);
    },
    // update conversion goal
    updateConversionGoal : function (obj) {
        return axios.put(`${QTurl}lead/updateConversionGoal`,obj);
    },
    allPaymentLink : function (leadId) {
        return axios.get(`${QTurl}paymentTransactions/paymentLink/${leadId}`);
    },

    paymentCancelLink : function (obj) {
        return axios.post(`${QTurl}paymentTransactions/cancel-link`,obj);
    },

    // This is Lock Inwarding Dates logs.
    inwardingLockDateGet: function () {
        return axios.get(`${Apiurl}lockInwardingDate/all-lock-inwarding`);
    },
    // this is to update inwarding lock date.
    inwardingLockNewDateUpdate: function (data) {
        return axios.post(`${Apiurl}lockInwardingDate/lock-inwarding`, data);
    },
     // submit hot deal checklist data
    submitHotDealChecklistData: function (obj, projectId){
        return axios.post(`${QTurl}lead/submitHotDealChecklistData/${projectId}`, obj);
    },
    approvereditServiceOrderPaymentStatusRoleWise: function (paymentId, data) {
        return axios.put(`${Apiurl}serviceOrder/payment-approver-request-rolewise/${paymentId}`, data)
    },
   getSopaymentreqRoleWise:function (paymentType ,page = 1, limit = 200, search = '') {
        const params = { paymentType, page, limit };
    if (search && search.trim() !== '') {
        params.search = search.trim();
    }
        return axios.get(`${Apiurl}serviceOrder/payment-approver-request-roleWise`,{
            params: params
        });
    },
    //function for fetching all data
    getSopaymentreqRoleWiseAll: function (paymentType) {
        return axios.get(`${Apiurl}serviceOrder/payment-approver-request-roleWise`, {
            params: {
                paymentType,
                page: 1,
                limit: 10000
            }
        });
    },

      // generating files/ payment json to send to hdfc from approved status
    generateVendorPaymentSnorkelHDFC: function (page = 1, limit = 100, startDate, endDate) {
        return axios.get(
            `${Apiurl}serviceOrder/vendor-so-payment-for-dgm?page=${page}&limit=${limit}&startDate=${startDate || ""}&endDate=${endDate || ""}`
        );
    },
    // Save a Snorkel upload log (called after OTP verified + Snorkel upload success)
    saveSnorkelUploadLog: (data) => {
        return axios.post(`${Apiurl}serviceOrder/save-snorkel-upload-log`, data);
    },

    // Fetch all past Snorkel upload logs for the Sync panel
    getSnorkelUploadLogs: () => {
        return axios.get(`${Apiurl}serviceOrder/get-snorkel-upload-logs`);
    },

    // Run sync: reads the Excel from s3Location and updates sentToBank = true
    syncSnorkelPayments: (data) => {
        // data = { logId: string, s3Location: string }
        return axios.post(`${Apiurl}serviceOrder/sync-snorkel-payments`, data);
    },
     // ── Vendor GST payment against an SO — separate bank feed from the SO one ──
   generateVendorGstPaymentSnorkelHDFC: function (page = 1, limit = 100, startDate, endDate) {
        return axios.get(
            `${Apiurl}serviceOrder/vendor-so-gst-payment-for-dgm?page=${page}&limit=${limit}&startDate=${startDate || ""}&endDate=${endDate || ""}`
        );
    },
    saveSnorkelUploadLogGST: (data) => {
        return axios.post(`${Apiurl}serviceOrder/save-snorkel-upload-log-gst`, data);
    },
    getSnorkelUploadLogsGST: () => {
        return axios.get(`${Apiurl}serviceOrder/get-snorkel-upload-logs-gst`);
    },
    syncSnorkelPaymentsGST: (data) => {
        // data = { logId: string, s3Location: string }
        return axios.post(`${Apiurl}serviceOrder/sync-snorkel-payments-gst`, data);
    },
     // ── PO payment equivalents of the above (vendor-aggregated) ───
    generateVendorPaymentSnorkelHDFCPO: function (page = 1, limit = 100, startDate, endDate) {
        return axios.get(
            `${Apiurl}inwardingPaymentRequest/vendor-po-payment-for-dgm?page=${page}&limit=${limit}&startDate=${startDate || ""}&endDate=${endDate || ""}`
        );
    },
    saveSnorkelUploadLogPO: (data) => {
        return axios.post(`${Apiurl}inwardingPaymentRequest/save-snorkel-upload-log-po`, data);
    },
    getSnorkelUploadLogsPO: () => {
        return axios.get(`${Apiurl}inwardingPaymentRequest/get-snorkel-upload-logs-po`);
    },
    syncSnorkelPaymentsPO: (data) => {
        // data = { logId: string, s3Location: string }
        return axios.post(`${Apiurl}inwardingPaymentRequest/sync-snorkel-payments-po`, data);
    },
    //Download excel for all DATA at once...
      vendorSoPaymentExcelDownload: function () {
        return axios.get(`${Apiurl}serviceOrder/vendorSoPaymentExcelDownload`);
    },
       // generating files/ payment json to send to hdfc from approved status
    responseDataAfterUploadingToHDFC: function ({ page = 1, limit = 200, search = '' } = {}) {
        return axios.get(`${Apiurl}serviceOrder/hdfc-reverse-response-after-uploading`, {
            params: { page, limit, search },
        });
    },
    syncSoReverseUtrsFromS3: function () {
        return axios.post(`${Apiurl}serviceOrder/so-reverse-sync-from-s3`);
    },
    getReverseUtrsByCategory: function (type, { page = 1, limit = 200, search = '' } = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/reverse/utrs`, {
            params: { type, page, limit, search },
        });
    },
    syncReverseUtrsFromS3: function () {
        return axios.post(`${QTurl}miscPayment/ex/payments/reverse/sync-from-s3`);
    },
    gstHdfcReverseResponseAfterUploading: function ({ page = 1, limit = 200, search = '' } = {}) {
        return axios.get(`${Apiurl}serviceOrder/gst-hdfc-reverse-response-after-uploading`, {
            params: { page, limit, search },
        });
    },
    syncGstReverseUtrsFromS3: function () {
        return axios.post(`${Apiurl}serviceOrder/gst-reverse-sync-from-s3`);
    },
    //  send email to any email address for OTP
    sendOtpMessageToAnyEmail: function (data) {
        return axios.post(`${QTurl}user/sendOtpMessageToAnyEmail`, data)
    },
    uploadToS3ForSnorkelPayment: (formData, type) => {
        const query = type ? `?type=${type}` : '';
        return axios.post(`${DPVurl}snorkel/upload-vendor-file${query}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
      uploadToS3ForSnorkelPaymentPO: (formData) => {
        return axios.post(`${DPVurl}snorkel/upload-vendor-file-po`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    saveSnorkelUploadLogEC: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/save-snorkel-upload-log`, data);
    },
    getSnorkelUploadLogsEC: () => {
        return axios.get(`${QTurl}miscPayment/ex/payments/get-snorkel-upload-logs`);
    },
    syncSnorkelPaymentsEC: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/sync`, data);
    },

    // ── Referral (office-meet / kick-off) ──
    getPendingReferralPayments: (params = {}) => {
        return axios.get(`${QTurl}miscPayment/ex/payments/referral/pending`, { params });
    },
    saveReferralUploadLog: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/referral/save-upload-log`, data);
    },
    getReferralUploadLogs: () => {
        return axios.get(`${QTurl}miscPayment/ex/payments/referral/get-upload-logs`);
    },
    syncReferralPayments: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/referral/sync`, data);
    },
       // ── Channel Partner ──
    getPendingChannelPartnerPayouts: (params = {}) => {
        return axios.get(`${QTurl}miscPayment/ex/payments/channel-partner/pending`, { params });
    },
    saveChannelPartnerUploadLog: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/channel-partner/save-upload-log`, data);
    },
    getChannelPartnerUploadLogs: () => {
        return axios.get(`${QTurl}miscPayment/ex/payments/channel-partner/get-upload-logs`);
    },
    syncChannelPartnerPayouts: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/channel-partner/sync`, data);
    },

    // ── Refund ──
    getPendingRefundPayments: (params = {}) => {
        return axios.get(`${QTurl}miscPayment/ex/payments/refund/pending`, { params });
    },
    saveRefundUploadLog: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/refund/save-upload-log`, data);
    },
    getRefundUploadLogs: () => {
        return axios.get(`${QTurl}miscPayment/ex/payments/refund/get-upload-logs`);
    },
    syncRefundPayments: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/refund/sync`, data);
    },
    allPaymentHistoryOfASO: function (soNumber) {
        return axios.get(`${Apiurl}serviceOrder/allPaymentHistory?soNumber=${soNumber}`);
  },
  updateServiceOrderTds: function(SoId, data) {
    return axios.put(`${Apiurl}serviceOrder/update-tds-percentage/${SoId}`, data);
    },
    assignPromotionalRole:function(obj){
        return axios.put(`${Apiurl}user/assignPromotionalRole`,obj)
    },

    // std rate card api's
    getOpenPoData : function (poId) {
        return axios.get(`${Apiurl}project/getOpenPoData/${poId}`)
    },

    getProjectExcelFileData: function (project, data) {
        return axios.put(`${Apiurl}project/getProjectExcelFile/${project._id}`, data);
    },

    getAllProcurementsAndServiceDetailsApprovedByOperationHead: function (page,rowsPerPage,startDate, endDate) {
        return axios.get(`${Apiurl}procurement/get-po-so-details-approved-by-operation-head?page=${page}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}`)
    },

    // /get-all-procurement-details-approved-by-operation-head

    getAllProcurementDetailsApprovedByOperationHeadWithOutPagination: function (startDate, endDate) {
        return axios.get(`${Apiurl}procurement/get-all-procurement-details-approved-by-operation-head?startDate=${startDate}&endDate=${endDate}`, {
            responseType: 'blob'
        });
    },

    getAllServiceOrderDetailsApprovedByOperationHeadWithOutPagination: function (startDate, endDate) {
        return axios.get(`${Apiurl}serviceOrder/get-all-service-order-details-approved-by-operation-head?startDate=${startDate}&endDate=${endDate}`, {
            responseType: 'blob'
        });
    },

    getAllServiceOrderAndProcurementDetailsApprovedByOperationHeadWithOutPagination :function (startDate, endDate) {
        return axios.get(`${Apiurl}procurement/get-full-po-so-details-approved-by-operation-head?startDate=${startDate}&endDate=${endDate}`, {
            responseType: 'blob'
        });
    },
    getLeadsReceived:function(id){
        return axios.get(`${QTurl}leadJourney/leads-received/${id}`)
    },
    getRNCStageLeads:function(id){
        return axios.get(`${QTurl}leadJourney/rnc-leads/${id}`)
    },
    getRCStageLeads:function(id){
        return axios.get(`${QTurl}leadJourney/rc-leads/${id}`)
    },
    getHotDealChecklist:function(id){
        return axios.get(`${QTurl}leadJourney/hotdeal-leads/${id}`)
    },
    getLeftPipelineTasks:function(id){
        return axios.get(`${QTurl}leadJourney/leftpipeline/${id}`)
},
    getRightPipelineTasks:function(id){
            return axios.get(`${QTurl}leadJourney/rightpipeline/${id}`)
    },
    getASMOverdueTasks:function(id){
        return axios.get(`${QTurl}leadJourney/asm-overdue-tasks/${id}`)
    },
    getTeamOverdueTasks:function(id){
        return axios.get(`${QTurl}leadJourney/team-overdue-tasks/${id}`)
    },
   
    getASMUpcomingTasks:function(id){
        return axios.get(`${QTurl}leadJourney/asm-upcoming-tasks/${id}`)
    },
    getTeamUpcomingTasks:function(id){
        return axios.get(`${QTurl}leadJourney/team-upcoming-tasks/${id}`)
    },


    getAllDrawingQcApprovalLeads: function (selectedExpCenter) {
        return axios.get(`${QTurl}lead/getAllDrawingQcApprovalLeads/${selectedExpCenter}`);
    },
    selectedUsersBasedOnQCRole: function (data) {
        return axios.get(`${QTurl}leadJourney/selectedUsersBasedOnQCRole?roleName=${data.role}&pivotValue=${data.pivotValue}`)
    },
    
    drawingQCApprove:function (data) {
        return axios.put(`${QTurl}assignTo/drawingQCApprove`, data);
    },
    drawingQCApprovelForDQCStages:function (data) {
        return axios.put(`${QTurl}assignTo/drawingQCApprovelForDQCStages`, data);
    },
    
    getDrawingQCDataBasedOnUserExpCenter: function (data) {
        return axios.get(`${QTurl}leadJourney/getDrawingQCDataBasedOnUserExpCenter?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&pivotValue=${data.pivotValue}&userId=${data.userId}&selectedRole=${data.selectedRole}&userExpeCenterId=${data.userExpeCenterId}&searchType=${data.searchType}&search=${data.search}&selectedLocation=${data.selectedLocation}&selectedQCStage=${data.selectedQCStage}&selectedUsers=${data.selectedUsers}`)
    },
    
    getAllClickedDrawingQCTableData: function (payload) {
        return axios.post(`${QTurl}lead/getAllClickedDrawingQCTableData`, payload);
    },

    allQCUsers: function (data) {
        return axios.get(`${QTurl}leadJourney/allQCUsers?roleName=${data.role}`)
    },
    
    assignQcPerson:function (data) {
        return axios.put(`${QTurl}assignTo/assignQcPerson`, data);
    },

    quotationLink: function (quoId) {
        return axios.get(`${QTurl}lead/quotationLink/${quoId}`);
    },
    // referral link creation
    getLeadCreated: function(data) {
        return axios.post(`${QTurl}lead/referralLeadCreation`, data); 
    },

    // this is for design health APIs.
    designHealthCommitmentData: function (data) {
        return axios.get(`${QTurl}designHealth/design-health-commitment-month?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&userExpeCenterId=${data.userExpeCenterId}&selectedLocation=${data.selectedLocation}&userId=${data.userId}&monthType=${data.monthType}`)
    },

    odmAgmMyCommitments: function () {
        return axios.get(`${QTurl}designHealth/odmAgmMyCommitments`)
    },
    odmAgmPendingTask: function () {
        return axios.get(`${QTurl}designHealth/odmAgmPendingTask`)
    },

    getMonthlyContractDataforFrezz: function (data) {
        return axios.get(`${QTurl}designHealth/getMonthlyContractDataforFrezz?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&userExpeCenterId=${data.userExpeCenterId}&selectedLocation=${data.selectedLocation}&userId=${data.userId}`)
    },

    getNewMonthlyContractDataforFrezz: function (data) {
        return axios.get(`${QTurl}designHealth/getNewMonthlyContractDataforFrezz?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&userExpeCenterId=${data.userExpeCenterId}&selectedLocation=${data.selectedLocation}&userId=${data.userId}`)
    },

    getBottomsUpData: function (data) {
        return axios.get(`${QTurl}designHealth/getBottomsUpData?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&userExpeCenterId=${data.userExpeCenterId}&selectedLocation=${data.selectedLocation}&userId=${data.userId}`)
    },

    getSlipsLeads: function (data) {
        return axios.get(`${QTurl}designHealth/getSlipsLeads?userExpeCenterId=${data.userExpeCenterId}&userId=${data.userId}`)
    },

    getAchievedLeads: function (data) {
        return axios.get(`${QTurl}designHealth/getAchievedLeads?userExpeCenterId=${data.userExpeCenterId}&userId=${data.userId}`)
    },
    getPendingLeads: function (data) {
        return axios.get(`${QTurl}designHealth/getPendingLeads?userExpeCenterId=${data.userExpeCenterId}&userId=${data.userId}`)
    },

    getNewCommitmentData: function (data) {
        return axios.get(`${QTurl}designHealth/getNewCommitmentData?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&userExpeCenterId=${data.userExpeCenterId}&selectedLocation=${data.selectedLocation}&userId=${data.userId}`)
    },

    freezLeads: function(data) {
        return axios.post(`${QTurl}designHealth/freezLeads`, data); 
    },

    approveOrRejectDSOProjection: function(data) {
        return axios.put(`${QTurl}designHealth/approveOrRejectDSOProjection`, data); 
    },

    getAdmDSoApprovalData: function(data) {
        return axios.get(`${QTurl}designHealth/getAdmDSoApprovalData?userId=${data.userId}&userRole=${data.userRole}&userExpCenterId=${data.userExpeCenterId}&pivot=${data.pivot}`); 
    },

    getAllApprovalPendingData: function(data) {
        return axios.get(`${QTurl}designHealth/getAllApprovalPendingData?userId=${data.userId}&userRole=${data.userRole}&userExpCenterId=${data.userExpeCenterId}&pivot=${data.pivot}`); 
    },

    freezeDsoDate: function(data) {
        return axios.put(`${QTurl}designHealth/updateDSOFreezeDate`, data); 
    },
    changeHierarchyOfALead: function (projectId, updates) {
        return axios.put(`${QTurl}lead/changeHierarchy?leadId=${projectId}`, { updates })
    },
    hierarchyoptionsAccordingToUser: function (department) {
        return axios.get(`${QTurl}lead/hierarchy-options?department=${department}`)
    },


    // ------------WebQuotation changes---------

    getAllCategory : function () {
        return axios.get(`${QTurl}webQuotationCommonSection/getAllCategory`);
    },
    
    webQuotationCustomerInfo : function (version,leadId) {
        return axios.get(`${QTurl}webQuotationCommonSection/quotation/${leadId}/${version}`);
      },
    customerWebQuotationLog : function(version){
    return axios.post(`${QTurl}customerWebQuotationLog/${version}`);
    },

    customerWebQuotationSendMail : function(version,emailId,leadId){
        return axios.put(`${QTurl}webQuotationCommonSection/sendMailToCustomer/${version}`,{emailId:emailId,leadId:leadId});
      },
      customerWebQuotationSendWhatsApp : function(version,whatsappNo,leadId){
        return axios.put(`${QTurl}webQuotationCommonSection/sendWhatsappToCustomer/${version}`,{whatsappNo:whatsappNo,leadId:leadId});
      },
    openWebQuotation : function(leadId){
        return axios.post(`${QTurl}webQuotationCommonSection/saveActivity/${leadId}`);
    },

    openWebQuotation : function(leadId){
        return axios.post(`${QTurl}webQuotationCommonSection/saveActivity/${leadId}`);
    },

    getVersionOfQuotationById: function (id) {
        return axios.get(`${QTurl}webQuotationCommonSection/getVersionOfQuotationById/${id}`)
    },
    
    getPartnersImg: function () {
        return axios.get(`${QTurl}partnersImg/`);
      },
      
      editPartnersImg: function (id, data) {
        return axios.put(`${QTurl}partnersImg/${id}`, data);
      },
      
      deletePartnersImg: function (id) {
        return axios.delete(`${QTurl}partnersImg/${id}`);
      },
      
      createPartnersImg: function (data) {
        return axios.post(`${QTurl}partnersImg/`, data);
      },


    socialMediaWebQuotationGet: function () {
    return axios.get(
        `${QTurl}socialMediaWebQuotation/`
    );
    },

    socialMediaWebQuotationPost: function (formData) {
        return axios.post(
            `${QTurl}socialMediaWebQuotation/`,formData
        );
    },

    socialMediaWebQuotationPut: function (editId, formData) {
        return axios.put(
            `${QTurl}socialMediaWebQuotation/${editId}`,formData
        );
    },

    socialMediaWebQuotationDelete: function (id) {
        return axios.delete(
            `${QTurl}socialMediaWebQuotation/${id}`
        );
    },

    protectWebQuotationLink : function(){
        return axios.get(`${QTurl}webQuotationCommonSection/protected`);
    },

    webQuotationOpenActivity : function(leadId, version){
    return axios.post(`${QTurl}webQuotationCommonSection/webQuotationOpenActivity/${leadId}/${version}`);
    },

    webQuotationCloseActivity : function(leadId,version){
    return axios.post(`${QTurl}webQuotationCommonSection/webQuotationCloseActivity/${leadId}/${version}`);
    },

    // web Quotation new APIS

    // cost Summary Item

    costSummaryItemGet: function () {
        return axios.get(
          `${QTurl}costSummaryItem`
        );
    },

    costSummaryItemPost: function (data) {
        return axios.post(`${QTurl}costSummaryItem`, data); 
    },

    costSummaryItemPut: function (id,data) {
        return axios.put(`${QTurl}costSummaryItem/${id}`, data); 
    },

    costSummaryItemDelete: function (id,data) {
        return axios.delete(`${QTurl}costSummaryItem/${id}`); 
    },


    // cost BreakDown Item

    costBreakDownItemGet: function () {
        return axios.get(
            `${QTurl}costBreakDownItem`
        );
    },

    costBreakDownItemPost: function (data) {
        return axios.post(`${QTurl}costBreakDownItem`, data); 
    },

    costBreakDownItemPut: function (id,data) {
        return axios.put(`${QTurl}costBreakDownItem/${id}`, data); 
    },

    costBreakDownItemDelete: function (id,data) {
        return axios.delete(`${QTurl}costBreakDownItem/${id}`); 
    },

    // why Choose Us New 

    whyChooseUsNewGet: function (id,data) {
        return axios.get(`${QTurl}whyChooseUsNew`); 
    },

    whyChooseUsNewPost: function (data) {
        return axios.post(`${QTurl}whyChooseUsNew`,data); 
    },

    whyChooseUsNewDelete: function (id) {
        return axios.delete(`${QTurl}whyChooseUsNew/${id}`); 
    },

    whyChooseUsNewPut: function (id,data) {
        return axios.put(`${QTurl}whyChooseUsNew/${id}`, data); 
    },

    // Customer Testimonials


    customerTestimonialsGet: function () {
        return axios.get(`${QTurl}customerTestimonials`); 
    },

    customerTestimonialsPost: function (data) {
        return axios.post(`${QTurl}customerTestimonials`,data); 
    },

    customerTestimonialsDelete: function (id) {
        return axios.delete(`${QTurl}customerTestimonials/${id}`); 
    },

    customerTestimonialsPut: function (id,data) {
        return axios.put(`${QTurl}customerTestimonials/${id}`, data); 
    },

    // web Quotation Gallery

    galleryCategoryWebQuotationGet: function (id,data) {
        return axios.get(`${QTurl}galleryCategoryWebQuotation`); 
    },

    cgalleryCategoryWebQuotationPost: function (data) {
        return axios.post(`${QTurl}galleryCategoryWebQuotation`,data); 
    },

    galleryCategoryWebQuotationDelete: function (id) {
        return axios.delete(`${QTurl}galleryCategoryWebQuotation/${id}`); 
    },

    galleryCategoryWebQuotationPut: function (id,data) {
        return axios.put(`${QTurl}galleryCategoryWebQuotation/${id}`, data); 
    },
       // This is NARACI API for design Quotation.
       getNaraciDesignQuotations(projectId) { 
        return axios.get(`${QTurl}quotation/naraciDesignQuotations/${projectId}`)
    },
    getAllInactiveUserLeads: function (limit, page, selectedSearchType, searchInput, expCenterId) {
        return axios.get(`${QTurl}lead/getAllInactiveUserLeads?limit=${limit}&page=${page}&searchType=${selectedSearchType}&search=${searchInput}&experienceCenterId=${expCenterId}`)
    },

     // Flagged project

     getAllDiscrepanciesList: function () {
        return axios.get(`${QTurl}discrepancies/`)
    },

    submitFlaggedProject : function(data){
        return axios.post(`${QTurl}flaggedProject`,data); 
    },

    getAllFlaggedProjects: function () {
        return axios.get(`${QTurl}flaggedProject`);
    },

    getFlaggedDashboard: function (params) {
        return axios.get(`${QTurl}flaggedProject/`, { params });
    },

    updateFlaggedProjectStatus: function(id, data) {
        return axios.put(`${QTurl}flaggedProject/${id}/status`, data);
    },

    getFlaggedProjectById: function(id) {
        return axios.get(`${QTurl}flaggedProject/${id}`);
    },

    // deleteFlaggedProject: function(id) {
    //     return axios.delete(`${QTurl}flaggedProject/${id}`);
    // },
    getLeadFlags: function(leadId) {
        return axios.get(`${QTurl}flaggedProject/lead/${leadId}`);
    },
    exportPreProductionData:function (date) {
        return axios.get(`${QTurl}lead/export-preproduction-data?date=${date}`, {
            responseType: 'blob' 
        });
    },
    exportProductionData:function (startDate, endDate) {
        return axios.get(`${QTurl}lead/export-factory-data?startDate=${startDate}&endDate=${endDate}`, {
            responseType: 'blob' 
        });
    },
    exportsummaryofDeliveryData:function (date) {
        return axios.get(`${QTurl}lead//export-material-delivery-excel?date=${date}`, {
            responseType: 'blob' 
        });
    },
    getSpendReport: function(data) {
        return axios.get(`${QTurl}automationLead/getSpendReport?startDate=${data.startDate}&endDate=${data.endDate}&month=${data.month}&year=${data.year}`)
    },
    updateFlaggedProjectAction: function(id, data) {
        return axios.put(`${QTurl}flaggedProject/${id}/action`, data);
    },
    // upload api for botwot excel upload..
    uploadFileForAutomation: function (data) {
        return axios.post(`${QTurl}automationLead/upload-automation-leads`, data);
    },
    // AI-verification-routed bulk automation leads upload - job-based like
    // createBulkLeadVerification above (202 + jobId, poll for results).
    uploadBulkLeadsAi: function (data) {
        return axios.post(`${QTurl}automationLead/upload-bulk-leads-ai`, data);
    },
    getBulkLeadsAiJobStatus: function (jobId) {
        return axios.get(`${QTurl}automationLead/upload-bulk-leads-ai/${jobId}`);
    },

    getSourceOfLeads: function(projectId){
        return axios.get(`${QTurl}leadJourney/sourceofleadmasters/`);
    },
    editQtSentMeetingDetail: function(obj){
        return axios.put(`${QTurl}assignTo/editQtSentMeetingDetail`, obj);
    },
    getLeadMeetingFixedDetail: function(projectId){
      return axios.get(`${QTurl}assignTo/getLeadMeetingFixedDetail/${projectId}`);
    },
    spendReportValues: function(data) {
        return axios.put(`${QTurl}automationLead/spendReportValues`, data)
    },
    getProposedMeetingData: function(obj){
        return axios.get(`${QTurl}leadJourney/getProposedMeetingData?startDate=${obj.startDate}&endDate=${obj.endDate}&searchType=${obj.searchType}&search=${obj.search}&selectedlocation=${obj.selectedlocation}&selectedExperienceCenter=${obj.selectedExperienceCenter}`);
    },
    // manual referral creation of lead and bank form link generation
    manualReferralLeadCreation: function (data) {
        return axios.post(`${QTurl}referral/updateLeadForReferral`, data);
    }, 
    // resend customer links (approvals, bank forms) from manual referral settings
    searchLeadsForCustomerLinks: function (searchType, search) {
        return axios.get(`${QTurl}lead/customer-links/search?searchType=${encodeURIComponent(searchType)}&search=${encodeURIComponent(search)}`);
    },
    getCustomerLinks: function (leadId) {
        return axios.get(`${QTurl}lead/customer-links/${leadId}`);
    },
    resendCustomerLink: function (leadId, linkKey) {
        return axios.post(`${QTurl}lead/customer-links/${leadId}/resend`, { linkKey });
    },
    sendDesignQuoteApproval: function(obj){
        return axios.post(`${QTurl}lead/sendDesignQuoteApproval`,obj)
    },
    getDesignQuoteApprovalData: function(obj){
        return axios.get(`${QTurl}lead/getDesignQuoteApprovalData?selectedExpCenter=${obj.commonExpCenter}`)
    },
    approveRejectDesignQuote : function(obj){
        return axios.put(`${QTurl}lead/approveRejectDesignQuote`, obj)
    },
    sendDsoPaymentApproval: function (obj) {
        return axios.post(`${QTurl}lead/sendDsoPaymentApproval`, obj);
    },
    getDsoPaymentApprovalData: function () {
        return axios.get(`${QTurl}lead/getDsoPaymentApprovalData`);
    },
    approveRejectDsoPaymentApproval: function (obj) {
        return axios.put(`${QTurl}lead/approveRejectDsoPaymentApproval`, obj);
    },
    repairDsoSenderAssignment: function (obj) {
        return axios.put(`${QTurl}lead/repairDsoSenderAssignment`, obj);
    },
    currentMonthDso: function () {
        return axios.get(`${QTurl}lead/current-month-dso`);
    },
    designprojectsdashboard: function (data) {
        const params = new URLSearchParams();
        // Add all parameters to the URL
        if (data.startDate) params.append('startDate', data.startDate);
        if (data.endDate) params.append('endDate', data.endDate);
        if (data.status) params.append('status', data.status);
        if (data.page) params.append('page', data.page);
        if (data.limit) params.append('limit', data.limit);

        return axios.get(`${QTurl}lead/design-projects-dashboard?${params.toString()}`);
    },
    designApprovalDashboard: function (data) {
        // Set default values
        const status = data.status || '';
        const startDate = data.startDate || '2022-01-01';
        const endDate = data.endDate || '';
        const page = data.page || 1;
        const limit = data.limit || 10;
        const search = data.search || '';

        // Build query string
        let queryString = `status=${encodeURIComponent(status)}&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) {
            queryString += `&endDate=${encodeURIComponent(endDate)}`;
        }
        queryString += `&page=${page}&limit=${limit}`;
        if (search) {
            queryString += `&search=${encodeURIComponent(search)}`;
        }
        return axios.get(`${QTurl}lead/design-approval?${queryString}`);
    },

    odmDesignProjectsDashboard: function (data) {
        const params = new URLSearchParams();
        if (data.startDate) params.append('startDate', data.startDate);
        if (data.endDate) params.append('endDate', data.endDate);
        if (data.status) params.append('status', data.status);
        if (data.page) params.append('page', data.page);
        if (data.limit) params.append('limit', data.limit);
        if (data.experienceCenter) params.append('experienceCenter', data.experienceCenter);
        if (data.city) params.append('city', data.city);
        return axios.get(`${QTurl}lead/odm-design-projects-dashboard?${params.toString()}`);
    },
    getDesignerPerformance: function (data = {}) {
        const params = new URLSearchParams();
        if (data.startDate) params.append('startDate', data.startDate);
        if (data.endDate) params.append('endDate', data.endDate);
        const queryString = params.toString();
        return axios.get(`${QTurl}lead/designer-performance${queryString ? '?' + queryString : ''}`);
    },
    getOdmAgmDesignerPerformance: function (data = {}) {
        const params = new URLSearchParams();
        if (data.startDate) params.append('startDate', data.startDate);
        if (data.endDate) params.append('endDate', data.endDate);
        const queryString = params.toString();
        return axios.get(`${QTurl}lead/odm-agm-designer-performance${queryString ? '?' + queryString : ''}`);
    },
    getMyTeamPerformance: function (data = {}) {
        const params = new URLSearchParams();
        if (data.city) params.append('city', data.city);
        if (data.experienceCenter) params.append('experienceCenter', data.experienceCenter);
        if (data.designation) params.append('designation', data.designation);
        if (data.activeStatus) params.append('activeStatus', data.activeStatus);
        const queryString = params.toString();
        return axios.get(`${QTurl}lead/my-team-performance${queryString ? '?' + queryString : ''}`);
    },
    getTeamBandwidth: function (data = {}) {
        const params = new URLSearchParams();
        if (data.city) params.append('city', data.city);
        if (data.experienceCenter) params.append('experienceCenter', data.experienceCenter);
        if (data.designation) params.append('designation', data.designation);
        if (data.salesWonStartDate) params.append('salesWonStartDate', data.salesWonStartDate);
        if (data.salesWonEndDate) params.append('salesWonEndDate', data.salesWonEndDate);
        const queryString = params.toString();
        return axios.get(`${QTurl}lead/team-bandwidth${queryString ? '?' + queryString : ''}`);
    },
    getOdmAgmApprovals: function (data = {}) {
        const params = new URLSearchParams();
        if (data.startDate) params.append('startDate', data.startDate);
        if (data.endDate) params.append('endDate', data.endDate);
        if (data.status) params.append('status', data.status);
        if (data.category) params.append('category', data.category);
        if (data.user) params.append('user', data.user);
        if (data.role) params.append('role', data.role);
        if (data.page) params.append('page', data.page);
        if (data.limit) params.append('limit', data.limit);
        const queryString = params.toString();
        return axios.get(`${QTurl}lead/odm-agm-approvals${queryString ? '?' + queryString : ''}`);
    },
    getOdmAgmSummaryDashboard: function (data = {}) {
        const params = new URLSearchParams();
        if (data.startDate) params.append('startDate', data.startDate);
        if (data.endDate) params.append('endDate', data.endDate);
        const queryString = params.toString();
        return axios.get(`${QTurl}lead/odm-agm-summary-dashboard${queryString ? '?' + queryString : ''}`);
    },
    getLeadDesignDetails: function (leadIds) {
        return axios.put(`${QTurl}lead/get-lead-details`, {
            leadIds: Array.isArray(leadIds) ? leadIds : [leadIds]
        });
    },
    getLeadDetailsOdmAgm: function (leadIds) {
     return axios.put(`${QTurl}lead/get-lead-details-odm-agm`, {
       leadIds: Array.isArray(leadIds) ? leadIds : [leadIds]
     });
    },

    dashboardSummary: function (data) {
        return axios.get(`${QTurl}leadJourney/dashboardSummary?startDate=${data.startDate}&endDate=${data.endDate}`)
    },
    performanceForDesigner: function (obj) {
        return axios.get(`${QTurl}target/performanceForDesigner/${obj.userId}?startDate=${obj.startDate}&endDate=${obj.endDate}`);
    },
    sendApprovalReminder :  function (payload) {
        return axios.post(`${QTurl}lead/send-approval-reminder`, payload);
    },
    leadLifeCycleDashboard: function (data) {
        return axios.get(`${QTurl}automationLead/leadLifeCycleDashboard?startDate=${data.startDate}&endDate=${data.endDate}&selectedSources=${data.selectedSources}`)
    },
    leadLifeCycleData: function (data) {
        return axios.post(`${QTurl}automationLead/getDataLeadLifeCycle`, data)
    },
    getChannelPartnerDashboard: function (data) {
        return axios.get(`${QTurl}automationLead/getChannelPartnerDashboard?startDate=${data.startDate}&endDate=${data.endDate}&selectedSources=${data.selectedSources}`)
    },
    channelPartnerData: function (data) {
        return axios.post(`${QTurl}automationLead/getDataChannelPartner`, data)
    },
    getChannelPartnerPerformance: function (data) {
        return axios.get(`${QTurl}automationLead/getChannelPartnerPerformance?startDate=${data.startDate}&endDate=${data.endDate}&selectedSources=${data.selectedSources}`)
    },
    getChannelPartnerLeadDetails: function (data) {
        return axios.post(`${QTurl}automationLead/getChannelPartnerLeadDetails`, data)
    },
    whatsAppCampaignDashboard: function(data) {
        return axios.get(`${QTurl}automationLead/whatsAppCampaignDashboard?startDate=${data.startDate}&endDate=${data.endDate}&selectedCampaigns=${data.selectedCampaigns}`)
    },
    whatsAppCampaignData: function (data) {
        return axios.get(`${QTurl}automationLead/getDataWhatsAppDashboard?startDate=${data.startDate}&endDate=${data.endDate}&selectedCampaigns=${data.selectedCampaigns}&stage=${data.stage}&month=${data.month}`)
    },
    getHoldLeads: function (data) {
        return axios.get(`${QTurl}automationLead/holdDashboard?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&selectedLocation=${data.selectedLocation}&selectedSourceOfLead=${data.selectedSourceOfLead}&userExpCenter=${data.userExpCenter}&userLocation=${data.userLocation}`)
    },
    holdDashboardData: function (data) {
        return axios.put(`${QTurl}automationLead/getDataOnClickHold`, data)
    },
    getUnderExecutionLeadsForInitiationBomDataTable: function (data) { 
        return axios.get(`${QTurl}lead/getUnderExecutionLeadsForInitiationBomDataTable?startDate=${data.startDate}&endDate=${data.endDate}&selectedExperienceCenter=${data.selectedExperienceCenter}&pivotValue=${data.pivotValue}&userId=${data.userId}&selectedRole=${data.selectedRole}&userExpeCenterId=${data.userExpeCenterId}&searchType=${data.searchType}&search=${data.search}&selectedLocation=${data.selectedLocation}&selectedQCStage=${data.selectedQCStage}&selectedUsers=${data.selectedUsers}&userLocationData=${data.userLocationData}`);
    },

    initiationBomTableOps : function(obj){
        return axios.put(`${QTurl}lead/initiationBomTableOps`, obj)
    },
    // Marketing tobeCalled api
    getToBeCalledMarketingData: function (obj){
        return axios.get(`${QTurl}lead/getToBeCalledMarketingData/?searchType=${obj.searchType}&search=${obj.search}&dateFilterType=${obj.dateFilterType}&startDate=${obj.startDate}&endDate=${obj.endDate}&experienceCenterId=${obj.experienceCenterId}`);
    },
    getOnHoldMarketingData: function (obj){
        return axios.get(`${QTurl}lead/getOnHoldMarketingData/?searchType=${obj.searchType}&search=${obj.search}&dateFilterType=${obj.dateFilterType}&startDate=${obj.startDate}&endDate=${obj.endDate}&experienceCenterId=${obj.experienceCenterId}`);
    },
    getOnNTBCHoldMarketingData: function (obj){
        return axios.get(`${QTurl}lead/getOnNTBCHoldMarketingData/?searchType=${obj.searchType}&search=${obj.search}&dateFilterType=${obj.dateFilterType}&startDate=${obj.startDate}&endDate=${obj.endDate}&experienceCenterId=${obj.experienceCenterId}`);
    },
    getJunkMarketingData: function (obj){
        return axios.get(`${QTurl}lead/getJunkMarketingData/?searchType=${obj.searchType}&search=${obj.search}&dateFilterType=${obj.dateFilterType}&startDate=${obj.startDate}&endDate=${obj.endDate}&experienceCenterId=${obj.experienceCenterId}`);
    },
    getLeadReturnedBySales: function (obj){
        return axios.get(`${QTurl}lead/getLeadReturnedBySales/?searchType=${obj.searchType}&search=${obj.search}&dateFilterType=${obj.dateFilterType}&startDate=${obj.startDate}&endDate=${obj.endDate}&experienceCenterId=${obj.experienceCenterId}`);
    },
    Sendfollowupmail :  function (payload) {
        return axios.post(`${QTurl}lead/send-follow-up-mail`, payload);
    },

    // This is BOM Segeragtion API start here.
    segregateHandleBom : function (formData){
        return axios.post(`${Apiurl}bomSegregation/segregateHandleBom`,formData);
    },

    downloadSegregatedBomExcel : function (formData){
        return axios.post(`${Apiurl}bomSegregation/download-segregated-excel`,formData, { responseType: "blob" });
    },

    segregatedBomFileCreation : function (formData){
        return axios.post(`${Apiurl}bomSegregation/segregateHandleBom/projects-wise-file-creation`,formData);
    },

    segregatedBomFileAutoUplaod : function (formData){
        return axios.post(`${Apiurl}bomSegregation/segregateHandleBom/project-wise-auto-upload`,formData);
    },

    DownLoadExcelConversionData: function(obj){
        return axios.get(`${QTurl}lead/DownLoadExcelConversionData?startDate=${obj.startDate}&endDate=${obj.endDate}`,{
            responseType: 'blob' 
          });
    },
    resendDesignHoldButton :function(obj){
        return axios.post(`${QTurl}lead/send-design-hold-approval-email`,obj);
    },
    OcrUploaderToOpenAI : function (data){
        return axios.post(`${decorURL}ocr-with-OpenAI/OpenAI-ocr`,data);
    },
    extractCompletionCertificate: function (data){
        return axios.post(`${decorURL}ocr-with-OpenAI/handover-validate`,data);
    },

    resendKickOffApprovalEmail :function(obj){
        return axios.post(`${QTurl}lead/resend-kickoff-approval-email`,obj);
    },

    updateGstDetails :function(obj){
        return axios.put(`${QTurl}lead/updateGstDetails`, obj);
    },
    updateSalesWonDate : function (data){
        return axios.put(`${QTurl}lead/updateSalesWonDate`,data);
    },

    addMaterialToBomSegregate : function (formData){
        return axios.put(`${Apiurl}bomSegregation/addMaterialToBomSegregate`,formData);
    },
    compareMonthwiseCount: function () {
        return axios.get(`${QTurl}leadJourney/compareMonthwiseCount`)
    },
    syncLeadJourneyFromLead: function (data) {
        return axios.post(`${QTurl}leadJourney/syncLeadJourneyFromLead`, data)
    },
    diffLeadsForMonth: function (data) {
        return axios.get(`${QTurl}leadJourney/diffLeadsForMonth?month=${data.month}&year=${data.year}`)
    },

    getAllEdgeBandMaterial: function() {
        return axios.get(`${Apiurl}project-material/getAllEdgeBandMaterial`);
    },

    updateNewApprovedMaterialInBOM: function(data) {
        return axios.patch(`${Apiurl}project-material/updateNewApprovedMaterialInBOM`, data);
    },
    
    leadHelthData:function (data){
        return axios.post(`${QTurl}lead/erp-leads-health`,data);
    },

    // Employee Rewards Points System- Designer.
    getERPSUsersData: function (data) {
        return axios.get(`${QTurl}employeeRewardsPointsDesigner/getERPSUsersData?designUserRoleId=${data.designUserRoleId}&allExpIds=${data.allExpIds.join(',')}`);
    },
    getERPSRewardsData: function (data) {
        return axios.get(`${QTurl}employeeRewardsPointsDesigner/getRewardsData?userIds=${data.userIds ? data.userIds.join(',') : ''}&experienceCenterIds=${data.experienceCenterIds ? data.experienceCenterIds.join(',') : ''}&selectedExperienceCenter=${data.selectedExperienceCenter ? data.selectedExperienceCenter.join(',') : ''}&selectedLocation=${data.selectedLocation ? data.selectedLocation.join(',') : ''}&month=${data.month || ''}&year=${data.year || ''}&achievementPercentage=${data.achievementPercentage || ''}&startDate=${data.startDate || ''}&endDate=${data.endDate || ''}&searchType=${data.searchType || ''}&search=${data.search || ''}&locationIds=${data.locationIds ? data.locationIds.join(',') : ''}&loginInUser=${data.loginInUser || ''}&viewMode=${data.viewMode || ''}`);
    },
    getHierarchyUsers: function (params) {
    return axios.get(`${QTurl}employeeRewardsPointsDesigner/getHierarchyUsers`, { params });
    },
    getManagerLocations: function () {
        return axios.get(`${QTurl}employeeRewardsPointsDesigner/getManagerLocations`);
    },
    getLeadNPS: function(leadId) {
    return axios.get(`${QTurl}employeeRewardsPointsDesigner/getLeadNPS?leadId=${leadId}`);
    },
    getGiftItems: function (points) {
        return axios.get(`${QTurl}employeeRewardsPointsDesigner/getGiftItems?points=${points}`);
    },
    requestRedemption: function (data) {
        return axios.post(`${QTurl}employeeRewardsPointsDesigner/requestRedemption`, data);
    },
    getRedemptionHistory: function (userId) {
        return axios.get(`${QTurl}employeeRewardsPointsDesigner/getRedemptionHistory?userId=${userId}`);
    },
    getRewardConfig: function () {
        return axios.get(`${QTurl}employeeRewardsPointsDesigner/getRewardConfig`);
    },
    updateRewardConfig: function (data) {
        return axios.post(`${QTurl}employeeRewardsPointsDesigner/updateRewardConfig`, data);
    },
    // Reward END
    fetchChannelPartnerReportData: function (obj){
        return axios.get(`${QTurl}lead/fetchChannelPartnerReportData/?startDate=${obj.startDate}&endDate=${obj.endDate}&dateType=${obj.dateType}`);
    },
    getAllVendorsPaginated: function (params) {
        return axios.post(`${Apiurl}vendor/getAllVendorsPaginated?${params}`)
    },
    getCustomerInfo: function (uniqueLeadNo) {
        return axios.get(`${QTurl}referral/customer-info/${uniqueLeadNo}`);
    },
    getByUniqueLeadNo: function (uniqueLeadNo) {
        return axios.get(`${QTurl}xoxodayErp/getByUniqueLeadNumber/${uniqueLeadNo}`);
    },
    createXoxoday: function (data) {
        return axios.post(`${QTurl}xoxodayErp/create-xoxoday-gift`, data)
    },
    getBotWotChatConversations: function (data) {
        return axios.get(`${QTurl}automationLead/botwot-chat-conversations?leadId=${data.leadId}`);
    },
    // furniture one functions/apis
    saveQuotationFurnitureOne: function (data) {
        return axios.post(`${QTurl}furnitureOne/save-Quotation`, data);
    },
    // marking an quotation as paid.
    markPaidAndCreateInvoice: function (data) {
        return axios.post(`${QTurl}furnitureOne/create-invoice-from-quotation`, data);
    },
    // This API is to get the project lead details for furniture one quotation.
     getProjectLeadDetailsFurnitureOne(projectId) { 
        return axios.get(`${QTurl}furnitureOne/leadDetails/?leadId=${projectId}`);
    },
    // This API is to get the quotation details for furniture one quotation.
     getQuotationFurnitureOne: function (leadId) {
        return axios.get(`${QTurl}furnitureOne/get-Quotation/?leadId=${leadId}`)
    },
    sendQuotationMailOrWhatsappForFurnitureOne : function (data){
         return axios.post(`${QTurl}furnitureOne/sendQuotationMailOrWhatsapp`,data)
    },
    generateQuotationPDF: (data) => {
         return axios.post(`${QTurl}furnitureOne/generate-pdf`, data)
    },

    // getting all items for zoho pos..
    furnitureOneZohoItems : () =>{
     return axios.get(`${QTurl}furnitureOne/zoho/items`)
    },
    // get all items from erp. 
    getFurnitureItems: (params = {}) => {
    return axios.get(`${QTurl}furnitureOne/getFurnitureItems`, { params });
   },
   // get single item from zoho 
    getSingleZohoItem: (itemId) => {
    return axios.get(`${QTurl}furnitureOne/zoho/items/${itemId}`);
   },
   updateFurnitureItemAll: (item_id, data) => {
    return axios.put(`${QTurl}furnitureOne/updateFurnitureItem/${item_id}`, data);
   },
   // sending approval for furniture one discount to  AGM/DGM.
   sendDiscountApprovalForFurnitureOne : (data) => {
    return axios.post(`${QTurl}furnitureOne/sendDiscountApprovalForF1`, data)
   },
   // getting all the discount approval data for AGM/DGM.
    getDiscountApprovalDataForFurnitureOne(page = 1, limit = 50) {
        return axios.get(`${QTurl}furnitureOne/getPendingApprovalForF1?page=${page}&limit=${limit}`);
    },
   // approving or rejecting the discount approval for furniture one by AGM/DGM.
   approveRejectDiscountForFurnitureOne : (data) => {
    return axios.put(`${QTurl}furnitureOne/approveRejectDiscountForF1`, data)
   },
   updateFurnitureOneItems : (data) =>{
       return axios.put(`${QTurl}furnitureOne/updateImageUrl`, data)
   },
 // furniture one functions/apis ends here 
    refundBankDetailsSave(formData) {
        const url = `${QTurl}referral/submit_refund_bank_details`;
        return axios.post(url, formData);
    },

    // Hr racksheet apis
    getHrStatusColorCodes: function () {
        return axios.get(`${QTurl}hrStatusColorCode`);
    },
    getHrStatusColorCodeById: function (id) {
        return axios.get(`${QTurl}hrStatusColorCode/${id}`);
    },
    createHrStatusColorCode: function (data) {
        return axios.post(`${QTurl}hrStatusColorCode`, data);
    },
    updateHrStatusColorCode: function (id, data) {
        return axios.put(`${QTurl}hrStatusColorCode/${id}`, data);
    },
    deleteHrStatusColorCode: function (id) {
        return axios.delete(`${QTurl}hrStatusColorCode/${id}`);
    },

    createRoster: function (data) {
        return axios.post(`${QTurl}roster/create`, data);
    },
    getAllRoster: function (params = {}) {
        const page = params.page != null ? params.page : 1;
        const limit = params.limit != null ? params.limit : 100;
        let url = `${QTurl}roster/get-all?page=${page}&limit=${limit}`;
        [
            "empId",
            "name",
            "emailId",
            "role",
            "department",
            "city",
            "ec",
            "status",
        ].forEach((key) => {
            if (params[key]) {
                url += `&${key}=${encodeURIComponent(params[key])}`;
            }
        });
        return axios.get(url);
    },
    deactivateRoster: function (id, extraData = {}) {
        return axios.put(`${QTurl}roster/deactivate/${id}`, extraData);
    },
    updateRoster: function (id, data) {
        return axios.put(`${QTurl}roster/update/${id}`, data);
    },
    deleteRoster: function (id) {
        return axios.delete(`${QTurl}roster/delete/${id}`);
    },
    getRosterCompanyWideSummary: function () {
        return axios.get(`${QTurl}roster/summary/company-wide`);
    },
    getRosterSummaryByCity: function () {
        return axios.get(`${QTurl}roster/summary/by-city`);
    },
    getRosterSummaryByEC: function () {
        return axios.get(`${QTurl}roster/summary/by-EC`);
    },
    getRosterOpenRequisitionsSummary: function () {
        return axios.get(`${QTurl}roster/summary/open-requisitions`);
    },
    getRosterAtRiskSummary: function () {
        return axios.get(`${QTurl}roster/summary/at-risk-headcount`);
    },
    getRosterDesignHierarchy: function () {
        return axios.get(`${QTurl}roster/design-hierarchy`);
    },
    getRosterSalesHierarchy: function () {
        return axios.get(`${QTurl}roster/sales-hierarchy`);
    },
    getRosterOperationsHierarchy: function () {
        return axios.get(`${QTurl}roster/operations-hierarchy`);
    },
    leadHelthNotesPending:function (data){
        return axios.post(`${QTurl}lead/erp-leads-notes-pending`,data);
    },
    IdsoCount: (params = {}) =>{
        return axios.get(`${QTurl}lead/getIDSOData`, { params: { page: 1, limit: 10, ...params } });
    },
    dsoCount: (params = {}) =>{
        return axios.get(`${QTurl}lead/DsoPaymentNotCollected`, { params: { page: 1, limit: 10, ...params } });
    },
    PaymentCollectedNotinUnderExecution:(params = {}) =>{
        return axios.get(`${QTurl}lead/PaymentCollectedNotinUnderExecution`, { params: { page: 1, limit: 10, ...params } });
    },
    DsoPaymentNotCollectedYesCondition:(params = {}) =>{
        return axios.get(`${QTurl}lead/DsoPaymentNotCollectedYesCondition`, { params: { page: 1, limit: 10, ...params } });
    },
    DsoPaymentNotCollectedSecondCondition:(page = 1, limit = 10) =>{
        return axios.get(`${QTurl}lead/DsoPaymentNotCollectedSecondCondition?page=${page}&limit=${limit}`);
    },
    
    DsoPaymentNotCollectedThirdCondition:(params = {}) =>{
        return axios.get(`${QTurl}lead/DsoPaymentNotCollectedThirdCondition`, { params: { page: 1, limit: 10, ...params } });
    },
    DsoPaymentNotCollectedOtherCondition: function (params = {}) {
        return axios.get(`${QTurl}lead/DsoPaymentNotCollectedOtherConditions`, { params: { page: 1, limit: 10, ...params } });
    },
    getExecutivePerformanceData:() =>{
        return axios.get(`${QTurl}lead/manager/dashboard-data`);
    },
    updatePaymentDate: (data) =>{
        return axios.put(`${QTurl}lead/updatePaymentDate`, data);
    },
    getUpdatePaymentDate: (params = {}) =>{
        return axios.get(`${QTurl}lead/getUpdatePaymentDate`, { params: { page: 1, limit: 10, ...params } });
    },

    rfdManagerexucativedata: (data) =>{
        return axios.get(`${QTurl}lead/rfdManager-exucative-data`);
    },
    getLeadDetailsByIds(data) {
        return axios.post(`${QTurl}lead/manager/get-lead-details-by-ids`,data );
    },
    getFactoryCRMUsers() {
        return axios.get(`${QTurl}lead/getFactoryCRMUsers` );
    },
    assignFactoryCRMToLead(data) {
        return axios.post(`${QTurl}lead/assignFactoryCRMToLead`, data);
    },
    assignLeadToExperienceCenter(data) {
        // data: { leadId, experienceCenterId }
        return axios.put(`${QTurl}lead/assignToExperienceCenter`, data);
    },
    getRfdExecutiveSummary: function (data) {
        return axios.get(`${QTurl}lead/RfdExecutiveSummary?fromDate=${data.fromDate}&toDate=${data.toDate}`);
    },

    getRfdExecutiveWorkStatus: function () {
        return axios.get(`${QTurl}lead/RfdExecutiveWorkStatus`);
    },

    getUserTaggedExpCenterDetails: function () {
        return axios.get(`${QTurl}experience-center/userTaggedDetails`);
    },

    buildDeliveryPackageRequestData: function (data) {
        const body = { ...data };
        if (Array.isArray(body.experienceCenter)) {
            body.experienceCenter = body.experienceCenter.filter(Boolean);
        }
        if (Array.isArray(body.user)) {
            body.user = body.user.filter(Boolean);
        }
        return body;
    },

    getDeliveryPackageScanSummary: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackageScanSummary`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackageScanSummary] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}deliveryPackageScanSummary`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackageScanDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackageScanDetails`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackageScanDetails] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackageScanDetails`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackagePartialScanSummary: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackagePartialScanSummary`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackagePartialScanSummary] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackagePartialScanSummary`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackagePartialScanDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        console.log('[deliveryPackagePartialScanDetails] POST body:', body);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackagePartialScanDetails`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackagePartialScanDetails] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackagePartialScanDetails`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackagePanelDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackagePanelDetails`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackagePanelDetails] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackagePanelDetails`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackagePartialPanelDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackagePartialPanelDetails`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackagePartialPanelDetails] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackagePartialPanelDetails`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackageHardwareItemDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackageHardwareItemDetails`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackageHardwareItemDetails] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackageHardwareItemDetails`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    getDeliveryPackagePartialHardwareItemDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        try {
            return await axios.post(`${deliveryUrl}dashboard/deliveryPackagePartialHardwareItemDetails`, body);
        } catch (error) {
            const cannotPost =
                error?.response?.status === 404 ||
                String(error?.response?.data || '').includes('Cannot POST');
            if (!cannotPost) throw error;

            console.warn('[deliveryPackagePartialHardwareItemDetails] POST failed, falling back to GET');
            return axios.get(`${deliveryUrl}dashboard/deliveryPackagePartialHardwareItemDetails`, {
                params: {
                    ...body,
                    experienceCenter: body.experienceCenter?.join(','),
                },
            });
        }
    },

    mergeDeliverySummaryResponses: function (partialResponse, fullResponse) {
        const partialResult = partialResponse?.data || {};
        const fullResult = fullResponse?.data || {};

        const partialData = (Array.isArray(partialResult.data) ? partialResult.data : []).map((row) => ({
            ...row,
            deliveryType: 'Partial',
            _deliverySource: 'partial',
        }));
        const fullData = (Array.isArray(fullResult.data) ? fullResult.data : []).map((row) => ({
            ...row,
            deliveryType: 'Full',
            _deliverySource: 'full',
        }));

        return {
            data: {
                ...partialResult,
                data: [...partialData, ...fullData],
                totalRecords: (partialResult.totalRecords || 0) + (fullResult.totalRecords || 0),
                nextPage: Boolean(partialResult.nextPage || fullResult.nextPage),
                partialTotalRecords: partialResult.totalRecords || 0,
                fullTotalRecords: fullResult.totalRecords || 0,
                partialNextPage: Boolean(partialResult.nextPage),
                fullNextPage: Boolean(fullResult.nextPage),
            },
        };
    },

    getDeliveryPackageCombinedScanSummary: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        const [partialResponse, fullResponse] = await Promise.all([
            this.getDeliveryPackagePartialScanSummary(body),
            this.getDeliveryPackageScanSummary(body),
        ]);
        return this.mergeDeliverySummaryResponses(partialResponse, fullResponse);
    },

    getDeliveryPackageCombinedScanDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        const { deliverySource, ...requestBody } = body;

        if (deliverySource === 'full') {
            return this.getDeliveryPackageScanDetails(requestBody);
        }
        return this.getDeliveryPackagePartialScanDetails(requestBody);
    },

    getDeliveryPackageCombinedPanelDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        const { deliverySource, ...requestBody } = body;

        if (deliverySource === 'full') {
            return this.getDeliveryPackagePanelDetails(requestBody);
        }
        return this.getDeliveryPackagePartialPanelDetails(requestBody);
    },

    getDeliveryPackageCombinedHardwareItemDetails: async function (data) {
        const body = this.buildDeliveryPackageRequestData(data);
        const { deliverySource, ...requestBody } = body;

        if (deliverySource === 'full') {
            return this.getDeliveryPackageHardwareItemDetails(requestBody);
        }
        return this.getDeliveryPackagePartialHardwareItemDetails(requestBody);
    },

    getSnagProjects: function (params = {}) {
        const query = {};
        if (params.search) query.search = params.search;
        if (params.startDate) query.startDate = params.startDate;
        if (params.endDate) query.endDate = params.endDate;
        return axios.get(`${deliveryUrl}project/getSnagProjects`, { params: query });
    },

    getHardwareSnagProjects: function (params = {}) {
        const query = {};
        if (params.search) query.search = params.search;
        if (params.startDate) query.startDate = params.startDate;
        if (params.endDate) query.endDate = params.endDate;
        return axios.get(`${Apiurl}hardware-snag/projects`, { params: query });
    },

    getHardwareSnagProjectDetails: function (projectNo) {
        return axios.get(`${Apiurl}hardware-snag/projects/${encodeURIComponent(projectNo)}`);
    },
    updateHardwareSnagProjectRemark: function (projectNo, data = {}) {
        return axios.put(
            `${Apiurl}hardware-snag/projects/${encodeURIComponent(projectNo)}/remark`,
            data
        );
    },
    updateHardwareSnagRemark: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/remark`, data);
    },

    exportHardwareSnagProjectItems: function (projectNos = []) {
        return axios.post(`${Apiurl}hardware-snag/projects/export-items`, { projectNos });
    },

    getHardwareBomByProjectNumber: function (projectNo) {
        return axios.get(`${Apiurl}hardware-bom/${encodeURIComponent(projectNo)}`);
    },

    markHardwareSnagPresentInBom: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/present-in-bom`, data);
    },

    markHardwareSnagNotPresentInBom: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/not-present-in-bom`, data);
    },

    approveHardwareSnagNotPresentInBom: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/approve-not-present-in-bom`, data);
    },

    rejectHardwareSnagNotPresentInBom: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/reject-not-present-in-bom`, data);
    },

    outwardHardwareSnagItem: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/outward`, data);
    },

    getHardwareSnagLogs: function (snagId, params = {}) {
        return axios.get(`${Apiurl}hardware-snag/${snagId}/logs`, { params });
    },

    updateHardwareSnagItemReason: function (snagId, data = {}) {
        return axios.put(`${Apiurl}hardware-snag/${snagId}/update-item-reason`, data);
    },

    getSnagPanelDetails: function (data = {}) {
        return axios.post(`${deliveryUrl}project/getSnagPanelDetails`, data);
    },

    downloadSnagPanelDetails: function (data = {}, config = {}) {
        return axios.post(`${deliveryUrl}project/downloadSnagPanelDetails`, data, {
            responseType: 'blob',
            ...config,
        });
    },

    getProductionSummaryPanelDetails: function (data = {}) {
        return axios.post(`${deliveryUrl}project/getProductionSummaryPanelDetails`, data);
    },

    downloadProductionSummaryPanelDetails: function (data = {}, config = {}) {
        return axios.post(`${deliveryUrl}project/downloadProductionSummaryPanelDetails`, data, {
            responseType: 'blob',
            ...config,
        });
    },

    downloadDeliveryPackagePanelDetails: function (data = {}, config = {}) {
        return axios.post(`${deliveryUrl}dashboard/downloadDeliveryPackagePanelDetails`, data, {
            responseType: 'blob',
            ...config,
        });
    },

    getProductionSummaryProjects: function (params = {}) {
        const query = {};
        if (params.searchType) query.searchType = params.searchType;
        if (params.search) query.search = params.search;
        if (params.cityName) query.cityName = params.cityName;
        if (params.currentStage) query.currentStage = params.currentStage;
        if (params.createdStartDate) query.createdStartDate = params.createdStartDate;
        if (params.createdEndDate) query.createdEndDate = params.createdEndDate;
        if (params.productionStartFrom) query.productionStartFrom = params.productionStartFrom;
        if (params.productionStartTo) query.productionStartTo = params.productionStartTo;
        return axios.get(`${deliveryUrl}project/getProductionSummaryProjects`, { params: query });
    },

    setMaterialReadinessDate: function (data = {}) {
        return axios.post(`${QTurl}factoryStageLeadDetails/setMaterialReadinessDate`, data);
    },

    getKekaDepartments: function () {
        return axios.get(`${QTurl}kekaDepartment`);
    },
    createKekaDepartment: function (data) {
        return axios.post(`${QTurl}kekaDepartment`, data);
    },
    updateKekaDepartment: function (id, data) {
        return axios.put(`${QTurl}kekaDepartment/${id}`, data);
    },
    deleteKekaDepartment: function (id) {
        return axios.delete(`${QTurl}kekaDepartment/${id}`);
    },
    getKekaRoles: function () {
        return axios.get(`${QTurl}kekaRole`);
    },
    createKekaRole: function (data) {
        return axios.post(`${QTurl}kekaRole`, data);
    },
    updateKekaRole: function (id, data) {
        return axios.put(`${QTurl}kekaRole/${id}`, data);
    },
    deleteKekaRole: function (id) {
        return axios.delete(`${QTurl}kekaRole/${id}`);
    },
    getKekaCities: function () {
        return axios.get(`${QTurl}kekaCity`);
    },
    createKekaCity: function (data) {
        return axios.post(`${QTurl}kekaCity`, data);
    },
    updateKekaCity: function (id, data) {
        return axios.put(`${QTurl}kekaCity/${id}`, data);
    },
    deleteKekaCity: function (id) {
        return axios.delete(`${QTurl}kekaCity/${id}`);
    },
    getKekaExperienceCenters: function () {
        return axios.get(`${QTurl}kekaExperienceCenter`);
    },
    createKekaExperienceCenter: function (data) {
        return axios.post(`${QTurl}kekaExperienceCenter`, data);
    },
    updateKekaExperienceCenter: function (id, data) {
        return axios.put(`${QTurl}kekaExperienceCenter/${id}`, data);
    },
    deleteKekaExperienceCenter: function (id) {
        return axios.delete(`${QTurl}kekaExperienceCenter/${id}`);
    },
    
    getPaymentRequestBreakdown: (orderId) => {
        return axios.get(`${Apiurl}serviceOrder/payment-request-breakdown/${orderId}`);
    },
    updatePaymentRequestBreakdown: (orderId, data) => {
        return axios.patch(`${Apiurl}serviceOrder/payment-request-breakdown/${orderId}`, data);
    },
    getPaymentRequestBreakdownPO: (vendorId) => {
        return axios.get(`${Apiurl}inwardingPaymentRequest/payment-request-breakdown-po/${vendorId}`);
    },
    updatePaymentRequestBreakdownPO: (vendorId, data) => {
        return axios.patch(`${Apiurl}inwardingPaymentRequest/payment-request-breakdown-po/${vendorId}`, data);
    },
    blockVendor: function (vendorId, blocked, remark) {
        return axios.put(`${Apiurl}vendor/blockVendor/${vendorId}`, { blocked, remark })
    },
    getVendorLogs: function ({ page = 1, limit = 20, vendorName, type } = {}) {
        return axios.get(`${Apiurl}vendor/vendorLogs`, { params: { page, limit, vendorName, type } })
    },

    // Paginated rack logs:

    getHrRackLogsGetAll: (params = {}) => {
        const page = params.page != null ? params.page : 1;
        const limit = params.limit != null ? params.limit : 10;
        const queryParams = [`page=${page}`, `limit=${limit}`];
        if (params.empId != null && String(params.empId).trim() !== "") {
            queryParams.push(`empId=${encodeURIComponent(String(params.empId).trim())}`);
        }
        if (params.action != null && String(params.action).trim() !== "") {
            queryParams.push(`action=${encodeURIComponent(String(params.action).trim())}`);
        }
        return axios.get(`${QTurl}hrRackLogs/get-all?${queryParams.join("&")}`);
    },

    uploadHrStatusColorCodeExcel: function (file, extraData = {}) {
        const appendableFields = Object.keys(extraData || {}).reduce((acc, key) => {
            const value = extraData[key];
            if (value !== undefined && value !== null && String(value).trim() !== "") {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        const queryParams = Object.keys(appendableFields).map(
            (key) => `${encodeURIComponent(key)}=${encodeURIComponent(appendableFields[key])}`
        );
        const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
        const uploadUrl = `${QTurl}roster/upload-roster${queryString}`;
        const formData = new FormData();
        Object.keys(appendableFields).forEach((key) => {
            formData.append(key, appendableFields[key]);
        });
        formData.append("file", file, file?.name || "upload.xlsx");
        return axios.post(uploadUrl, formData);
    },

    // AI Calling Analytics (HoomanLabs) dashboard:

    getAiCallingAnalyticsFilters() {
        return axios.get(`${QTurl}aiCallingAnalytics/filters`);
    },
    getAiCallingAnalyticsSummary(params = {}) {
        return axios.get(`${QTurl}aiCallingAnalytics/summary`, { params });
    },
    getAiCallingAnalyticsDrilldown(params = {}) {
        return axios.get(`${QTurl}aiCallingAnalytics/drilldown`, { params });
    },

    // Move to Marketing - AI classifier review dashboard (founder-facing):
    getMoveToMarketingClassifierDashboard(params = {}) {
        return axios.get(`${QTurl}lead/moveToMarketingClassifierDashboard`, { params });
    },

    // BotWot WhatsApp funnel - how many leads were texted, how many replied.
    // params: { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' }
    // Served from /api/lead (already behind the ERP JWT) rather than
    // /api/hoomanLabs, whose router requires the shared HoomanLabs API key.
    getBotWotWhatsAppStats(params = {}) {
        return axios.get(`${QTurl}lead/botwotWhatsAppStats`, { params });
    },
      // ────────────all misc payment related  HTTP function starting from here. ──────
    onBoardECOwner : function (obj) {
        return axios.post(`${QTurl}miscPayment/ex/owners/onboard`,obj)
    },
    // fetch a single onboarded rental owner (used for the Edit flow)
    getRentalOwner: function (id) {
        return axios.get(`${QTurl}miscPayment/ex/owners/record/${id}`);
    },
    // update an onboarded rental owner — resets approval if it was already active
    updateRentalOwner: function (id, obj) {
        return axios.put(`${QTurl}miscPayment/ex/owners/update/${id}`, obj);
    },
    getRentalOwnerAadhaar: function (id) {
        return axios.get(`${QTurl}miscPayment/ex/owners/${id}/aadhaar`);
    },
    // bulk-download all attachments for an owner/provider as a zip
    downloadOwnerDocumentsZip: function (id) {
        return axios.get(`${QTurl}miscPayment/ex/owners/${id}/documents/zip`, { responseType: "blob" });
    },
    downloadServiceProviderDocumentsZip: function (id) {
        return axios.get(`${QTurl}miscPayment/ex/service-providers/${id}/documents/zip`, { responseType: "blob" });
    },
    // get all draft user wise for onboarding owner
    getRentalOwnerDrafts: function () {
        return axios.get(`${QTurl}miscPayment/ex/owners/drafts`);
    },
    // delete rental for an owner ..
    deleteRentalOwnerDraft: function (draftId) {
        return axios.delete(`${QTurl}miscPayment/ex/owners/draft/${draftId}` );
    },
    // update draft for an owner
    updateRentalOwnerDraft: function (draftId, obj) {
        return axios.put( `${QTurl}miscPayment/ex/owners/update-draft/${draftId}`, obj);
    },
    // crearing first time draft for an owner..
    createRentalOwnerDraft: function (obj) {
        return axios.post(`${QTurl}miscPayment/ex/owners/draft`, obj);
    },
    // ─── Service Provider Onboarding ─────────
    onBoardServiceProvider: function (obj) {
        return axios.post(`${QTurl}miscPayment/ex/service-providers/onboard`, obj);
    },
   // fetch a single onboarded service provider (used for the Edit flow)
    getServiceProvider: function (id) {
        return axios.get(`${QTurl}miscPayment/ex/service-providers/record/${id}`);
    },
    // ─── Admin-managed Service Type / Scope master data ──────────────────
    getServiceTypeConfigs: function () {
        return axios.get(`${QTurl}miscPayment/master-data/service-types/getAll`);
    },
    addServiceTypeConfig: function (data) {
        return axios.post(`${QTurl}miscPayment/master-data/service-types/add`, data);
    },
    updateServiceTypeConfig: function (data) {
        return axios.post(`${QTurl}miscPayment/master-data/service-types/update`, data);
    },
    deleteServiceTypeConfig: function (id) {
        return axios.delete(`${QTurl}miscPayment/master-data/service-types/${id}`);
    },
    // ─── Service Type Cap (Experience Centre x Service Type x Max Amount) ──
    getServiceTypeCaps: function (experienceCenterId) {
        return axios.get(`${QTurl}miscPayment/master-data/service-caps/getAll`, { params: experienceCenterId ? { experienceCenterId } : {} });
    },
    addServiceTypeCap: function (data) {
        return axios.post(`${QTurl}miscPayment/master-data/service-caps/add`, data);
    },
    updateServiceTypeCap: function (data) {
        return axios.post(`${QTurl}miscPayment/master-data/service-caps/update`, data);
    },
    deleteServiceTypeCap: function (id) {
        return axios.delete(`${QTurl}miscPayment/master-data/service-caps/${id}`);
    },
    lookupServiceTypeCap: function (experienceCenterId, service_type) {
        return axios.get(`${QTurl}miscPayment/master-data/service-caps/lookup`, { params: { experienceCenterId, service_type } });
    },
    // update an onboarded service provider — resets approval if it was already active
    updateServiceProvider: function (id, obj) {
        return axios.put(`${QTurl}miscPayment/ex/service-providers/update/${id}`, obj);
    },
    // create service provider draft.. 
    createServiceProviderDraft: function (obj) {
        return axios.post(`${QTurl}miscPayment/ex/service-providers/draft`, obj);
    },
    // update service provided draft
    updateServiceProviderDraft: function (draftId, obj) {
        return axios.put(`${QTurl}miscPayment/ex/service-providers/update-draft/${draftId}`, obj);
    },
  // get alll draft for service provideda
    getServiceProviderDrafts: function () {
        return axios.get(`${QTurl}miscPayment/ex/service-providers/drafts`);
    },
    // delete an service proved..
    deleteServiceProviderDraft: function (draftId) {
        return axios.delete(`${QTurl}miscPayment/ex/service-providers/draft/${draftId}`);
    },
    getActiveOwnersForPayment: function (draftId) {
        return axios.delete(`${QTurl}miscPayment/ex/service-providers/draft/${draftId}`);
    },

    // ─── Payment Raising ───────────────────
    // Raise a new payment request
    raisePayment: function (payload) {
        return axios.post(`${QTurl}miscPayment/ex/payments/raise`, payload);
    },

    // Get active rental owners for a specific EC (for payment dropdown)
    getActiveOwnersForPayment: function (ecId) {
        return axios.get(`${QTurl}miscPayment/ex/payments/owners/${ecId}`);
    },

    // Get active service providers for a specific EC (for payment dropdown)
    getActiveProvidersForPayment: function (ecId) {
        return axios.get(`${QTurl}miscPayment/ex/payments/providers/${ecId}`);
    },

    // Get payment history for an EC
    getPaymentHistory: function (ecId, params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/history/${ecId}`, { params });
    },
        // Get perticular user  approvals  for finance team /sreedevi mam
     getMyPaymentsForMiscPayment: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/pending`, { params });
    },
     // Get  all pending  approvals  for finance team /sreedevi mam
    getPendingPaymentsForMiscPayment: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/all-pending`, { params });
    },
    // Get payment history (approved/rejected/paid)
    getPaymentHistoryForMiscPayment: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/history`, { params });
    },
    // approve or reject misc payment by the approver..
    processApprovalForMiscPayment: function (paymentId, payload) {
        return axios.post(`${QTurl}miscPayment/ex/payments/act/${paymentId}`, payload);
    },
    // Finance Manager (Snorkel) — revise amount / mark postponed or penalty before sending to bank
    revisePaymentForMiscPayment: function (paymentId, payload) {
        return axios.patch(`${QTurl}miscPayment/ex/payments/${paymentId}/revise`, payload);
    },
    getRaisedPaymentsPending: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/raised/pending`, { params });
    },
    getRaisedPaymentsHistory: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/raised/history`, { params });
    },
    // ─── Rental Payment Notifications ──────────

    // Get rental payment notifications for the logged-in user
    getRentalPaymentNotifications: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/rental-payment-notifications`, { params });
    },

    // Get rental payment dashboard data
    getRentalDashboardData: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/dashboard/rental-payments`, { params });
    },

    // Get rental payment trends for charts
    getRentalTrends: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/dashboard/rental-trends`, { params });
    },

     // Get pending approvals for rental owners and service providers
    getPendingApprovals: function (modelType, params = {}) {
        return axios.get(`${QTurl}miscPayment/Onbaord-approval/ex/approvals/pending`, { params: { modelType, ...params } });
    },
    getAllPendingApprovals: function (modelType, params = {}) {
        return axios.get(`${QTurl}miscPayment/Onbaord-approval/ex/approvals/all-pending`, { params: { modelType, ...params } });
    },
    // Get approved history (active records)
    getApprovedHistory: function (modelType, params = {}) {
        return axios.get(`${QTurl}miscPayment/Onbaord-approval/ex/approvals/appproved`, { params: { modelType, ...params } });
    },
    // Process approval action (approve/reject)
    processApproval: function (id, payload) {
        return axios.post(`${QTurl}miscPayment/Onbaord-approval/ex/approvals/act/${id}`, payload);
    },

    // Get ERP payment requests for finance dashboard
    getERPRequestsForFinance: function (params = {}) {
        return axios.get(`${QTurl}miscPayment/ex/payments/erp-requests`, { params });
    },

    getAdhocPreview: function (projectId, type, value) {
        return axios.get(`${Apiurl}adhoc/preview/${projectId}?type=${type}&value=${value}`)
    },
    getVendorsForMaterial: function (materialId) {
        return axios.get(`${Apiurl}adhoc/vendors-for-material/${materialId}`)
    },
    createAdhocPoSo: function (data) {
        return axios.post(`${Apiurl}adhoc/create`, data)
    },
    approveAdhocRequest: function (id, data) {
        return axios.put(`${Apiurl}adhoc/${id}/approve`, data)
    },
    rejectAdhocRequest: function (id, data) {
        return axios.put(`${Apiurl}adhoc/${id}/reject`, data)
    },
    getAdhocHistory: function (projectId) {
        return axios.get(`${Apiurl}adhoc/history/${projectId}`)
    },
    getAdhocPendingForRole: function () {
        return axios.get(`${Apiurl}adhoc/pending-for-role`)
    },
    getAllAdhocTransactions: function (params) {
        const query = new URLSearchParams(params).toString()
        return axios.get(`${Apiurl}adhoc/all${query ? `?${query}` : ''}`)
    },
     // Physical Site Visit payment request flow
    raiseSiteVisitPaymentRequest(data) {
        const url = `${QTurl}referral/site-visit-payment/raise`;
        return axios.post(url, data);
    },
    getSiteVisitPaymentApprovals() {
        const url = `${QTurl}referral/site-visit-payment/approvals`;
        return axios.get(url);
    },
    getSiteVisitPaymentHistory(params) {
        const url = `${QTurl}referral/site-visit-payment/history`;
        return axios.get(url, { params });
    },
    approveSiteVisitPayment(leadId, data) {
        const url = `${QTurl}referral/site-visit-payment/${leadId}/approve`;
        return axios.put(url, data);
    },
    siteVisitBankDetailsSave(formData) {
        const url = `${QTurl}referral/submit_site_visit_bank_details`;
        return axios.post(url, formData);
    },
    getSiteVisitPaymentDetails(token) {
        const url = `${QTurl}referral/site-visit-payment/details`;
        return axios.get(url, { params: { token } });
    },
    getBankDetailsStatus({ customerId, leadId, type }) {
        const url = `${QTurl}referral/bank-details-status`;
        return axios.get(url, { params: { customerId, leadId, type } });
    },
     // ─── Channel Partner Onboarding & Payout (routes live in referral.js) ──
    onboardChannelPartner: function (obj) {
        return axios.post(`${QTurl}referral/channel-partner/onboard`, obj);
    },
    editChannelPartner: function (id, obj) {
        return axios.post(`${QTurl}referral/channel-partner/edit/${id}`, obj);
    },
    actOnChannelPartnerOnboarding: function (id, data) {
        return axios.post(`${QTurl}referral/channel-partner/act/${id}`, data);
    },
    getAllChannelPartners: function (params = {}) {
        return axios.get(`${QTurl}referral/channel-partner/all`, { params });
    },
    raiseChannelPartnerPayout: function (obj) {
        return axios.post(`${QTurl}referral/channel-partner/payment/raise`, obj);
    },
    actOnChannelPartnerPayout: function (id, data) {
        return axios.post(`${QTurl}referral/channel-partner/payment/act/${id}`, data);
    },
    getAllChannelPartnerPayments: function (params = {}) {
        return axios.get(`${QTurl}referral/channel-partner/payment/all`, { params });
    },
    getChannelPartnerAadhaar: function (id) {
        return axios.get(`${QTurl}referral/channel-partner/${id}/aadhaar`);
    },
     // ── Physical Site Visit (independent from Referral above) ──
    getPendingSiteVisitPayments: (params = {}) => {
        return axios.get(`${QTurl}miscPayment/ex/payments/site-visit/pending`, { params });
    },
    saveSiteVisitUploadLog: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/site-visit/save-upload-log`, data);
    },
    getSiteVisitUploadLogs: () => {
        return axios.get(`${QTurl}miscPayment/ex/payments/site-visit/get-upload-logs`);
    },
    syncSiteVisitPayments: (data) => {
        return axios.post(`${QTurl}miscPayment/ex/payments/site-visit/sync`, data);
    },
    getTatInternalTickets: function () {
        return axios.get(`${QTurl}tatInternalTicket/all`);
    },
    createTatInternalTicket: function (data) {
        return axios.post(`${QTurl}tatInternalTicket/new`, data);
    },
    updateTatInternalTicket: function (id, data) {
        return axios.put(`${QTurl}tatInternalTicket/${id}`, data);
    },
    deleteTatInternalTicket: function (id) {
        return axios.delete(`${QTurl}tatInternalTicket/${id}`);
    },
    getEscalationMatrixTechUsers: function () {
        return axios.get(`${QTurl}escalationMatrix/techUsers`);
    },
    getEscalationMatrixList: function () {
        return axios.get(`${QTurl}escalationMatrix/all`);
    },
    createEscalationMatrix: function (data) {
        return axios.post(`${QTurl}escalationMatrix/new`, data);
    },
    updateEscalationMatrix: function (id, data) {
        return axios.put(`${QTurl}escalationMatrix/${id}`, data);
    },
    deleteEscalationMatrix: function (id) {
        return axios.delete(`${QTurl}escalationMatrix/${id}`);
    },
    getGstPaymentBreakdown: (orderId) => {
        return axios.get(`${Apiurl}serviceOrder/gst-payment-breakdown/${orderId}`);
    },
    updateGstPaymentBreakdown: (orderId, data) => {
        return axios.patch(`${Apiurl}serviceOrder/gst-payment-breakdown/${orderId}`, data);
    },
      // Stock Movement dashboard — item-level Opening/Inward/Outward/Closing reconciliation.
    getStockMovementItems: function (search) {
        return axios.get(`${Apiurl}materialMaster/materials/stock-movement-items${search ? `?search=${encodeURIComponent(search)}` : ''}`)
    },
    getStockMovementSummary: function (params = {}) {
        return axios.get(`${Apiurl}materialMaster/materials/stock-movement-summary`, { params })
    },

    // Stock Movement Logs dashboard — raw activity log (date + item, more fields to follow).
    getStockMovementLogs: function (params = {}) {
        return axios.get(`${Apiurl}stock-movement-log/all`, { params })
    },
    downloadStockMovementLogsExcel: function (params = {}) {
        return axios.get(`${Apiurl}stock-movement-log/download-excel`, { params, responseType: 'blob' })
    },
      getStockMovementDetail: function (params = {}) {
        return axios.get(`${Apiurl}stock-movement-log/detail`, { params })
    },
    downloadStockMovementDetailExcel: function (params = {}) {
        return axios.get(`${Apiurl}stock-movement-log/detail/download-excel`, { params, responseType: 'blob' })
    },
    downloadStockMovementTransactionsExcel: function (params = {}) {
        return axios.get(`${Apiurl}stock-movement-log/transactions/download-excel`, { params, responseType: 'blob' })
    },
    getPushToProdList: function (page = 1, limit = 10, search = "") {
        return axios.get(`${QTurl}pushToProd/getPushToProdList?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`)
    },
    setPushToProdBomSkip: function (data) {
        return axios.put(`${QTurl}pushToProd/bomSkip`, data)
    },
    saveSegregatedBomExcel : function (formData){
        return axios.post(`${Apiurl}bomSegregation/save-segregated-excel`,formData);
    },
    getMoqAndOrders: function (params) {
        return axios.get(`${Apiurl}minimum-order-qty/moq-orders`, { params })
    },
    updateMoqShippingTat: function (data) {
        return axios.put(`${Apiurl}minimum-order-qty/moq-orders/shipping-tat`, data)
    },
    getAutomationPoVendors: function (procurementId) {
        return axios.get(`${Apiurl}minimum-order-qty/automation-po/${procurementId}/vendors`)
    },
    saveAutomationPoVendor: function (procurementId, data) {
        return axios.post(`${Apiurl}minimum-order-qty/automation-po/${procurementId}/vendor-decision`, data)
    },
    notifyAutomationPoVendor: function (procurementId) {
        return axios.post(`${Apiurl}minimum-order-qty/automation-po/${procurementId}/notify-vendor`)
    },
    getMyRouteAccess:function (){
        return axios.get(`${Apiurl}route-access/my-routes`);
    },
    getAllRouteAccess:function (params){
        return axios.get(`${Apiurl}route-access`, { params });
    },
    syncRouteAccess:function (paths){
        return axios.post(`${Apiurl}route-access/sync`, { paths });
    },
    removeRouteAccess:function (paths){
        return axios.post(`${Apiurl}route-access/remove`, { paths });
    },
    logDeniedRoute:function (path, url){
        return axios.post(`${Apiurl}route-access/log-denied`, { path, url });
    },
    getDeniedRouteLogs:function (params){
        return axios.get(`${Apiurl}route-access/denied-logs`, { params });
    },
    getRouteAccessByRole:function (roleId){
        return axios.get(`${Apiurl}route-access/by-role/${roleId}`);
    },
    getRouteAccessByUser:function (userId){
        return axios.get(`${Apiurl}route-access/by-user/${userId}`);
    },
    saveRouteAccessForRole:function (roleId, paths){
        return axios.put(`${Apiurl}route-access/by-role/${roleId}`, { paths });
    },
    saveRouteAccessForUser:function (userId, paths){
        return axios.put(`${Apiurl}route-access/by-user/${userId}`, { paths });
    },
    getLeadAccessGrants(leadId) {
        return axios.get(`${QTurl}lead/accessGrant${leadId ? `?leadId=${leadId}` : ''}`);
    },
    createLeadAccessGrant(data) {
        return axios.post(`${QTurl}lead/accessGrant`, data);
    },
    deleteLeadAccessGrant(id) {
        return axios.delete(`${QTurl}lead/accessGrant/${id}`);
    },
    getAllLocations() {
        return axios.get(`${QTurl}location`);
    },
    searchLeadsForAccessGrant(search) {
        return axios.get(`${QTurl}lead/accessGrant/searchLeads?search=${encodeURIComponent(search)}`);
    },
    getLeadAccessLogs({ leadId, userId, status, page, limit } = {}) {
        const params = new URLSearchParams();
        if (leadId) params.set('leadId', leadId);
        if (userId) params.set('userId', userId);
        if (status) params.set('status', status);
        if (page) params.set('page', page);
        if (limit) params.set('limit', limit);
        return axios.get(`${QTurl}lead/accessGrant/logs?${params.toString()}`);
    },
    getApprovedVendorsPaginated: function (params) {
        return axios.get(`${Apiurl}vendor/getApprovedVendorsPaginated?${params}`)
    },
    updateLeadAccessGrant(id, data) {
        return axios.put(`${QTurl}lead/accessGrant/${id}`, data);
    },
    generateHardwareBom: function (data) {
        return axios.post(`${QTurl}project/generateHardwareBom`, data)
    },
    resetSavedBom: function (projectId, data) {
        return axios.put(`${Apiurl}project-material/reset-bom/${projectId}`, data)
    },
    getDiscountApprovalHistory(params) {
        return axios.get(`${QTurl}discountApprovalHistory`, { params });
    },
    getAvailableOptimizationNumbers: function (userId) {
        return axios.get(`${QTurl}project/getAvailableOptimizationNumbers`, { params: { userId } })
    },
    reserveOptimizationNumber: function (data) {
        return axios.post(`${QTurl}project/reserveOptimizationNumber`, data)
    },
    releaseOptimizationNumber: function (data) {
        return axios.post(`${QTurl}project/releaseOptimizationNumber`, data)
    },
    generateInitiationBom: function (projectId) {
        return axios.post(`${Apiurl}project-material/initiation-bom/${projectId}`)
    },

}

export default HttpService;